(function () {
  'use strict';

  angular
    .module('pixerf', [
      'ui.router',
      'ngRoute',
      'ngAnimate',
      'ui.bootstrap',
      'toastr',
      'angular-jwt',
      'ngResource',
      'loadingButton',
      'LocalStorageModule',
      'angular-storage',
      'ngSanitize',
      'hm.readmore',
      'underscore',
      'slick',
      'auth0.auth0',
      'pascalprecht.translate',
      'infinite-scroll',
      'fancyboxplus',
			'ngFileSaver'
    ]);

})();

(function(){

  angular
    .module('pixerf')
    .factory('sessionManagerSvc', sessionManagerSvc);

    sessionManagerSvc.$inject = ['localStorageService', '$rootScope', '$location', 'messageConst'];

    function sessionManagerSvc(localStorageService, $rootScope, $location, messageConst){
    	var CALLBACK_URL = "PIXERF.CALLBACK_URL";
        var TOKEN  = "PIXERF.TOKEN";
        var ID_TOKEN  = "PIXERF.ID_TOKEN";
        var EXPIRED_AT  = "PIXERF.EXPIRED_AT";
        var PROFILE = "PIXERF.PROFILE";
        var USER = "PIXERF.LOGIN_USER";
        var SIGNING_UP_USER = "PIXERF.SIGNING_UP_USER";
        var FIRST_TIME_LOGIN = "PIXERF.FIRST_TIME_LOGIN";
        var RESET_PASSOWRD_REDIRECT = "PIXERF.RESET_PASSOWRD_REDIRECT";
        var MARKETPLACE_HISTORY = "PIXERF.LAST_MARKETPLACE_TAB";

        var mCurrentLoginUser = {data: null};
        function setCurrentLoginUser(user){
            var cloned = null;
            if(user){
                cloned = $.extend(true, {}, user);
            }
            mCurrentLoginUser.data = cloned;
            if(user){
                $rootScope.$broadcast(messageConst.BROADCAST.USER_DATA_CHANGE);
            }
        }
        function getCurrentLoginUser(){
            if(!mCurrentLoginUser.data) return mCurrentLoginUser;
            var cloned = $.extend(true, {}, mCurrentLoginUser);
            return cloned;
        }
        function setToken(token){
            localStorageService.set(TOKEN, token);
        }
        function getToken(){
            return localStorageService.get(TOKEN);
        }
        function setProfile(profile){
            localStorageService.set(PROFILE, profile);
        }
        function getProfile(){
            return localStorageService.get(PROFILE);
        }
        function clearSession(){
            setToken(null);
            setCurrentLoginUser(null);
            setProfile(null);
            setExpiredTime(null);
        }
        function setSession(authResult) {
            // Set the time that the Access Token will expire at
            var expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
            setToken(authResult.idToken);
            setExpiredTime(expiresAt);
            setProfile(authResult.idToken);
        }
        function isTokenExpired(){
            var expiresAt = JSON.parse(getExpiredTime());
			return new Date().getTime() >= expiresAt;
        }
        function setCallbackURL(value){
            localStorageService.set(CALLBACK_URL, value);
        }
        function getCallbackURL(value){
            return localStorageService.get(CALLBACK_URL, value);
        }
        function setExpiredTime(value){
            localStorageService.set(EXPIRED_AT, value);
        }
        function getExpiredTime(value){
            return localStorageService.get(EXPIRED_AT, value);
        }
        function uuid() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			  });
		}
        

		return {
			setCurrentLoginUser: setCurrentLoginUser,
            getCurrentLoginUser: getCurrentLoginUser,
            setProfile: setProfile,
            getProfile: getProfile,
            getToken: getToken,
            setToken: setToken,
            clearSession: clearSession,
            setSession: setSession,
            setCallbackURL: setCallbackURL,
            getCallbackURL: getCallbackURL,
            isTokenExpired: isTokenExpired,
			uuid: uuid
		};
    }
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('messageSvc', messageSvc);
	messageSvc.$inject = ['pixerfConfirmPopupSvc'];

	function messageSvc(pixerfConfirmPopupSvc) {
		var mLanguage = "en";
		var messageFormatter = new MessageFormat(mLanguage);

		function setLanguage(value) {
			mLanguage = value;
			messageFormatter = new MessageFormat(mLanguage);
		}

		function compile(message, data) {
			return messageFormatter.compile(message)(data);
		}

		function warnLeavingWithoutSaving() {
			return pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				message: '<h4 class="text--bold">Hang on!</h4>Your changes have not been saved yet. If you exit now, they will be lost.',
				okBtnText: 'Yes',
				cancelBtnText: 'No'
			});
		}

		return {
			setLanguage: setLanguage,
			compile: compile,
			warnLeavingWithoutSaving: warnLeavingWithoutSaving
		};
	}
})();

/*
 * This class is auth0AuthenticationSvc
 */
(function(){

  angular
    .module('pixerf')
    .factory('auth0AuthenticationSvc', auth0AuthenticationSvc);

    auth0AuthenticationSvc.$inject = ['accountUtils', 'angularAuth0', 'localStorageService', '$q', 'pixerfApiUserSvc', 'sessionManagerSvc', 'authenticationConst', 'jwtHelper', '$location', '$http', 'toastr', '$timeout', '$state'];

    function auth0AuthenticationSvc(accountUtils, angularAuth0, localStorageService, $q, pixerfApiUserSvc, sessionManagerSvc, authenticationConst, jwtHelper, $location, $http, toastr, $timeout, $state){
		handleAuthentication();
		var mSignout = false;
		var CONNECTION = {
			CUSTOM: 'Username-Password-Authentication',
			FACEBOOK: 'facebook'
		};

		var callbackURL  =  window.location.href;
		function getParamterFromURL(url) {
			  // This function is anonymous, is executed immediately and
			  // the return value is assigned to QueryString!
			  var query_string = {};
			  var query = window.location.search.substring(1);
			  var vars = query.split("&");
			  for (var i=0;i<vars.length;i++) {
			    var pair = vars[i].split("=");
			        // If first entry with this name
			    if (typeof query_string[pair[0]] === "undefined") {
			      query_string[pair[0]] = decodeURIComponent(pair[1]);
			        // If second entry with this name
			    } else if (typeof query_string[pair[0]] === "string") {
			      var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
			      query_string[pair[0]] = arr;
			        // If third or later entry with this name
			    } else {
			      query_string[pair[0]].push(decodeURIComponent(pair[1]));
			    }
			  }
			  return query_string;
		}
		function getUserInfoAfterLogin(){
			var def =  $q.defer();
            pixerfApiUserSvc.me(function(pixerfUserInfo){
                if(!pixerfUserInfo.cover_image || pixerfUserInfo.profile_image){
                    var avatarUrl = accountUtils.buildUserAvatarPhotoUrl(pixerfUserInfo, true);
					pixerfUserInfo.avatar = avatarUrl;
                }
				sessionManagerSvc.setCurrentLoginUser(pixerfUserInfo);
				def.resolve(pixerfUserInfo);

    		}, function(error){
				// signout();
    			console.log(error);
    			def.reject(error);
    		});
    		return def;
		}

		function signInByUserNamePassword(user){
			var def =  $q.defer();
            angularAuth0.login({
                username: user.email,
                password: user.password,
				realm: CONNECTION.CUSTOM,
				redirectUri: window.location.href
            }, function(error) {
				console.log('loginned');
                if (error) {
                    def.reject(error);
                }
            });
            return def;

		}
		function handleAuthentication() {
			angularAuth0.parseHash(function (err, authResult) {
				//user is logining in and get redirectd with url parameters
				if (authResult && authResult.accessToken && authResult.idToken) {
					localStorageService.set("signin", true);
					var profile = authResult.idTokenPayload;
					sessionManagerSvc.setSession(authResult);


					getUserInfoAfterLogin({}).promise.then(function(userData){
						var callbackURL = sessionManagerSvc.getCallbackURL();
						if (callbackURL) {
							$location.path(callbackURL);
							sessionManagerSvc.setCallbackURL(null);
						} else {
							if(userData.role === "judge"){
								$state.go("home.submissions");
							} else if(userData.role === "curator_internal" || userData.role === "admin_internal" || userData.role === "admin"){
								$state.go("dashboard");
							} else{
								signout();		
							}
							toastr.success("Hi, " +  userData.displayName);
						}
					}, function(){
						signout();
					})
				}else if (err) {
					$location.path('/');
					console.log(err);
				} else{
					authenticationCheck().then(function(result){
					}, function(result){
						handleAuthenticationCheck(result)
					});
				}
			})
		}
		function signout(){
			angularAuth0.logout();
			localStorageService.set("signout", true);
			sessionManagerSvc.clearSession();
			mSignout = true;
			window.location.href = "/";
		}
		function getProfile(cb) {
			var def = $q.defer();
			var accessToken = sessionManagerSvc.getToken();
			if (!accessToken) {
				def.reject('Access Token must exist to fetch profile')
			}
			if (!jwtHelper.isTokenExpired(accessToken)) {
				angularAuth0.client.userInfo(accessToken, function(err, profile) {
					if (profile) {
						def.resolve(profile);
					}
					if(err){
						def.reject(profile);
					}
				});
			} else {
				def.reject("Access Token expired");
			}
			return def.promise;
		  }
		function authenticationCheck (){
            var def = $q.defer();
			var param =  getParamterFromURL(window.location.href);
			if(typeof param.success !== "undefined"){
				def.reject();
				signout();
				return def.promise;
			}

			var token = sessionManagerSvc.getToken();
			if (token) {
				if (!jwtHelper.isTokenExpired(token)) {
					if(sessionManagerSvc.getCurrentLoginUser().data){
						def.resolve(sessionManagerSvc.getCurrentLoginUser().data);
					} else{
						var profile = sessionManagerSvc.getProfile();
						getUserInfoAfterLogin({}).promise.then(function(userData){
							def.resolve(userData);
						}, function(){
							def.reject(authenticationConst.AUTHENTICATION_STATE.FAILED_RETREIVE_ACCOUNT_INTO);
						});
					}
				} else {
					def.reject(authenticationConst.AUTHENTICATION_STATE.TOKEN_EXPIRED);
				}
			} else{
				def.reject(authenticationConst.AUTHENTICATION_STATE.NOT_LOGIN);
			}
            return def.promise;
        }
        function authenticationErrHandler(errMsg){
            toastr.error(errMsg);
            sessionManagerSvc.clearSession();
            $timeout(function(){
                $location.path('/');

            }, 3000);
        }
        function handleAuthenticationCheck(result){

            if(result === authenticationConst.AUTHENTICATION_STATE.TOKEN_EXPIRED){
                authenticationErrHandler("Session timeout!");
                signout();
            } else if(result === authenticationConst.AUTHENTICATION_STATE.FAILED_RE_AUTHENTICATE){
                authenticationErrHandler("Failed to re-authenticate!");
                signout();
            } else if(result === authenticationConst.AUTHENTICATION_STATE.FAILED_RETREIVE_ACCOUNT_INTO){
                authenticationErrHandler("Failed to retrieve user information!");
                signout();
            } else if (result === authenticationConst.AUTHENTICATION_STATE.FAILED_SIGNUP){
                signout();
            }
        }

		return {
			signInByUserNamePassword: signInByUserNamePassword,
			getParamterFromURL : getParamterFromURL,
			signout: signout,
			getUserInfoAfterLogin: getUserInfoAfterLogin,
			authenticationCheck: authenticationCheck,
			handleAuthenticationCheck: handleAuthenticationCheck
		}
    }
})();


(function() {
    'use strict';
    angular
        .module('pixerf')
        .constant('messageConst', {
           "error" : {
                "SOME_THING_WRONG": "Oops! Looks like something went wrong. Please try again!",
                "VOTES_EXCEEDED": "You can only vote for a maximum of three photos!"
           },
           "success": {
                "RSVP": "Thanks for your RSVP!",
                "SUBMISSION": "Thanks for your submission!",
           },
           "info": {
                "SUBMISSION_CLOSED": "Submissions are now closed!"
           },
           "BROADCAST": {
                "USER_DATA_CHANGE": "USER_DATA_CHANGE",
                "UPDATED_CART": "UPDATED_CART"
            }

        });
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('systemUtils', systemUtils);

    systemUtils.$inject = ['$timeout'];

    function systemUtils($timeout) {
        function apply(scope){
            $timeout(function(){
                scope.$apply();
            })
        }
        function isMobile(){
            return window.innerWidth < 667;
        }
        function scrollTo(options){
            var body = $("html, body");
            body.stop().animate({ scrollTop: 0 }, '500', 'swing');
        }
    //------------------------------------------------------------------------------------------------------------------
        return {
            apply: apply,
            isMobile: isMobile,
            scrollTo: scrollTo
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('responsiveUtils', responsiveUtils);

    responsiveUtils.$inject = ['$timeout'];

    function responsiveUtils($timeout) {
        
        function isPortrait(){
            var $window = $(window);
            return $window.height() > $window.width();
        }
        function isIphoneOrAndroid(){
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/android/i.test(userAgent)) {
                return "Android";
            }
        
            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }
        }
    //------------------------------------------------------------------------------------------------------------------
        return {
           isPortrait: isPortrait,
           isIphoneOrAndroid: isIphoneOrAndroid
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('pathUtils', pathUtils);

    pathUtils.$inject = ['fileConst', 'pixerfUrl'];

    function pathUtils(fileConst, pixerfUrl) {
        function getWebrootUrl(){
            return window.location.protocol + "//" + window.location.host;
        }
        function getFallbackFileUrl(){
            return getWebrootUrl()  + "/assets/images/icon-market.png";
        }
        function buildFilePath(fileId, size, type){
            if(!fileId){
                return getFallbackFileUrl();
            }
            return type ? pixerfUrl.full + 'thumbnail/' + type + '/' +  fileId + '/' +  size  : pixerfUrl.full + 'thumbnail/' +  fileId + '/' +  size;
        }
        return {
            getWebrootUrl: getWebrootUrl,
            buildFilePath: buildFilePath,
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('pagingUtils', pagingUtils);

    pagingUtils.$inject = [];

    function pagingUtils() {
        function isNoMorePageToLoad(currentPage, response){
            var totalPage = getTotalPage(response);
            if(typeof currentPage !== "number") currentPage = parseInt(currentPage);
            // var totalPage = 3;
            if(totalPage <= 1) return true;
            return currentPage >= totalPage;
        }
        function scrollToTop(){
            var $target = $("html, body");
            $target.stop().animate({ scrollTop: 0 }, '500', 'swing');

        }
        function getTotalPage(response){
            var pageNum = response.headers("total-pages");
            if(!pageNum) pageNum = response.headers("Total-Pages");
            if(!pageNum) return 0;
            return parseInt(pageNum);
        }
        function getTotalCount(response){
            var totalCount = response.headers("total");
            if(!totalCount) totalCount = response.headers("Total");
            if(!totalCount) return 0;
            return parseInt(totalCount);
        }
    //------------------------------------------------------------------------------------------------------------------
        return {
           isNoMorePageToLoad: isNoMorePageToLoad,
           scrollToTop: scrollToTop,
           getTotalPage: getTotalPage,
           getTotalCount: getTotalCount
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('numberUtils', numberUtils);

    numberUtils.$inject = [];

    function numberUtils() {
        function fraction2Decimal(value){
            try{
                return eval(value);
            }catch(ex){
                return null;
            }
        }
        function parseInt(str){
            try{
                return window.parseInt(str);
            }catch(ex){
                return null;
            }
        }
        function formatNumber(number, separtor, numCharacter){
            separtor = separtor ? separtor : ",";
            numCharacter = numCharacter ? numCharacter : 3;
            if(!number) return "0";
            var re = new RegExp('\\B(?=(\\d{' + numCharacter +  '})+(?!\\d))', 'g');
            return number.toString().replace(re, separtor);
        }
        function getRandomInRange(start, end){
            return Math.floor(Math.random() * end) + start;
        }
        function formatNumberByK(number){
            var thousand = 1000;
            if(number < thousand) return number;
            var mod = number % thousand;
            if(mod === 0){
                return (number/thousand) + "K";
            }
            if(mod < thousand*0.1){
                return (number/thousand).toFixed(0) + 'K';
            }
            return (number/thousand).toFixed(1) + 'K';
        }
    //------------------------------------------------------------------------------------------------------------------
        return {
           fraction2Decimal: fraction2Decimal,
           parseInt: parseInt,
           formatNumber: formatNumber,
           getRandomInRange: getRandomInRange,
           formatNumberByK: formatNumberByK
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('fileUtils', fileUtils);

    fileUtils.$inject = ['fileConst', 'pathUtils', 'sessionManagerSvc'];

    function fileUtils(fileConst, pathUtils, sessionManagerSvc) {
        function findFileById(files, id){
            if(typeof id !=="number") id = parseInt(id);
            return _.find(files, function(p){
                return p.id === id;
            });

        }
        function transform(photo, freshImage){
            // var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            var fingerPrint = freshImage ? ("?" + new Date().getTime()) : '';
            // photo.badges = badgeUtils.transformBadges(photo.badges);
            photo.url =  pathUtils.buildFilePath(photo.id, "1024x", 's') + fingerPrint;
            photo.urlSmall = pathUtils.buildFilePath(photo.id, "x400", 's') + fingerPrint;
            // photo.thumbnailBig = pathUtils.buildFilePath(photo.id, "x300") + fingerPrint;
            // photo.thumbnail = pathUtils.buildFilePath(photo.id, "160x") + fingerPrint;
            // photo.path = window.location.protocol + "//" + window.location.host + "/#/photo/" + photo.id; 
            // photo.isMine = (mLoginnedUser && photo.user) ? mLoginnedUser.id === photo.user.id : false;
            // photo.price = photo.price == -1 ? null : photo.price;
            // if(photo.user) accountUtils.transformUserData(photo.user);
            // if(!photo.galleries && photo.gallery_ids || (photo.galleries && photo.gallery_ids && photo.gallery_ids.length !== photo.galleries.length)){
            //     photo.galleries = galleryUtils.buildGalleriesFromIds(photo.gallery_ids);
            // }
        }
        function transforms(photos){
            for (var i =0; i < photos.length; i ++){
                transform(photos[i]);
            }
            return photos;          
        } 

    //------------------------------------------------------------------------------------------------------------------
        return {
           findFileById: findFileById,
           transforms: transforms,
           transform: transform
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('arrayUtils', arrayUtils);

    arrayUtils.$inject = [];

    function arrayUtils() {
        function shuffle(array) {
            var currentIndex = array.length, temporaryValue, randomIndex;

            // While there remain elements to shuffle...
            while (0 !== currentIndex) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }

            return array;
        }
        function indexOf(array, iterator){
            for(var i = 0; i < array.length; i ++){
                if(iterator(array[i])) return i;
            }
            return -1;
        }
        function swapElement(array, one, two){
            var indexOne = _.indexOf(array, one);
            var indexTwo = _.indexOf(array, two);
            if(indexOne !== -1 && indexTwo !== -1) {
                var temp = array[indexOne];
                array[indexOne] = array[indexTwo];
                array[indexTwo] = temp;
            }
        }
        function isEqual(one, two, propertyOne, propertyTwo){
            if((!one && two) || (one && !two)) return false;
            if(one.length !== two.length) return false;
            for (var i = 0; i < one.length; i++){
                var found = _.find(two, function(gl){
                    var oneValue = one[i].hasOwnProperty(propertyOne) ? one[i][propertyOne] : one[i];
                    var twoValue = gl.hasOwnProperty(propertyTwo) ? gl[propertyTwo] : gl;
                    
                    return oneValue === twoValue;

                })
                if(!found) return false;
            }
            return true;
        }
        function getIntersection(arrays, comparedProperty) {
            var i, all, shortest, nShortest, n, len, ret = [], obj={}, nOthers;
            nOthers = arrays.length-1;
            nShortest = arrays[0].length;
            shortest = 0;
            for (i=0; i<=nOthers; i++){
              n = arrays[i].length;
              if (n<nShortest) {
                shortest = i;
                nShortest = n;
              }
            }
          
            for (i=0; i<=nOthers; i++) {
              n = (i===shortest)?0:(i||shortest); //Read the shortest array first. Read the first array instead of the shortest
              len = arrays[n].length;
              for (var j=0; j<len; j++) {
                  var elem = arrays[n][j][comparedProperty];
                  if(obj[elem] === i-1) {
                    if(i === nOthers) {
                      ret.push(arrays[n][j]);
                      obj[elem]=0;
                    } else {
                      obj[elem]=i;
                    }
                  }else if (i===0) {
                    obj[elem]=0;
                  }
              }
            }
            return ret;
        }  
    //------------------------------------------------------------------------------------------------------------------
        return {
           shuffle: shuffle,
           indexOf: indexOf,
           swapElement: swapElement,
           isEqual: isEqual,
           getIntersection: getIntersection
        };
    }
})();
(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('uploadPhotoDetailSvc', uploadPhotoDetailSvc);

	uploadPhotoDetailSvc.$inject = ['addToGallerySvc', 'pixerfApiKeywordSvc', '$q', 'accountUtils', 'sessionManagerSvc', '$translate'];

	function uploadPhotoDetailSvc(addToGallerySvc, pixerfApiKeywordSvc, $q, accountUtils, sessionManagerSvc, $translate) {

		function isMultipleValue(files, property) {
			var firstFile = files[0];
			return !_.every(files, function (f) {
				return _.isEqual(firstFile[property], f[property]);
			})
		}

		function buildKeywords(keywords, max) {
			var firstNine = [];
			for (var i = 0; i < keywords.length; i++) {
				if (firstNine.length === max) return firstNine;
				var keyword = keywords[i];
				if (!_.contains(firstNine, keyword) && validateKeyword(keyword)) {
					firstNine.push(keyword);
				}
			}
			return firstNine;
		}

		function validateKeyword(keyword) {
			return keyword.length > 2;

		}

		function buildCallToActionMessages(file) {
			var messages = [];
			if (!file) return messages;
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (!loginUser) return messages;
			if (!loginUser.canCurate && !file.isMine) return messages;
			if (!file.price) {
				messages.push("- Please set a price before this photo can be featured in the Marketplace.");
			}

			if (!file.releases) file.releases = [];
			if (file.license === 'commercial' && file.has_model_property && file.releases.length === 0) {
				messages.push('<div>- Please upload photo release form(s) </div><get-release-form-btn class="pixerf-link--color-blue text--bold" text="You can download the forms here."></get-release-form-btn>');
			}
			return messages;
		}

		function loadTags(query) {
			var deferred = $q.defer();
			pixerfApiKeywordSvc.query({
				'word': query
			}, function (response) {
				var firstNine = buildKeywords(response, 10);
				deferred.resolve(firstNine);
			}, function (error) {
				deferred.reject(error);
			});
			return deferred.promise;
		}

		function validate(files) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				var photoName = "Photo " + (file.title ? file.title : file.name);
				if ((file.license === "commercial" && file.has_model_property == null) || !file.license) {
					return $translate.instant("photo-apply-commercial-license", {
						name: photoName
					});
				}
				if (!file.title) {
					return photoName + ": Please input the title of this photo!";
				}
				if (!file.categories || !file.categories.length) {
					return $translate.instant("photo-select-category", {
						name: photoName
					});
				}
				if (!file.price || (file.price && !file.price.id)) {
					return photoName + ": Please select the price of this photo!";
				}
				var valid = !(accountUtils.isContainsLink(file.description));
				if (!valid) return "Sorry, " + photoName + ": description cannot contain link or email.";
				valid = !accountUtils.isContainsFileExtension(file.title);
				if (!valid) return "Sorry, " + "Photo title cannot contain extension.";
			}
		}

		function isPriceSet(files) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				if (!file.price) return false;
			}
			return true;
		}

		function synchonizeSuggestedKeywords(action, $tag, files) {

			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				if (!file.suggestedKeywords) file.suggestedKeywords = [];
				var isInSuggestedKeyword = _.find(file.originalSuggestedKeywords, function (t) {
					return t === $tag.text;
				});
				if (action === "add") {
					if (isInSuggestedKeyword) {
						file.suggestedKeywords = _.reject(file.suggestedKeywords, function (t) {
							return $tag.text && t === $tag.text;
						});
					}
				} else if (action === "remove") {
					var isExisted = _.find(file.suggestedKeywords, function (t) {
						return t === $tag.text;
					});

					if (!isExisted && isInSuggestedKeyword) file.suggestedKeywords.push($tag.text);
				}
			}
		}

		function synchonizeKeywords(action, $tag, files) {

			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				if (!file.tags) file.tags = [];
				var isExisted = _.find(file.tags, function (t) {
					return t.text === $tag.text;
				});
				if (action === "add") {
					if (!isExisted) {
						file.tags.push($tag);
					}
				} else if (action === "remove") {
					file.tags = _.reject(file.tags, function (t) {
						return t.text === $tag.text;
					});
				}
			}
		}

		function synchonizedFilesInfo(files, property, value) {
			for (var i = 0; i < files.length; i++) {
				if (typeof value === 'object') {
					if (Array.isArray(value)) {
						files[i][property] = $.extend(true, [], value);
					} else {
						files[i][property] = $.extend(true, {}, value);
					}
				} else {
					files[i][property] = value;
				}
			}
		}

		function synchonizePrice(files, price) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				var isExisted = _.find(file.price_ranges, function (p) {
					return p.id === price.id;
				})
				if (isExisted) {
					file.price = isExisted;
				}
			}
		}

		function updateMasterFile(masterFile, property, value) {
			masterFile.data[property] = value;
		}

		function buildMasterFileKeywords(files) {
			var arrays = [];
			for (var i = 0; i < files.length; i++) {
				arrays.push(files[i].tags);
			}
			var buff = [];
			var i, all, shortest, nShortest, n, len, ret = [],
				obj = {},
				nOthers, isExisted;
			nOthers = arrays.length - 1;
			nShortest = arrays[0].length;
			shortest = 0;
			for (i = 0; i <= nOthers; i++) {
				n = arrays[i].length;
				if (n < nShortest) {
					shortest = i;
					nShortest = n;
				}
			}
			for (i = 0; i <= nOthers; i++) {
				n = (i === shortest) ? 0 : (i || shortest);
				len = arrays[n].length;
				for (var j = 0; j < len; j++) {
					var tag = arrays[n][j];
					tag.isSameKeyword = false;
					isExisted = _.find(buff, function (t) {
						return t.text === tag.text;
					})
					if (!isExisted) {
						buff.push(tag);
					}
					var elem = tag['text'];
					if (obj[elem] === i - 1) {
						if (i === nOthers) {
							ret.push(tag);
							isExisted = _.find(buff, function (t) {
								return t.text === tag.text;
							})
							if (isExisted) {
								isExisted.isSameKeyword = true;
							}
							obj[elem] = 0;
						} else {
							obj[elem] = i;
						}
					} else if (i === 0) {
						obj[elem] = 0;
					}
				}
			}
			return buff;
		}

		function resetKeyworkd(tags) {
			for (var i = 0; i < tags.length; i++) {
				tags[i].isSameKeyword = false;
			}
			return tags;
		}

		function buildMasterFileReleases(files) {
			var arr = _.reduce(files, function (memo, item) {
				if (item.releases && item.releases.length > 0) {
					memo = memo.concat(item.releases);
				}
				return memo;
			}, []);
			return _.uniq(arr, function (item) {
				return item.id;
			});
		}

		function buildMasterFileGalleries(files) {
			var arr = _.reduce(files, function (memo, item) {
				if (item.galleries && item.galleries.length > 0) {
					memo = memo.concat(item.galleries);
				}
				return memo;
			}, []);
			return _.uniq(arr, function (item) {
				return item.id;
			});
		}

		function buildPriceRanges(files) {
			var maxPriceRanges = files[0].price_ranges;
			for (var i = 1; i < files.length; i++) {
				var file = files[i];
				if (file.price_ranges[file.price_ranges.length - 1].value > maxPriceRanges[maxPriceRanges.length - 1].value) {
					maxPriceRanges = file.price_ranges;
				}
			}
			return maxPriceRanges;
		}

		function buildMasterFile(masterFile, files, synchronizable, categories) {

			var firstFile = files[0];
			if (!synchronizable) {
				masterFile.data = firstFile;
			} else {

				masterFile.data = {
					name: '',
					title: '',
					license: '',
					categories: [],
					description: '',
					location: '',
					galleries: [],
					tags: [],
					suggestedKeywords: [],
					originalSuggestedKeywords: [],
					price: null,
					releases: [],
					has_model_property: false,
					price_ranges: [],
					user: null
				};
			}
			if (!firstFile) {
				masterFile.data = null;
				return;
			}
			masterFile.data.name = firstFile.name;
			for (var property in masterFile.data) {
				if (property === "user") {
					masterFile.data.user = firstFile.user;
				} else if (property === "categories") {
					if (files.length > 1 && isMultipleValue(files, property)) {
						var multiple = {
							id: -1,
							name: 'Multiple categories'
						};
						if (categories.data[0].id !== -1) {
							categories.data.unshift(multiple);
						}
						masterFile.data.categories = [multiple];
					} else {
						masterFile.data.categories = firstFile.categories || [];
						if (categories.data[0].id === -1) {
							categories.data.shift(multiple);
						}
					}

				} else if (property === "tags") {
					firstFile.tags = firstFile.tags || [];
					masterFile.data.tags = files.length > 1 ? buildMasterFileKeywords(files) : resetKeyworkd(firstFile.tags);
				} else if (property === "releases") {
					if (!firstFile.releases) firstFile.releases = [];
					masterFile.data.releases = files.length > 1 && isMultipleValue(files, property) ? buildMasterFileReleases(files) : firstFile.releases;
				} else if (property === "suggestedKeywords") {
					masterFile.data.suggestedKeywords = files.length > 1 ? [] : (firstFile.suggestedKeywords || []);
				} else if (property === "originalSuggestedKeywords") {
					masterFile.data.originalSuggestedKeywords = files.length > 1 ? [] : (firstFile.originalSuggestedKeywords || []);
				} else if (property === "galleries") {
					masterFile.data.galleries = files.length > 1 && isMultipleValue(files, property) ? buildMasterFileGalleries(files) : firstFile.galleries;
					masterFile.data.galleriesName = addToGallerySvc.buildGalleriesNames(masterFile.data.galleries);
				} else if (property === "price_ranges") {
					masterFile.data.price_ranges = files.length > 1 ? buildPriceRanges(files) : firstFile.price_ranges;
				} else {
					if (Array.isArray(masterFile.data[property])) {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property];
					} else if (typeof masterFile.data[property] === "object") {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property] ? firstFile[property] : undefined;
					} else {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property];
					}
				}
			}
		}
		return {
			synchonizedFilesInfo: synchonizedFilesInfo,
			loadTags: loadTags,
			synchonizeSuggestedKeywords: synchonizeSuggestedKeywords,
			validate: validate,
			isPriceSet: isPriceSet,
			buildMasterFile: buildMasterFile,
			updateMasterFile: updateMasterFile,
			buildCallToActionMessages: buildCallToActionMessages,
			synchonizeKeywords: synchonizeKeywords,
			synchonizePrice: synchonizePrice
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('uploadPhotoDetailCtrl', uploadPhotoDetailCtrl);

    uploadPhotoDetailCtrl.$inject = ['photoSvc', 'sessionManagerSvc', 'sendReleaseFormEmailPopupSvc', 'categoryUtils','$scope', 'uploadPhotoDetailSvc', '$q', 'toastr', '$timeout', 'pagingUtils', 'galleryUtils', 'addToGallerySvc', 'pixerfApiMediaSvc', 'pixerfMessagePopupSvc', 'fileUtils'];

    function uploadPhotoDetailCtrl(photoSvc, sessionManagerSvc, sendReleaseFormEmailPopupSvc, categoryUtils, scope, uploadPhotoDetailSvc, $q, toastr, $timeout, pagingUtils, galleryUtils, addToGallerySvc, pixerfApiMediaSvc, pixerfMessagePopupSvc, fileUtils) {

        var self = this;
        self.onGallerySelected = onGallerySelected;
        self.synchonizedFilesInfo = synchonizedFilesInfo;
        self.synchonizePrice = synchonizePrice;
        self.loadTags = loadTags;
        self.addTag = addTag;
        self.onTagRemoved = onTagRemoved;
        self.onInvalidTag = onInvalidTag;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.onTagAdded = onTagAdded;
        self.masterFile = {data: null};
        self.onRequiredReleaseRadioBtnClicked = onRequiredReleaseRadioBtnClicked;
        self.onPhotoUsageItemClicked = onPhotoUsageItemClicked;
        self.onQuestionAnswered = onQuestionAnswered;
        self.getTagClass = getTagClass;
        self.callToActionMesages = [];
        self.categoryDropdownSettings = {
            displayProp: 'name',
            idProp: 'id',
            smartButtonMaxItems: 3,
            selectionLimit: 3,
            showCheckAll : false,
            showUncheckAll: false,
            scrollable: true,
            scrollableHeight: "275px",
            buttonClasses: 'multiple-dropdown-selection__btn-dropdown text--truncate text-left',
            events: {
                onSelectionChanged: function(){
                    var files = scope.files;
                    if(scope.categories.data[0] && scope.categories.data[0].id === -1){
                        self.masterFile.data.categories.shift();
                        scope.categories.data.shift();
                    }
                    synchonizedFilesInfo(files, "categories", self.masterFile.data.categories);
                },
                onMaxSelectionReached: function(){
                    toastr.error("Please select up to a maximum of three categories only.");
                }
            }
        };
        function synchonizedFilesInfo(){
            if(scope.synchronizable){
                uploadPhotoDetailSvc.synchonizedFilesInfo.apply(uploadPhotoDetailSvc, arguments);
            } else {//editphoto mode
                self.callToActionMesages = uploadPhotoDetailSvc.buildCallToActionMessages(self.masterFile.data);
            }
            scope.formError = uploadPhotoDetailSvc.validate(scope.files);
        }
        scope.$watchCollection("files",function(newFiles, oldValue){
            uploadPhotoDetailSvc.buildMasterFile(self.masterFile, newFiles, scope.synchronizable, scope.categories);
            self.callToActionMesages = uploadPhotoDetailSvc.buildCallToActionMessages(self.masterFile.data);
        });
        function getTagClass($tag){
            return $tag.isSameKeyword ? 'tag-item--bolder' : '';
        }
        function onTagAdded($tag){
            var files = scope.files;
            $tag.isSameKeyword = files.length > 1;
            $timeout(function(){
                var isInSuggestedKeyword = _.find(self.masterFile.data.originalSuggestedKeywords, function(t){
                    return t === $tag.text;
                });
                if(isInSuggestedKeyword){
                    self.masterFile.data.suggestedKeywords = _.reject(self.masterFile.data.suggestedKeywords, function(t){
                        return t === $tag.text;
                    });
                }
                if(scope.synchronizable){
                    uploadPhotoDetailSvc.synchonizeKeywords("add", $tag, files);
                    uploadPhotoDetailSvc.synchonizeSuggestedKeywords("add", $tag, files);
                }
            }, 300);
        }
        function onInvalidTag($tag, tiScope){
            var files = scope.files;
            var isExisted = _.find(self.masterFile.data.tags, function(t){
                return t.text === $tag.text;
            });
            if(isExisted && !isExisted.isSameKeyword && files.length > 1){
                isExisted.isSameKeyword = true;
                tiScope.newTag.text('');
            }
            if(scope.synchronizable){
                uploadPhotoDetailSvc.synchonizeKeywords("add", $tag, files);
                uploadPhotoDetailSvc.synchonizeSuggestedKeywords("add", $tag, files);
            }
        }
        function onTagRemoved($tag){
            var files = scope.files;
            var isExisted = _.find(self.masterFile.data.suggestedKeywords, function(t){
                return t === $tag.text;
            });
            var isInSuggestedKeyword = _.find(self.masterFile.data.originalSuggestedKeywords, function(t){
                return t === $tag.text;
            });
            if(!isExisted && isInSuggestedKeyword) self.masterFile.data.suggestedKeywords.push($tag.text);
            if(scope.synchronizable){
                uploadPhotoDetailSvc.synchonizeKeywords("remove", $tag, files);
                uploadPhotoDetailSvc.synchonizeSuggestedKeywords("remove", $tag, files);
            }
        }
        function addTag(tags, tagText){
            var files = scope.files;
            if(!tags) tags = [];
            var isExisted = _.find(tags, function(t){
                return t.text === tagText;
            })
            if(!isExisted) {
                tags.push({text: tagText});
                onTagAdded({text: tagText});
            }

        }
        function loadTags(query){
            var files = scope.files;
            var deferred = $q.defer();
            uploadPhotoDetailSvc.loadTags(query).then(function(tags){
                deferred.resolve(tags);
                // self.masterFile.data.suggestedKeywords = tags;
            }, function(error){
                deferred.reject(error);
                toastr.error("Failed to get tags.");
            })
            return deferred.promise;
        }
        function onGallerySelected(gallery){
            photoSvc.updateFileGalleriesInfo(self.masterFile.data, gallery);
            self.masterFile.data.galleriesName = addToGallerySvc.buildGalleriesNames(self.masterFile.data.galleries);
        }
        function showSendReleaseFormPopup(){
            sendReleaseFormEmailPopupSvc.showPopup();
        }
        function onPhotoUsageItemClicked(usage){
            self.masterFile.data.license = usage;
            self.masterFile.data.has_model_property = null;
            self.masterFile.data.releases = [];
        }
        function onRequiredReleaseRadioBtnClicked(){
            self.synchonizedFilesInfo(scope.files, 'has_model_property', self.masterFile.data.has_model_property)
            if(self.masterFile.data.has_model_property){
                showSendReleaseFormPopup();
            } else {
                self.masterFile.data.releases = [];
            }

        }
        function synchonizePrice(){
            uploadPhotoDetailSvc.synchonizePrice.apply(null,arguments);
        }
        function onQuestionAnswered(question){
            if(question === 'COMMERCIAL?'){
                self.onPhotoUsageItemClicked('commercial');
                self.synchonizedFilesInfo(scope.files, 'license', 'commercial');
            } else if(question === 'NO_NEED_RELEASE?' || question==='NEED_RELEASE_FORM?'){
                self.onRequiredReleaseRadioBtnClicked();
            }
            else if(question === 'NOT_COMMERCIAL?') {
                self.onPhotoUsageItemClicked('editorial');
                self.synchonizedFilesInfo(scope.files, 'license', 'editorial')
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('uploadPhotoDetail', uploadPhotoDetail);

  function uploadPhotoDetail() {

    var directive = {
      scope: {
          files: "=",
          categories : '=',
          synchronizable: '=',
          formError: "=",
          isFormDirty: "=",
          alert: "=",
          isLoadingClarifai: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/upload-photo-detail/upload-photo-detail.html',
      controller: 'uploadPhotoDetailCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('tilePhotoCtrl', tilePhotoCtrl);

  tilePhotoCtrl.$inject = ['$scope', 'sessionManagerSvc'];

  function tilePhotoCtrl(scope, sessionManagerSvc) {
    var self = this;
    self.imageUrl = scope.file.thumbnails['x400'];
    self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
    self.clickOutSide = clickOutSide;

    function clickOutSide($event) {
      $("body").trigger("click");
      $event.stopPropagation();
    }

  }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('tilePhoto', tilePhoto);

	function tilePhoto() {

		var directive = {
			scope: {
				displaySize: "@",
				file: "=",
				mission: "=",
				gallery: "=",
				onFileRemoved: "&",
				onAddedOrRemovedFromGallery: "&",
				context: '=',
				onPhotoClicked: '&?',
				onPhotoClickedCallback: '&?',
				simpleSelectMode: '=',
				overlayMode: '=',
				onPhotoPopupSaved: '&',
				onPhotoPopupClosed: '&',
				options: '=',
				onRemoveBtnClick: '&?',
				showLicense: '=',
				hideCaption: '='
			},
			restrict: 'E',
			templateUrl: 'app/components/tile-photo/tile-photo.html',
			controller: 'tilePhotoCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('spinnerWin', spinnerWin);
    spinnerWin.$inject = [];
    function spinnerWin() {
        return {
            restrict: 'E',
            scope: {
                "spinner": "=",
                "isOverlayMode": "="
            },
            templateUrl: "app/components/spinner-win/spinner-win.html",
            replace: true
        };
    }
})();                                                                  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('slickSlider', slickSlider);

	slickSlider.$inject = ['$timeout'];
	function slickSlider($timeout) {
		var directive = {
			scope: {
				init: '&',
				beforeChange: '&',
				afterChange: '&'
			},
			restrict: 'A',
			link: function (scope, element, attrs) {
				var self = this;
				$timeout(function () {
					$(element).slick(scope.$eval(attrs.slickSlider));
				});
				$(element).on('wheel', (function (e) {
					e.preventDefault();
					if (e.originalEvent.deltaY < 0) {
						$(element).slick('slickPrev');
					} else {
						$(element).slick('slickNext');
					}
				}));
				$(element).on('init', function (event, slick) {
					self.slick = slick;
					if (attrs.init) {
						scope.init({
							event: event,
							slick: slick
						});
					}
				});
				$(element).on('beforeChange', function (event, slick, currentSlideIndex, nextSlideIndex) {
					if (attrs.beforeChange) {
						scope.beforeChange({
							event: event,
							slick: slick,
							currentSlide: currentSlideIndex,
							nextSlide: nextSlideIndex
						});
					}
				});
				$(element).on('afterChange', function (event, slick, currentSlide, nextSlide) {
					if (attrs.afterChange) {
						scope.afterChange({
							event: event,
							slick: slick,
							currentSlide: currentSlide,
							nextSlide: nextSlide
						});
					}
				});
			}
		};
		return directive;
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('scrollToTop', scrollToTop);

    scrollToTop.$inject = [];

    function scrollToTop($timeout) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/scroll-to-top/scroll-to-top.html',
            scope: {
            },
            link: function (scope, element) {

                function init() {
                    var $element = $(element);
                    var $body = $("html, body");
                    $element.click(function () {
                        $body.stop().animate({ scrollTop: 0 }, '500', 'swing');
                    })
                    window.addEventListener('scroll', function () {
                        if (window.pageYOffset > 1 * $(window).innerHeight()) {
                            element.addClass('show-scroll-to-top');
                        } else {
                            element.removeClass('show-scroll-to-top');
                        }
                    })
                }
                init();
            }
        };


    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('scrollPagingCtrl', scrollPagingCtrl);

    scrollPagingCtrl.$inject = ['pagingUtils'];

    function scrollPagingCtrl(pagingUtils) {

        var self = this;
        self.scrollToTop = pagingUtils.scrollToTop;
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('scrollPaging', scrollPaging);
    scrollPaging.$inject = [];
    function scrollPaging() {
        return {
            restrict: 'E',
            scope: {
                "message": '@',
                'spinner': '=',
                'isLastPage': '=',
                'showMessage': '=',
                'hideBackToTop': '='
            },
            templateUrl: "app/components/scroll-paging/scroll-paging.html",
            replace: true,
            controller: 'scrollPagingCtrl',
            controllerAs: 'vm'
        };
    }
})();                                                                  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('portfolioTileCtrl', portfolioTileCtrl);

	portfolioTileCtrl.$inject = ['$scope'];

	function portfolioTileCtrl($scope) {

		var self = this;
		self.imgCoverLayout = 0;
		if($scope.portfolio && $scope.portfolio.thumbnailPath){
			self.imgCoverLayout = $scope.portfolio.thumbnailPath.length > 2 ? 3 : $scope.portfolio.thumbnailPath.length;
		}

		self.onPhotoClicked = function(photo){
			$scope.onPortfolioClicked({'portfolio': photo});
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('portfolioTile', portfolioTile);

	function portfolioTile() {

		var directive = {
			scope: {
				speciality: "@",
				portfolio: "=",
				onPortfolioClicked: "&",
				isSmallSize: "@?"
			},
			templateUrl: 'app/components/portfolio-tile/portfolio-tile.html',
			restrict: 'E',
			controller: 'portfolioTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('portfolioPhotoSvc', portfolioPhotoSvc);

	portfolioPhotoSvc.$inject = ['pixerfApiMediaSvc', '$q'];

	function portfolioPhotoSvc(pixerfApiMediaSvc, $q) {
		function updateFileGalleriesInfo(file, portfolioGallery) {
			if (!file.galleries) {
				file.galleries = [];
			}
			if (portfolioGallery.isSelected) {
				file.galleries.push(portfolioGallery);
			} else {
				file.galleries = _.reject(file.galleries, function (gal) {
					return gal.id === portfolioGallery.id;
				})
			}
		}

		function removePhotoFromPortfolioGallery(file, portfolioGallery) {
			var def = $q.defer();
			pixerfApiMediaSvc.remove_from_gallery({
				id: file.id,
				gallery_id: portfolioGallery.id
			}, {}).$promise.then(function () {
				def.resolve();
				updateFileGalleriesInfo(file, portfolioGallery);
			}, function () {
				// portfolioGallery.isSelected = !portfolioGallery.isSelected;
				def.reject();
			});
			return def.promise;
		}
		return {
			removePhotoFromPortfolioGallery: removePhotoFromPortfolioGallery,
			updateFileGalleriesInfo: updateFileGalleriesInfo
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('portfolioPhotoCtrl', portfolioPhotoCtrl);

	portfolioPhotoCtrl.$inject = ['$scope', 'pixerfConfirmPopupSvc', 'portfolioPhotoSvc', 'toastr', 'sessionManagerSvc'];

	function portfolioPhotoCtrl($scope, pixerfConfirmPopupSvc, portfolioPhotoSvc, toastr, sessionManagerSvc) {
		var self = this;
		self.onRemovePortfolioPhotoClicked = onRemovePortfolioPhotoClicked;
		self.displaySize = $scope.displaySize ? $scope.file.thumbnails[scope.displaySize] : $scope.file.thumbnails['x400'];
		self.isLogined =  !!sessionManagerSvc.getCurrentLoginUser().data;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

		function onRemovePortfolioPhotoClicked(file, portfolioGallery) {
			var modal = pixerfConfirmPopupSvc.showPopup({ message: 'Hi, This photo will be removed from this portfolio gallery.' });
			modal.result.then(function () {
				portfolioPhotoSvc.removePhotoFromPortfolioGallery(file, portfolioGallery).then(function () {
					file.portfolios = _.reject(file.portfolios, function (gl) {
						return gl.id === portfolioGallery.id;
					})
					$scope.onFileRemoved({ file: file });
				}, function () {
					toastr.error("Cannot remove this photo from this portfolio gallery. Please try again.");
				})
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('portfolioPhoto', portfolioPhoto);

	function portfolioPhoto() {

		var directive = {
			scope: {
				displaySize: "@",
				file: "=",
				portfolioGallery: "=",
				onFileRemoved: "&",
				onRemovePortfolioPhotoClicked: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/portfolio-photo/portfolio-photo.html',
			controller: 'portfolioPhotoCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('popoverCartSvc', popoverCartSvc);

     popoverCartSvc.$inject = ['$rootScope', 'messageConst'];

    function popoverCartSvc($rootScope, messageConst) {

        
        var mIsOpen = {
            data : false
        };
        function isOpen(){
            return mIsOpen;
        }

        function toogle(status){
            $rootScope.$broadcast(messageConst.BROADCAST.TOOGLE_CART_POPUP, {status: status});
        }
        return {
           toogle: toogle,
           isOpen: isOpen
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('popoverCartCtrl', popoverCartCtrl);

    popoverCartCtrl.$inject = ['$scope', 'messageConst', '$state', 'cartSvc', '$uibModalStack', '$timeout', 'sessionManagerSvc', 'store', 'accountConst'];

    function popoverCartCtrl($scope, messageConst, $state, cartSvc, $uibModalStack, $timeout, sessionManagerSvc, store, accountConst) {

        var self = this;
        self.viewCartList = viewCartList;
        self.cart = cartSvc.getCart();
        self.isOpen = false;
        self.onCartItemRemoved = onCartItemRemoved;
        self.onCartItemClicked = onCartItemClicked;
        self.onContinueXerfingBtnClicked = onContinueXerfingBtnClicked;
		self.isDisablePopup = isDisablePopup;
		self.onCloseBtnClicked = onCloseBtnClicked;
        self.checkOut = checkOut;
		self.spinner = {
			isVisible: false
        };
        self.isAuthenticated = function () {
			return !!sessionManagerSvc.getCurrentLoginUser().data;
		};
        $scope.$on(messageConst.BROADCAST.TOOGLE_CART_POPUP, function(event, args) {
            if(typeof args.status !== 'undefined'){
                self.isOpen = !!args.status;
            } else{
                self.isOpen = !self.isOpen;
            }
            
        });
		function onCloseBtnClicked(){
			$timeout(function(){
				$("#header-navbar-btn").trigger("click");
            });
		}
        function viewCartList(){
            $state.go("checkout.shopping-cart");
        }
        function checkOut(){
            var pixerfEnv = new PixerfEnv().getEnv();
            var path = (pixerfEnv === "PRODUCTION") ? 'https://pixerf.com/#/' : 'https://qa.pixerf.com/#';
            var userId = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
            var link = path + '/sign-cart/' + userId;
            redirectToPixerfPayment(link);
        }

        function redirectToPixerfPayment(link){
            $timeout(function(){
                window.open(link, '_self');
           })
        }
        function onCartItemRemoved(){
            if(self.cart.data.cart_items.length === 0){
                self.isOpen = false;
            }
        }
        function onCartItemClicked(cartItem){
            $state.go('photo', {id: cartItem.media.id});
        }
        function onContinueXerfingBtnClicked(){
            if($state.current.name === "checkout.shopping-cart"){
                $uibModalStack.dismissAll();
                $timeout(function(){
                     window.history.back();
                })
            }
        }
        function isDisablePopup(){
            return self.cart.data.cart_items.length === 0 || $state.current.name === 'checkout.shopping-cart';
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('popoverCart', popoverCart);

  function popoverCart() {

    var directive = {
      scope: {},
      restrict: 'E',
      templateUrl: 'app/components/popover-cart/popover-cart.html',
      controller: 'popoverCartCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfUserAvatar', pixerfUserAvatar);

    pixerfUserAvatar.$inject = ['$rootScope', '$interval'];
    function pixerfUserAvatar($rootScope, $interval) {

        var directive = {
            scope: {
                userData: '=',
                tooltip: '=',
                lazy: '=' ,
            },
            restrict: 'E',
            templateUrl: 'app/components/pixerf-user-avatar/pixerf-user-avatar.html',
            replace: true
        };
        return directive;
    }

})();

(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('pixerfConfirmPopupSvc', pixerfConfirmPopupSvc);
    pixerfConfirmPopupSvc.$inject = ['$uibModalStack', '$uibModal'];

    function pixerfConfirmPopupSvc($uibModalStack, $uibModal){
        function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/pixerf-confirm-popup/pixerf-confirm-popup.html',
                controller: 'pixerfConfirmPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex ' + data.windowClass,
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });

        }

        return {
            showPopup: showPopup
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('pixerfConfirmPopupCtrl', pixerfConfirmPopupCtrl);

    pixerfConfirmPopupCtrl.$inject = ['$uibModalInstance','resolveData'];

    function pixerfConfirmPopupCtrl($uibModalInstance, resolveData) {

        var self = this;
        self.resolveData = resolveData;
        self.message = resolveData.message;
        self.hideConfirmText = resolveData.hideConfirmText;
        self.hideCancelBtn = resolveData.hideCancelBtn;
        self.cancelBtnText = resolveData.cancelBtnText ? resolveData.cancelBtnText : 'No';
        self.okBtnText = resolveData.okBtnText ? resolveData.okBtnText : 'Yes';
        self.confirmText = resolveData.confirmText;
        self.hideTitle = resolveData.hideTitle;

        self.ok = function () {
            if(resolveData.okFn){
                if(self.isWorking) return;
                self.isWorking = true;
                self.isSubmmited = true;
                resolveData.okFn().then(function(){
                    $uibModalInstance.close();

                    if(resolveData.okFnCallback){
                        resolveData.okFnCallback();
                    }
                }, function(){
                    self.isWorking = false;
                })
            } else {
                $uibModalInstance.close();
            }
        };
        $uibModalInstance.closed.then(function(){
            self.isWorking = false;
        })

        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

(function () {

	angular
		.module('pixerf')
		.controller('pixerfAnimationCarouselCtrl', pixerfAnimationCarouselCtrl);

	pixerfAnimationCarouselCtrl.$inject = ['$scope'];

	function pixerfAnimationCarouselCtrl($scope) {

		var self = this;
		self.datas = $scope.data || [];
		self.config = {
			slidesToShow: $scope.config && $scope.config.slidesToShow ? $scope.config.slidesToShow : 4,
			slidesToScroll: $scope.config && $scope.config.slidesToScroll ? $scope.config.slidesToScroll : 4,
			infinite: $scope.config && $scope.config.infinite ? $scope.config.infinite : false,
			dots: $scope.config && $scope.config.dots ? $scope.config.dots : true,
			autoplay: $scope.config && $scope.config.autoplay ? $scope.config.autoplay : false,
			autoplaySpeed: $scope.config && $scope.config.autoplaySpeed ? $scope.config.autoplaySpeed : 2000,
			speed: $scope.config && $scope.config.speed ? $scope.config.speed : 2000,
			responsive: $scope.config && $scope.config.responsive && $scope.config.responsive.length ? $scope.config.responsive : [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		};
		self.onItemClicked = function(){
			console.log('onItemClicked')
		}
	};
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('pixerfAnimationCarousel', pixerfAnimationCarousel);

	pixerfAnimationCarousel.$inject = [];

	function pixerfAnimationCarousel() {
		var directive = {
			scope: {
				instance: '@',
				data: '=',
				config: '=',
				limit: '@?'
			},
			restrict: 'E',
			templateUrl: 'app/components/pixerf-animation-carousel/pixerf-animation-carousel.html',
			controller: 'pixerfAnimationCarouselCtrl',
			controllerAs: 'vm',
			transclude: {
				"itemTemplate": "itemTemplate"
			},
			replace: true
		};
		return directive;
	}
})();

(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoViewerSvc', photoViewerSvc);
    photoViewerSvc.$inject = ['$rootScope'];

    function photoViewerSvc($rootScope){
        var mCurrentList = [];
        var mSearch = {};

        function removeDataOnStateChanged(){
            var listener = $rootScope.$on('$stateChangeStart', 
                function(){ 
                    removeListPhoto();
                    listener();// remove listener
                }
            )
            $rootScope.$on('$destroy', function(){
                listener();// remove listener
            });
        }

        function setListPhoto(currentList, unWatchingChangeState){
            mCurrentList = currentList;
            if(!unWatchingChangeState){
                removeDataOnStateChanged();
            }
        }

        function removeListPhoto(){
            setListPhoto([])
        }
        
        function getListPhoto(){
            return mCurrentList;
        }
        
        function setSearchParams(search){
            mSearch = search;
        }

        function getSearchParams(){
            return mSearch;
        }

        function isShouldGetMoreNavigation(currentPosition, navigationListLength, direction){
            if(direction === "next") return navigationListLength - currentPosition < 3;
            if(direction === "prev") return currentPosition < 3;
        }
        function getNextPhoto(direction, currentPosition, navigationList){
            var step = direction === "next" ? 1 : -1;
            return  navigationList[currentPosition + step];   
        }
        return {
            isShouldGetMoreNavigation: isShouldGetMoreNavigation,
            getNextPhoto: getNextPhoto,
            setListPhoto: setListPhoto,
            getListPhoto: getListPhoto,
            getSearchParams: getSearchParams,
            setSearchParams: setSearchParams
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('photoViewerCtrl', photoViewerCtrl);

  photoViewerCtrl.$inject = ['$scope', 'photoViewerSvc', 'pixerfApiMediaSvc', 'toastr', 'sessionManagerSvc', 'photoGridSvc', '$q', 'pixerfApiMediaDetailSvc'];

  function photoViewerCtrl($scope, photoViewerSvc, pixerfApiMediaSvc, toastr, sessionManagerSvc, photoGridSvc, $q, pixerfApiMediaDetailSvc) {
    var self = this;
    $scope.instance = self;
    self.rotatePhoto = rotatePhoto;
    self.navigationList = [];
    self.isLastPrev = false;
    self.isLastNext = false;
    self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
    self.originalRotation = $scope.photo.rotate_by;
    self.navigate = navigate;
    self.saveRotation = saveRotation;
    self.resetRotation = resetRotation;
    self.isRotationDirty = false;
    self.rotateStep = 0;
    self.originRotateStep = 0;
    self.photoRotate = $scope.photo.rotate_by;
    self.searchParams = {};
    self.logKey = logKey;
    self.showNavigateBtn = true;

    init();

    function init() {
      getNavigationList();
    }

    function logKey(e) {
      if (e.code === 'ArrowLeft' && self.isLastPrev) {

        navigate('prev');
      } else if (e.code === 'ArrowRight' && self.isLastNext) {
        navigate('next');
      }
    }

    function checkNavigatable(navigationList, photoid) {
      var currentPosition = _.indexOf(navigationList, photoid);
      if (currentPosition < 0) {
        self.isLastPrev = false;
        self.isLastNext = false;
        return;
      }
      self.isLastPrev = currentPosition !== 0;
      self.isLastNext = currentPosition !== navigationList.length - 1;
    }

    function getNavigationList() {
      self.navigationList = photoViewerSvc.getListPhoto();
      if (self.navigationList.length <= 1) {
        self.showNavigateBtn = false;
      }
      checkNavigatable(self.navigationList, $scope.photo.id);
    }

    function navigate(direction) {
      var currentPosition = _.indexOf(self.navigationList, $scope.photo.id);
      var nextPhotoId = photoViewerSvc.getNextPhoto(direction, currentPosition, self.navigationList);

      if (!nextPhotoId) {
        loadMorePhotos().then(function (mediaId) {
          getPhotoDetails(mediaId);
        });
      } else {
        getPhotoDetails(nextPhotoId);
      }
    }

    function rotatePhoto() {
      var step = self.rotateStep;
      step += 90;
      self.photoRotate = self.photoRotate === null ? 90 : (self.photoRotate + 90);
      if (self.photoRotate >= 360) {
        self.photoRotate = null;
      }
      if (step >= 360) {
        step = 0;
      }
      self.rotateStep = step;
    }

    function resetRotation() {
      self.rotateStep = self.originRotateStep;
      self.photoRotate = self.originalRotation;
    }

    function saveRotation() {
      if (self.isWorking) return;
      self.isWorking = true;
      if (self.photoRotate === 0 || self.photoRotate >= 360) self.photoRotate = null;
      pixerfApiMediaSvc.update({
        id: $scope.photo.id
      }, {
        rotate_by: self.photoRotate
      }).$promise.then(function () {
        self.isWorking = false;
        self.originalRotation = self.photoRotate;
        self.originRotateStep = self.rotateStep;
        $scope.photo.rotate_by = self.photoRotate;
        toastr.success("This photo has been successfully updated!");
        $scope.onPhotoSaved($scope.photo);
      }, function () {
        self.isWorking = false;
        toastr.error("Oops looks like something went wrong");
      });
    }

    function loadMorePhotos() {
      var def = $q.defer();
      var tempIds = [];
      self.searchParams = photoViewerSvc.getSearchParams();
      if (self.searchParams) {
        self.searchParams.page++;
        photoViewerSvc.setSearchParams(self.searchParams);
      }
      photoGridSvc.fetchPhotos(self.searchParams).then(function (response) {
        tempIds = _.pluck(response.data, "id");
        self.navigationList = self.navigationList.concat(tempIds);
        photoViewerSvc.setListPhoto(self.navigationList, true);
        def.resolve(tempIds[0]);
      }).catch(function () {
        def.reject();
      })

      return def.promise;
    }

    function getPhotoDetails(nextPhotoId) {
      pixerfApiMediaDetailSvc.get({
        id: nextPhotoId
      }).$promise.then(function (response) {
        var nextPhoto = response.data;
        $scope.photo = nextPhoto;
        checkNavigatable(self.navigationList, nextPhoto.id);
        $scope.onNavigate({
          photo: nextPhoto
        });
      }, function (err) {
        toastr.error("Failed to get photo detail. Please try again.");
      })
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('photoViewer', photoViewer);

	function photoViewer() {

		var directive = {
			scope: {
				'photo': '=',
				'onNavigate': '&',
				'photoLoaded': "=",
				'onPhotoSaved': '&',
				'instance': '='
			},
			restrict: 'E',
			templateUrl: 'app/components/photo-viewer/photo-viewer.html',
			controller: 'photoViewerCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoPriceSizeSelectionSvc', photoPriceSizeSelectionSvc);

    photoPriceSizeSelectionSvc.$inject = ['sessionManagerSvc'];

    function photoPriceSizeSelectionSvc(sessionManagerSvc){
       
        return {
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('photoPriceSizeSelectionCtrl', photoPriceSizeSelectionCtrl);

  photoPriceSizeSelectionCtrl.$inject = ['$scope', '$translate', 'sessionManagerSvc', 'commonConst'];

  function photoPriceSizeSelectionCtrl($scope, $translate, sessionManagerSvc, commonConst) {
    var self = this;
    self.mloginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
    self.commonConst = commonConst;
    self.layoutHorizontal = $scope.layoutHorizontal;
    self.isCustomPriceForDefiner = isCustomPriceForDefiner;
    self.onPriceItemClicked = _.debounce(function (evt, price) {
      $scope.$apply(function () {
        onPriceItemClicked(evt, price);
      })
    }, 300);
    self.selectedPrice = null;
    self.toolTips = [{
        "size": "XS",
        "toolTips": $translate.instant('tool-tip-xsmall'),
      },
      {
        "size": "S",
        "toolTips": $translate.instant('tool-tip-small'),
      },
      {
        "size": "M",
        "toolTips": $translate.instant('tool-tip-medium'),
      },
      {
        "size": "L",
        "toolTips": $translate.instant('tool-tip-large'),
      },
      {
        "size": "XL",
        "toolTips": $translate.instant('tool-tip-xlarge')
      },
      {
        "size": "XXL",
        "toolTips": $translate.instant('tool-tip-xxlarge')
      }
    ];

    $scope.$watch("photo.price", function () {
      if ($scope.photo && $scope.photo.price && $scope.photo.price.range && $scope.photo.price.range.length > 0) {
        onPriceItemClicked(null, getDefaultValue());
        buildLicenseToolTips();
      }
    })

    function isCustomPriceForDefiner(userId, size) {
      if (self.commonConst.CHEATED_USERS.DEFINERS.includes(userId) && ['Large', 'Small', 'L', 'S'].includes(size)) {
        return true;
      } else if (!self.commonConst.CHEATED_USERS.DEFINERS.includes(userId)) {
        return true;
      } else {
        return false
      }
    }

    function buildLicenseToolTips() {
      var priceRange = $scope.photo.price.range;
      for (var i = 0; i < priceRange.length; i++) {
        for (var j = 0; j < self.toolTips.length; j++) {
          if (priceRange[i].size === self.toolTips[j].size) {
            priceRange[i].toolTips = self.toolTips[j].toolTips;
            break;
          }
        }
      }
    }

    function getDefaultValue() {
      var priceRange = $scope.photo.price.range;
      for (var i = 0; i < priceRange.length; i++) {
        if (priceRange[i].isSelected) {
          return priceRange[i];
        }
      }
      if ($scope.photo.data && $scope.photo.data.user && self.commonConst.CHEATED_USERS.DEFINERS.includes($scope.photo.data.user.id)) {
        priceRange = _.find(priceRange, function (price) {
          return price.size == "S";
        })
        return priceRange;
      } else {
        return priceRange[0];
      }
    }

    function deselectAll(priceRange) {
      for (var i = 0; i < priceRange.length; i++) {
        priceRange[i].isSelected = false;
      }
    }

    function onPriceItemClicked(evt, price) {
      if ($scope.isDisabled) return;
      deselectAll($scope.photo.price.range);
      price.isSelected = true;
      self.selectedPrice = price;
      $scope.onItemSelectedChanged({
        evt: evt,
        price: self.selectedPrice
      });

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoPriceSizeSelection', photoPriceSizeSelection);

  function photoPriceSizeSelection() {

    var directive = {
      scope: {
        user: "=",
        "layoutHorizontal": "=",
        "photo" : "=",
        'onItemSelectedChanged': '&',
        'isReadonly': '=',
        'isDisabled': '='
      },
      restrict: 'E',
      templateUrl: 'app/components/photo-price-size-selection/photo-price-size-selection.html',
      controller: 'photoPriceSizeSelectionCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photoLicenseInfoCtrl', photoLicenseInfoCtrl);

	photoLicenseInfoCtrl.$inject = ['$scope', 'toastr', 'sessionManagerSvc', 'pixerfApiMediaSvc', 'pixerfApiUserSvc'];

	function photoLicenseInfoCtrl($scope, toastr, sessionManagerSvc, pixerfApiMediaSvc, pixerfApiUserSvc) {

		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onRequestReleaseFormBrnclicked = onRequestReleaseFormBrnclicked;
		self.getCommercialStatus = getCommercialStatus;
		self.showDownloadRelease = showDownloadRelease;

		function onRequestReleaseFormBrnclicked(photo) {
			var pixerfAPIUrlConfigurer = new PixerfAPIUrlConfigurer();
			var baseUrl = pixerfAPIUrlConfigurer.getBaseUrl();
			var fullUrl = pixerfAPIUrlConfigurer.URL_PRFIX + baseUrl + pixerfAPIUrlConfigurer.URL_AFFIX + '#/';

			if (baseUrl.startsWith("localhost")) {
				fullUrl = pixerfAPIUrlConfigurer.URL_LOCAL_PRFIX + baseUrl + pixerfAPIUrlConfigurer.URL_AFFIX + '#/';
			}
			var photoUrl = fullUrl + 'photo/' + photo.id + '/' + photo.title;

			if (!photo.user || !photo.user.id) {
				return toastr.error("Oops! Looks like something went wrong.");
			}
			if (!photo.user.email) {
				return getUserInfoAndCallRequest(photoUrl, photo.user.id);
			}

			callRequestReleaseFormApi(photo.user.email, photoUrl);
		}

		function callRequestReleaseFormApi(email, photoUrl){
			pixerfApiMediaSvc.request_release_form({
				email: email,
				url: photoUrl
			}).$promise.then(
				function success(res) {
					toastr.success('Successfully requested!');
				},
				function error(err) {
					console.log(err);
					toastr.error("Oops! Looks like something went wrong.");
				}
			);
		}

		function getUserInfoAndCallRequest(photoUrl, userId){
			return pixerfApiUserSvc.get({
				id: userId,
				action: 'profile'
			}).$promise.then(
				function success(userData) {
					callRequestReleaseFormApi(userData.email, photoUrl);
				},
				function error(err) {
					console.log(err);
					toastr.error("Oops! Looks like something went wrong.");
				}
			);
		}

		function getCommercialStatus() {
			if ($scope.photo.license === 'editorial') {
				return 'No';
			} else if (($scope.photo.status === 'approved') || ($scope.photo.has_model_property == false)) {
                return 'Yes';
			}
            return 'Pending';
		}

		function showDownloadRelease() {
			return $scope.photo.license === "commercial" && self.loginnedUser && self.loginnedUser.canCurate && $scope.photo.releases && $scope.photo.releases.length;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('photoLicenseInfo', photoLicenseInfo);

	function photoLicenseInfo() {

		var directive = {
			scope: {
				'photo': '=',
			},
			restrict: 'E',
			templateUrl: 'app/components/photo-license-info/photo-license-info.html',
			controller: 'photoLicenseInfoCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoGridPagerCtrl', photoGridPagerCtrl);

    photoGridPagerCtrl.$inject = ['$scope'];

    function photoGridPagerCtrl( $scope) {

        var self = this;
        self.pageNumber = 1;
        $scope.instance = self;

    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoGridPager', photoGridPager);

  function photoGridPager() {

    var directive = {
      scope: {
        photoGridInstance: "=",
        totalPhotoText: '@',
        isShownNumPhotos: '=',
        unit: '@',
        page: "=",
        totalPage: '=',
        totalPhotos: '=',
        onCurrentPageChanged: "&",
        isShowPageText: '@'
      },
      restrict: 'E',
      templateUrl: 'app/components/photo-grid-pager/photo-grid-pager.html',
      controller: 'photoGridPagerCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('photoGridSvc', photoGridSvc);

	photoGridSvc.$inject = ['pixerfApiGallerySvc', 'pixerfApiUserSvc', 'pixerfApiMediaSvc', 'fileConst', 'pixerfApiMissionSvc', 'pixerfApiMediaDetailSvc'];

	function photoGridSvc(pixerfApiGallerySvc, pixerfApiUserSvc, pixerfApiMediaSvc, fileConst, pixerfApiMissionSvc, pixerfApiMediaDetailSvc) {
		function fetchPhotos(searchParam) {
			var urlParams = {
				page: searchParam.page,
				page_size: fileConst.PHOTO_GRID_PAGE_SIZE
			};
			if (searchParam.pageSize) {
				urlParams.page_size = searchParam.pageSize;
			}
			if (searchParam.type === 'pending_missions') {
				return pixerfApiMissionSvc.get_pending_in_missions().$promise;
			}
			if (searchParam.mission) {
				urlParams.id = searchParam.mission.id;
				if (searchParam.status === 'pending') {
					return pixerfApiMissionSvc.pending_submission_mission(urlParams).$promise;
				}
				if (searchParam.status === 'rejected') {
					return pixerfApiMissionSvc.rejected_submission_mission(urlParams).$promise;
				}
				if (searchParam.type) {
					urlParams.type = searchParam.type;
				}
				return pixerfApiMissionSvc.get_participations(urlParams).$promise;
			}
			if (searchParam.userId) {
				urlParams.id = searchParam.userId;
				if (searchParam.type) {
					urlParams.type = searchParam.type;
				}
				return pixerfApiUserSvc.get_medias(urlParams, buildSearchParam(searchParam)).$promise;
			}
			if (searchParam.galleryIds) {
				var galleryIds = typeof searchParam.galleryIds === "string" ? searchParam.galleryIds.split(",") : searchParam.galleryIds;
				urlParams.id = galleryIds[0];
				return pixerfApiGallerySvc.get_medias(urlParams).$promise;
			}
			if (searchParam.action === "more") {
				urlParams.id = searchParam.mediaid;
				return pixerfApiMediaDetailSvc.getSimilar(urlParams).$promise;
			}
			return pixerfApiMediaDetailSvc.search(urlParams, buildSearchParam(searchParam)).$promise;
		}

		function getPhotoSizeContraint(sizeName) {
			for (var i = 0; i < fileConst.SIZE_DEFINITION.length; i++) {
				if (fileConst.SIZE_DEFINITION[i].name === sizeName) {
					if (i === fileConst.SIZE_DEFINITION.length - 1) {
						return "gte-" + fileConst.SIZE_DEFINITION[i].value;
					}
					return "gte-" + fileConst.SIZE_DEFINITION[i].value + "," + "lte-" + fileConst.SIZE_DEFINITION[i + 1].value;
				}
			}
		}

		function buildSearchParam(searchParam, isTemporary) {
			var param = {};
			if (searchParam.username) {
				param.username = searchParam.username;
			}
			if (searchParam.sort) param.sort = searchParam.sort;
			if (searchParam.state && !isTemporary && !searchParam.status) {
				param.state = searchParam.state
			} else if (searchParam.status){
				param.status = searchParam.status;
				param.has_model_property = true;
			}
			if (typeof searchParam.in_mission !== 'undefined') param.in_mission = searchParam.in_mission;
			if (searchParam.keywords) param.keywords = searchParam.keywords;
			if (searchParam.galleryIds) param.gallery_ids = typeof searchParam.galleryIds === "string" ? searchParam.galleryIds.split(",") : searchParam.galleryIds;
			if (searchParam.megapixels) param.megapixels = getPhotoSizeContraint(searchParam.megapixels.toUpperCase());
			if (searchParam.orientation) param.orientation = searchParam.orientation;
			if (searchParam.categoryIds) param.category_ids = typeof searchParam.categoryIds === "string" ? searchParam.categoryIds.split(",") : searchParam.categoryIds;
			if (searchParam.license) param.license = searchParam.license.toUpperCase();
			if (searchParam.price) param.price = searchParam.price;
			if (searchParam.more_type) param.more_type = searchParam.more_type;
			if (searchParam.type) param.type = searchParam.type;
			if (searchParam.states && searchParam.states.length) {
				param.states = searchParam.states;
			}

			return param;
		}

		function fetchTemporaryPhotos(searchParam){
			var isTemporary = true;
			var urlParams = {
				page: searchParam.page,
				page_size: fileConst.PHOTO_GRID_PAGE_SIZE
			};
			if (searchParam.pageSize) {
				urlParams.page_size = searchParam.pageSize;
			}
			if (searchParam.type === 'pending_missions') {
				return pixerfApiMissionSvc.get_pending_in_missions().$promise;
			}
			if (searchParam.mission) {
				urlParams.id = searchParam.mission.id;
				if (searchParam.status === 'pending') {
					return pixerfApiMissionSvc.pending_submission_mission(urlParams).$promise;
				}
				if (searchParam.status === 'rejected') {
					return pixerfApiMissionSvc.rejected_submission_mission(urlParams).$promise;
				}
				if (searchParam.type) {
					urlParams.type = searchParam.type;
				}
				return pixerfApiMissionSvc.get_participations(urlParams).$promise;
			}
			if (searchParam.userId) {
				urlParams.id = searchParam.userId;
				if (searchParam.type) {
					urlParams.type = searchParam.type;
				}
				return pixerfApiUserSvc.get_medias(urlParams, buildSearchParam(searchParam, isTemporary)).$promise;
			}
			if (searchParam.galleryIds) {
				var galleryIds = typeof searchParam.galleryIds === "string" ? searchParam.galleryIds.split(",") : searchParam.galleryIds;
				urlParams.id = galleryIds[0];
				return pixerfApiMediaSvc.getTemporary(urlParams).$promise;
			}
			if (searchParam.action === "more") {
				urlParams.id = searchParam.mediaid;
				return pixerfApiMediaSvc.getSimilar(urlParams).$promise;
			}
			return pixerfApiMediaSvc.getTemporary(urlParams, buildSearchParam(searchParam, isTemporary)).$promise;
		}

		return {
			fetchPhotos: fetchPhotos,
			fetchTemporaryPhotos: fetchTemporaryPhotos
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoGridCtrl', photoGridCtrl);

    photoGridCtrl.$inject = ['$rootScope', '$scope', 'photoGridSvc', 'fileUtils', 'pagingUtils', 'sessionManagerSvc', 'accountUtils', '$q', 'arrayUtils', 'numberUtils', 
        'gallerySvc', 'photoDetailSvc', 'photoViewerSvc', 'pixerfApiUserSvc', 'pixerfApiMediaSvc'];

    function photoGridCtrl($rootScope, $scope, photoGridSvc,  fileUtils, pagingUtils, sessionManagerSvc, accountUtils, $q, arrayUtils, numberUtils, 
        gallerySvc, photoDetailSvc, photoViewerSvc, pixerfApiUserSvc, pixerfApiMediaSvc) {

        var self = this;
        var photoIds = [];
        self.containerClass = $scope.container ? $scope.container + " .photo-grid__photos-container" : '';
        self.getFile = getFile;
        self.fetchMorePhotos = fetchMorePhotos;
        self.fetchPhotos = fetchPhotos;
        self.render = render;
        self.spinner = {isVisible: false};
        self.photos = null;
        self.totalPhotos = 0;
        self.totalPage = 0;
        self.failedToLoadImages = [];
        self.searchParams = null;
        self.firstPageNumber = -1;
        self.isNoMorePhotoToLoad = true;
        self.onFileRemoved = onFileRemoved;
        self.onAddedOrRemovedFromGallery = onAddedOrRemovedFromGallery;
        self.onPhotoPopupSaved = onPhotoPopupSaved;
        $scope.instance = self;
        self.onWindowResize = _.debounce(reRender, 300);
        self.onOrientationChange = _.debounce(reRenderOrientationChange, 300);
        self.isFresh = false;
        var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.isMobile = photoDetailSvc.isMobile();
        self.isTemporaryType = false;
        self.flaggedUsers = [];
        var tmpPhotos = [];

        function getFile(fileId){
            var found = fileUtils.findFileById(self.photos, fileId);
            if(found){
                // found.isMine = mLoginnedUser ? mLoginnedUser.username === found.person.username : false;
                // found.person = accountUtils.transformUserData(found.person);
                // found.path = window.location.protocol + "//" + window.location.host + "/photo/" + fileId;
            }

            return found;
        }
        function fetchPhotos(searchParams, isRefresh){
            var def =  $q.defer();
            if(self.spinner.isVisible){
                def.resolve([]);
                return def.promise;
            }
            self.searchParams = searchParams || {};
            if(!self.searchParams.page) self.searchParams.page = 1;


            self.spinner.isVisible = true;
            self.isNoMorePhotoToLoad = false;
            if(isRefresh) {
                reset();
            }

            if(self.firstPageNumber === -1) self.firstPageNumber = self.searchParams.page;

            self.isFresh = isRefresh;

            if(self.isTemporaryType){
                return fetchTemporaryPhotos(def);
            }
            photoGridSvc.fetchPhotos(self.searchParams).then(function(response){
                if (self.searchParams.page === 1) {
                    self.failedToLoadImages = [];
                    self.photos = [];
                }
                if(response.data && response.data.length > 0){
                    if($scope.isPendingCommercialCustom){
                        var promises = [];
                        response.data = _.reject(response.data, function (pt) {
                            return !pt.has_model_property;
                        });
                        response.data = _.reject(response.data, function (pt) {
                            return pt.is_releasable;
                        });

                        for(var i = 0; i< response.data.length; i++){
                            promises.push(pixerfApiMediaSvc.get({
                                id: response.data[i].id
                            }).$promise.then(function(res){
                                return res.data;
                            }));
                        }

                        $q.all(promises).then(function (res) {
                            res = _.reject(res, function (pt) {
                                return pt.status != 'pending';
                            });
                            tmpPhotos = tmpPhotos.concat(res);
                            if(tmpPhotos.length < 10) {
                                self.spinner.isVisible = false;
                                fetchMorePhotos();
                                return;
                            }
                            self.spinner.isVisible = false;
                            if(angular.isDefined($scope.onBeforeRender)){
                                $scope.onBeforeRender({photos: tmpPhotos});
                            }
                            self.photos = self.photos.concat(tmpPhotos);
                            if(!self.searchParams.action || self.searchParams.action != "more"){
                                photoIds = _.pluck(self.photos, "id");
                                photoViewerSvc.setSearchParams(self.searchParams);
                                photoViewerSvc.setListPhoto(photoIds);
                            }
                            render(tmpPhotos);
                            tmpPhotos = [];
                        })
                    } else {
                        self.spinner.isVisible = false;
                        if(angular.isDefined($scope.onBeforeRender)){
                            $scope.onBeforeRender({photos: response.data});
                        }
                        self.photos = self.photos.concat(response.data);
                        if(!self.searchParams.action || self.searchParams.action != "more"){
                            photoIds = _.pluck(self.photos, "id");
                            photoViewerSvc.setSearchParams(self.searchParams);
                            photoViewerSvc.setListPhoto(photoIds);
                        }
                        render(response.data);
                    }
                }
                self.isNoMorePhotoToLoad = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
                self.totalPhotos = pagingUtils.getTotalCount(response);
                self.totalPage = pagingUtils.getTotalPage(response);
                def.resolve(self);
            }, function(){
                self.isFresh = false;
                self.spinner.isVisible = false;
                def.reject(self);
            });

            return def.promise;
        }

        function fetchTemporaryPhotos(def){
            photoGridSvc.fetchTemporaryPhotos(self.searchParams).then(
                function success(response){
                    self.spinner.isVisible = false;
                    if (self.searchParams.page === 1) {
                        self.failedToLoadImages = [];
                        self.photos = [];
                    }
                    if (response.data && response.data.length > 0) {
                        if (angular.isDefined($scope.onBeforeRender)) {
                            $scope.onBeforeRender({ photos: response.data });
                        }
                        self.photos = self.photos.concat(response.data);
                        if (!self.searchParams.action || self.searchParams.action != "more") {
                            photoIds = _.pluck(self.photos, "id");
                            photoViewerSvc.setSearchParams(self.searchParams);
                            photoViewerSvc.setListPhoto(photoIds);
                        }
                        render(response.data);
                    }
                    self.isNoMorePhotoToLoad = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
                    self.totalPhotos = pagingUtils.getTotalCount(response);
                    self.totalPage = pagingUtils.getTotalPage(response);
                    def.resolve(self);
                },
                function error(err){
                    self.isFresh = false;
                    self.spinner.isVisible = false;
                    def.reject(self);
                }
            );

            return def.promise;
        }

        function registerScrollSpy(photos, isRedraw){
            for (var i = 0; i < photos.length; i ++){
                var photo = photos[i];
                photo.onScrollTo = '';
                photo.scrollSpyId = undefined;
                photo.pixerfScrollSpyDirection = undefined;
                photo.isFirstPhoto = undefined;
                photo.isLastPhoto = undefined;
                if(i === 0){
                    photo.scrollSpyId = new Date().getTime() + "-" + photo.id;
                    photo.onScrollTo = 'onScrollToPhoto({page:' + photo.pageNumber + '})';
                    photo.pixerfScrollSpyDirection = 'down';
                    if(self.searchParams.page === self.firstPageNumber){
                        photo.pixerfScrollSpyDirection = 'both';
                        photo.isFirstPhoto = true;
                    }
                }
                if(i === photos.length - 1) {
                    photo.scrollSpyId = new Date().getTime() + "-" + photo.id;
                    photo.onScrollTo = 'onScrollToPhoto({page:' +  photo.pageNumber + '})';
                    if(isRedraw){
                        photo.pixerfScrollSpyDirection = 'both';
                    } else {
                        photo.pixerfScrollSpyDirection = 'up';
                    }
                    if(self.isNoMorePhotoToLoad){
                        photo.isLastPhoto = true;
                        photo.pixerfScrollSpyDirection = 'both';
                    }
                }
            }
        }
        function fetchMorePhotos(){
            if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page ++;
            if($scope.onLoadMorePage) $scope.onLoadMorePage({page: self.searchParams.page});
            fetchPhotos(self.searchParams);
        }
        function startRendering(photos, failedToLoadImages, isRedraw){
            photos = removeSpoilPhotos(photos, failedToLoadImages);
            if (angular.isDefined($scope.shuffle)) {
                var shuffleRange = numberUtils.parseInt($scope.shuffle);
                if(self.searchParams.page <= shuffleRange){
                    photos = arrayUtils.shuffle(photos);
                }
            }
            if (angular.isDefined($scope.onScrollToPhoto)) {
                registerScrollSpy(photos, isRedraw);
            }
            $scope.grid.generate(photos);
        }
        function redraw(){
            var photoPages = Object.values(_.groupBy(self.photos, "pageNumber"));
            for( var i = 0; i < photoPages.length; i++){
                startRendering(photoPages[i], self.failedToLoadImages, true);
            }
        }
        function render(photos){
            if(photos.length <= 0) return;
            self.spinner.isVisible = true;
            var imageElements = [];
            var loadedImage = 0;
            for(var i=0; i< photos.length; i++){
                if(self.searchParams){
                    photos[i].pageNumber = self.searchParams.page;
                }
                imageElements[i] = new Image();
                imageElements[i].setAttribute("class", "image"+i);
                imageElements[i].onload = (function(idx){
                    return function(){
                        loadedImage ++;
                        photos[idx].w = this.width;
                        photos[idx].h = this.height;
                        photos[idx].ar = this.width / this.height;
                        if(loadedImage === photos.length){
                            self.spinner.isVisible = false;
                            self.isFresh = false;
                            startRendering(photos, self.failedToLoadImages);
                        }
                    }
                })(i)
                imageElements[i].onerror = (function(idx){
                    return function(){
                        loadedImage ++;
                        self.failedToLoadImages.push(photos[idx].id);
                        if(loadedImage === photos.length){
                            self.spinner.isVisible = false;
                            self.isFresh = false;
                            startRendering(photos, self.failedToLoadImages);
                        }
                    }
                })(i)
                var photo = photos[i];
                imageElements[i].src = photo.urlSmall;
            }
        }
        function removeSpoilPhotos(photos, spoilPhotoIds){
            for (var i  = 0; i < spoilPhotoIds.length; i ++){
                photos = _.reject(photos, function(item){
                    return item.id === spoilPhotoIds[i];
                });
            }
            return photos;
        }
        function reRender(){
			if($rootScope.mobileAndTabletcheck) return;
            if(self.photos.length === 0 || self.spinner.isVisible) return;
            $scope.grid.reset();
            // render(self.photos);
            redraw();
        }
        function reRenderOrientationChange(){
            if($rootScope.mobileAndTabletcheck){
                $scope.grid.reset();
                redraw();
            }
        }
        function reset(){
            self.photos = [];
            $scope.grid.reset();
            self.firstPageNumber = -1;
        }
        function onFileRemoved(file, extraParams){
            self.photos = _.reject(self.photos, function(f){
                return f.id === file.id;
            });
            $scope.grid.reset();
            if(self.photos.length > 0){
                render(self.photos);
            } else {
                self.spinner.isVisible = false;
            }
            if($scope.gallery){
                gallerySvc.updateGalleryCover($scope.gallery);
            }
            if($scope.onFileRemoved){
                $scope.onFileRemoved({file: file, extraParams: extraParams});
            }

        }
        function onAddedOrRemovedFromGallery(file){
            if(!$scope.gallery) return;
            var isExisted = _.find(self.photos, function(it){return it.id === file.id});
            var isGalleryExisted = _.find(file.galleries, function(it){return it.id === $scope.gallery.id});
            if(isGalleryExisted && !isExisted){
                self.photos.push(file);
                $scope.grid.reset();
                if(self.photos.length > 0){
                    render(self.photos);
                } else {
                    self.spinner.isVisible = false;
                }
                if($scope.gallery && !$scope.gallery.cover_media ){
                    gallerySvc.updateGalleryCover($scope.gallery);
                }
            } else if(!isGalleryExisted && isExisted){
                onFileRemoved(file)
            }
        }
        function onPhotoPopupSaved(oldPhoto, newPhoto){
            if(oldPhoto.rotate_by !== newPhoto.rotate_by){
                oldPhoto.urlSmall = oldPhoto.urlSmall.split('?')[0] + "?" + new Date().getTime();
                reRender();
            }
            if($scope.onPhotoPopupSaved){
                $scope.onPhotoPopupSaved.apply(arguments);
            }
        }

        function getFlaggedUser() {
            if (mLoginnedUser && (mLoginnedUser.isAdminInternal || mLoginnedUser.isCurator)){

                self.isWorking = true;
                pixerfApiUserSvc.getFlaggedUser().$promise.then(function (data) {
                    self.flaggedUsers = data;
                }).catch(function (err) {
                    console.log(err);
                })
            }
		}
        function init(){
            getFlaggedUser();
        }

        init();
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoGrid', photoGrid);
  photoGrid.$inject = ["$compile"];
  function photoGrid($compile) {

    var directive = {
      scope: {
          mission: '=',
          photos: "=",
          morePhotos : "=",
          hideNoMoreMessage: "=",
          spinner: "=",
          isNoMorePhotoToLoad: "=",
          user: "=",
          instance: "=?",
          gallery: "=",
          context: '=',
          idealHeight: '=',
          isIgnoreBodyScroll: '=',
          onScrollToPhoto: '&?',
          shuffle: '@',
          onLoadMorePage: '&',
          onPhotoClicked: '&?',
          onPhotoClickedCallback: '&?',
          simpleSelectMode: '=',
          overlayMode: '=',
          onBeforeRender: '&?',
          container: '@?',
		      onFileRemoved: '&?',
          onPhotoPopupSaved: '&',
          onPhotoPopupClosed: '&',
          onInit: '&?',
          options: '=?',
          onRemoveBtnClick: '&?',
          template: '=',
          height: '@',
          isPendingCommercialCustom: '@?'
      },
      transclude: true,
      restrict: 'E',
      templateUrl: 'app/components/photo-grid/photo-grid.html',
      controller: 'photoGridCtrl',
      controllerAs: 'vm',
      replace: true,
      link: function(scope, element, attrs, ctrl){
          function buildItemTemplate(){
              if(attrs.template){
                  return scope.template;
              }
              var str = '<photo ';
              if(attrs.onScrollToPhoto){
                str += 'scroll-spy-id="<%=scrollSpyId%>" is-first-spy-item="<%=isFirstPhoto%>" is-last-spy-item="<%=isLastPhoto%>" pixerf-scroll-spy="<%=onScrollTo%>" pixerf-scroll-spy-direction="<%=pixerfScrollSpyDirection%>"';
              }
              if(attrs.onPhotoClicked){
                str += ' on-photo-clicked="onPhotoClicked({file: file})"';
              }
              if(attrs.onPhotoClickedCallback){
                str += ' on-photo-clicked-callback="onPhotoClickedCallback({file: file})"';
              }
              if(attrs.simpleSelectMode){
                str += ' simple-select-mode="simpleSelectMode"';
              }
              if(attrs.overlayMode){
                str += ' overlay-mode="overlayMode"';
              }
              if(attrs.options){
                str += ' options="options"';
              }
              if(attrs.onRemoveBtnClick){
                str += ' on-remove-btn-click="onRemoveBtnClick({file: file})"';
              }
              if(attrs.onPhotoPopupClosed){
                str += ' on-photo-popup-closed="onPhotoPopupClosed({originalFile: originalFile , newFile: newFile})"';
              }
              str += ' context="context" on-added-or-removed-from-gallery="vm.onAddedOrRemovedFromGallery(file)" on-file-removed="vm.onFileRemoved(file)" gallery="gallery" file="vm.getFile(<%=id%>)" flagged-users="vm.flaggedUsers">';
              str += '</photo>';
              return str;
          }
          scope.grid = new PhotoGrid({
              idealHeight: ctrl.isMobile ? Math.max(150, parseInt(window.innerHeight / 4)) :  (scope.idealHeight ? scope.idealHeight : Math.max(350, parseInt(window.innerHeight / 3))),
              $container: $(element).find(".photo-grid__photos-container"),
              $parent: scope.container ? $(scope.container + " .photo-grid__photos-container") : $("body"),
              itemTmpl: buildItemTemplate(),
              height: scope.height,
              isIgnoreBodyScroll: scope.isIgnoreBodyScroll,
              events: {
                  beforeItemRendered: function(item, photo){
                       $compile(item)(scope);
                  }
              }
          });
          //notifiy grid initialize done
          if(attrs.onInit){
              scope.onInit({photoGrid: ctrl});
          }
      }
    };
    return directive;
  }

})();

// Generated by CoffeeScript 1.6.3
var linear_partition, min;

min = function(arr) {
  var computed, result, x, _i, _len;
  for (_i = 0, _len = arr.length; _i < _len; _i++) {
    x = arr[_i];
    computed = x[0];
    if (!result || computed < result.computed) {
      result = {
        value: x,
        computed: computed
      };
    }
  }
  return result.value;
};

linear_partition = function(seq, k) {
  var ans, i, j, m, n, solution, table, x, y, _i, _j, _k, _l;
  n = seq.length;
  if (k <= 0) {
    return [];
  }
  if (k > n) {
    return seq.map(function(x) {
      return [x];
    });
  }
  table = (function() {
    var _i, _results;
    _results = [];
    for (y = _i = 0; 0 <= n ? _i < n : _i > n; y = 0 <= n ? ++_i : --_i) {
      _results.push((function() {
        var _j, _results1;
        _results1 = [];
        for (x = _j = 0; 0 <= k ? _j < k : _j > k; x = 0 <= k ? ++_j : --_j) {
          _results1.push(0);
        }
        return _results1;
      })());
    }
    return _results;
  })();
  solution = (function() {
    var _i, _ref, _results;
    _results = [];
    for (y = _i = 0, _ref = n - 1; 0 <= _ref ? _i < _ref : _i > _ref; y = 0 <= _ref ? ++_i : --_i) {
      _results.push((function() {
        var _j, _ref1, _results1;
        _results1 = [];
        for (x = _j = 0, _ref1 = k - 1; 0 <= _ref1 ? _j < _ref1 : _j > _ref1; x = 0 <= _ref1 ? ++_j : --_j) {
          _results1.push(0);
        }
        return _results1;
      })());
    }
    return _results;
  })();
  for (i = _i = 0; 0 <= n ? _i < n : _i > n; i = 0 <= n ? ++_i : --_i) {
    table[i][0] = seq[i] + (i ? table[i - 1][0] : 0);
  }
  for (j = _j = 0; 0 <= k ? _j < k : _j > k; j = 0 <= k ? ++_j : --_j) {
    table[0][j] = seq[0];
  }
  for (i = _k = 1; 1 <= n ? _k < n : _k > n; i = 1 <= n ? ++_k : --_k) {
    for (j = _l = 1; 1 <= k ? _l < k : _l > k; j = 1 <= k ? ++_l : --_l) {
      m = min((function() {
        var _m, _results;
        _results = [];
        for (x = _m = 0; 0 <= i ? _m < i : _m > i; x = 0 <= i ? ++_m : --_m) {
          _results.push([Math.max(table[x][j - 1], table[i][0] - table[x][0]), x]);
        }
        return _results;
      })());
      table[i][j] = m[0];
      solution[i - 1][j - 1] = m[1];
    }
  }
  n = n - 1;
  k = k - 2;
  ans = [];
  while (k >= 0) {
    ans = [
      (function() {
        var _m, _ref, _ref1, _results;
        _results = [];
        for (i = _m = _ref = solution[n - 1][k] + 1, _ref1 = n + 1; _ref <= _ref1 ? _m < _ref1 : _m > _ref1; i = _ref <= _ref1 ? ++_m : --_m) {
          _results.push(seq[i]);
        }
        return _results;
      })()
    ].concat(ans);
    n = solution[n - 1][k];
    k = k - 1;
  }
  return [
    (function() {
      var _m, _ref, _results;
      _results = [];
      for (i = _m = 0, _ref = n + 1; 0 <= _ref ? _m < _ref : _m > _ref; i = 0 <= _ref ? ++_m : --_m) {
        _results.push(seq[i]);
      }
      return _results;
    })()
  ].concat(ans);
};

part = function (seq, k) {
  if (k <= 0) {
    return [];
  }
  while (k) {
    try {
      return linear_partition(seq, k--);
    } catch (_error) {}
  }
};
function PhotoGrid(options){
	var defaultOptions = {
		idealHeight: parseInt(window.innerHeight / 3),
		spacer: 10,
		itemClass: 'photo',
		itemTmpl: '<div></div>',
		$container: $('.photo-grid__photos-container'),
		isExcludeScrollBar: true,
		isIgnoreBodyScroll: false,
		$parent: $("body"),
		events: {}
	}
	this.options = $.extend(true,defaultOptions, options);
}
PhotoGrid.prototype = (function(){
	function getScrollBarWidth () {
		var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'),
			widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
		$outer.remove();
		return 100 - widthWithScroll;
	};
	var V_SCROLL_BAR_WIDTH = getScrollBarWidth();
	function createItem(imageInfo){
		var imgHtml = _.template(this.options.itemTmpl)(imageInfo);
		var $item = $(imgHtml);
		// $item.css("background-image", 'url(' + imageInfo.urlSmall + ')');
		$item.width(imageInfo.w);
		$item.height(imageInfo.h);
		$item.css("margin", this.options.spacer);
		$item.addClass(this.options.itemClass);
		return $item.get(0);
	}
	function isScrollBarVisible($elmt){
		if(this.options.$parent.is("body")){
			return $(document).height() > $(window).height();
		}
		return $elmt.get(0).scrollHeight > $elmt.get(0).clientHeight ;
	}
	function renderItem(photo, viewportWidth, summedRatios, rows){
		var imageInfo = {};
		var respect = rows < 1 ? 'height' : undefined;
		var dimension = calculateImageDimension.call(this, viewportWidth, this.options.idealHeight, summedRatios, photo.ar, respect);
		photo.w = dimension.w;
		photo.h = dimension.h;

		var elem =  createItem.call(this, photo);

		if(this.options.events.beforeItemRendered){
			this.options.events.beforeItemRendered(elem, photo);
		}
		this.options.$container.get(0).appendChild(elem);
	}
	function calculateImageDimension(viewportWidth, idealHeight, summedRatios, ar, respect){
		var dimension = {};
		if(respect === "height"){

			dimension.h = idealHeight;
			dimension.w = parseInt(idealHeight * ar - 2*this.options.spacer);
		} else {
			dimension.w = parseInt(viewportWidth/ summedRatios * ar - 2*this.options.spacer);
			dimension.h = parseInt(viewportWidth / summedRatios - 2*this.options.spacer);
		}
		return dimension;
		
	}
	function reset(){
		if(this.options.height){
			this.options.$container.css("height", "auto");
		}
		this.options.$container.empty();
		
	}
	function calculateViewportWidth(photos){
		var self = this;
		var padding = 0;
		try{
			var paddingLeft = self.options.$container.css("padding-left").split("px")[0];
			var paddingRight = self.options.$container.css("padding-right").split("px")[0];
	 		padding = (paddingLeft ? parseInt(paddingLeft) : 0) + (paddingRight ? parseInt(paddingRight) : 0);
		}catch(ex){
			padding = 0;
		}
		var viewportWidth = self.options.$container[0].getBoundingClientRect().width - padding;
		if(viewportWidth < 0 ) return;
		if(isScrollBarVisible.call(this, self.options.$container)){
			if($("body").css("over-flow") === "hidden"){
				return viewportWidth - V_SCROLL_BAR_WIDTH;
			}
			return viewportWidth ;
		}
		var summedRatios;
		var sumHeight = 0;
		var summed_width = photos.reduce((function(sum, p) {
	  		return sum += p.ar * self.options.idealHeight;
		}), 0);
		var rows = Math.round(summed_width / viewportWidth);

		summedRatios = photos.reduce((function(sum, p) {
	  		return sum += p.ar;
		}), 0);
		if(rows < 1){
			sumHeight = parseInt(viewportWidth / summedRatios - 2*this.options.spacer);
		} else{
			var weights = photos.map(function(p) {
				return parseInt(p.ar * 100);
			});
			var partition = part(weights, rows);

			var index = 0;
			var rowBuffer = [];
			var imageInfo = {};
			var rowHeight = 0;
			for (var i = 0; i < partition.length; i++) {
				rowBuffer = [];
				for (var j = 0; j<partition[i].length; j++) {
					rowBuffer.push(photos[index++])
				}
				summedRatios = rowBuffer.reduce((function(sum, p) {
					return sum += p.ar;
				}), 0);
				rowHeight = parseInt(viewportWidth / summedRatios - 2*this.options.spacer) + 2*this.options.spacer;
				sumHeight += rowHeight;
			}
		}
		this.options.$container.append('<div id="pixerf-photo-grid" style="height: ' +  sumHeight  +  'px">' + '</div>');
		if(this.options.height && photos.length > 0){
			this.options.$container.css("height", this.options.height);
		}
		if(isScrollBarVisible.call(this, this.options.$container)){
			$("#pixerf-photo-grid").remove();
			return viewportWidth - V_SCROLL_BAR_WIDTH;
		}
		$("#pixerf-photo-grid").remove();
		// setTimeout(function(){
		// })
		
		return viewportWidth ;
	}
	function generate(photos){
		var self = this;
		var viewportWidth = calculateViewportWidth.call(this, photos);
		var summedRatios;
		var summed_width = photos.reduce((function(sum, p) {
	  		return sum += p.ar * self.options.idealHeight;
		}), 0);
		var rows = Math.round(summed_width / viewportWidth);

		summedRatios = photos.reduce((function(sum, p) {
	  		return sum += p.ar;
		}), 0);
		if(rows < 1){
			// rows = 1;
			for (var i  = 0; i < photos.length; i ++){
				renderItem.call(this, photos[i], viewportWidth, summedRatios, rows);
			}
			return ;
		} 
		var weights = photos.map(function(p) {
			return parseInt(p.ar * 100);
		});
		var partition = part(weights, rows);

		var index = 0;
		var rowBuffer = [];
		var imageInfo = {};
		for (var i = 0; i < partition.length; i++) {
			rowBuffer = [];
			for (var j = 0; j<partition[i].length; j++) {
				rowBuffer.push(photos[index++])
			}
			summedRatios = rowBuffer.reduce((function(sum, p) {
		  		return sum += p.ar;
			}), 0);
			for (var k = 0; k<rowBuffer.length; k++) {
				var photo = rowBuffer[k];
				renderItem.call(this, photo,  viewportWidth, summedRatios, rows);
		  	}
		}
		// setTimeout(function(){
		// 	self.options.$container.css("min-height", '');
		// },0);
	}
	return {
		generate: generate,
		reset: reset
	}
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photoExifInfoCtrl', photoExifInfoCtrl);

	photoExifInfoCtrl.$inject = ['$rootScope', '$scope', 'photoDetailSvc'];

	function photoExifInfoCtrl($rootScope, $scope, photoDetailSvc) {

		var self = this;
		self.buildPhotoReleaseInfo = photoDetailSvc.buildPhotoReleaseInfo;

		init();

		$scope.$on('builtCameraInfo', function () {
			init();
		});

		function init() {
			self.showInfoCamera = !!$scope.media.camera.cameraFormated || !!$scope.media.camera.lens_model || !!$scope.media.camera.takenInfo;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('photoExifInfo', photoExifInfo);

	function photoExifInfo() {

		var directive = {
			scope: {
				"media": "="
			},
			restrict: 'E',
			templateUrl: 'app/components/photo-exif-info/photo-exif-info.html',
			controller: 'photoExifInfoCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .factory('photoDetailPopupSvc', photoDetailPopupSvc);
  photoDetailPopupSvc.$inject = ['$uibModal'];

  function photoDetailPopupSvc($uibModal) {

    var mIsPopupShowing = false;
    var mData = {
      photo: null
    }
    var mOriginalData = {
      photo: null
    }
    var mShouldScrollTop = {
      data: false
    }

    function isShouldScrollTop() {
      return mShouldScrollTop;
    }

    function setShouldSrollTop(value) {
      mShouldScrollTop.data = value
    }

    function isPopupShowing() {
      return mIsPopupShowing;
    }

    function setPopupShowing(value) {
      mIsPopupShowing = value;
    }

    function setData(data) {
      mData.photo = $.extend(true, {}, data.photo);
      mOriginalData.photo = data.photo;
    }

    function getData() {
      if (!mData.photo) return mData;
      // mData.photo = buildPhotoDetail(mData.photo);
      return mData;
    }

    function getOriginalData() {
      return mOriginalData;
    }

    function showPopup(data) {
      setData(data);
      mIsPopupShowing = true;
      var uploadModal = $uibModal.open({
        size: 'full',
        templateUrl: 'app/components/photo-detail-popup/photo-detail-popup.html',
        controller: 'photoDetailPopupCtrl',
        controllerAs: 'vm',
        windowClass: 'modal-margin photo-detail-modal',
        resolve: {
          data: function () {
            return data;
          }
        }
      });
      return uploadModal;
    }

    function updateUI(data) {
      setData(data);
    }
    return {
      showPopup: showPopup,
      isPopupShowing: isPopupShowing,
      setPopupShowing: setPopupShowing,
      updateUI: updateUI,
      getData: getData,
      getOriginalData: getOriginalData,
      setShouldSrollTop: setShouldSrollTop,
      isShouldScrollTop: isShouldScrollTop,
    };
  }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photoDetailPopupCtrl', photoDetailPopupCtrl);

	photoDetailPopupCtrl.$inject = ['$scope', 'photoDetailPopupSvc', 'sessionManagerSvc', '$uibModalInstance', 'commonConst', '$timeout', 'data', 'photoDetailSvc', 'messageSvc'];

	function photoDetailPopupCtrl($scope, photoDetailPopupSvc, sessionManagerSvc, $uibModalInstance, commonConst, $timeout, data, photoDetailSvc, messageSvc) {
		var self = this;
		self.photoViewer = {};
		self.context = data.context;
		self.closePopup = closePopup;
		self.onDeletePhotoBtnClicked = onDeletePhotoBtnClicked;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.data = photoDetailPopupSvc.getData();
		self.originalData = photoDetailPopupSvc.getOriginalData();
		self.isEditing = {
			data: data.isEditing || false
		};
		self.onSaved = onSaved;
		self.shouldScrollTop = photoDetailPopupSvc.isShouldScrollTop();
		$scope.$on('modal.closing', closeConfirm);

		function onDeletePhotoBtnClicked(photo) {
			$timeout(function () {
				$uibModalInstance.close({
					'action': commonConst.ACTION.DELETE,
					'photo': photo
				}, 2000);
			})
		}

		function onSaved(savedPhoto) {
			if (data.onPhotoPopupSaved) {
				data.onPhotoPopupSaved({
					originalFile: self.originalData.photo,
					newFile: savedPhoto
				});
			}
			self.originalData.photo.title = savedPhoto.title;
			self.originalData.photo.tags = savedPhoto.tags;
			self.originalData.photo.galleries = savedPhoto.galleries;
			self.originalData.photo.categories = savedPhoto.categories;
			self.originalData.photo.price = savedPhoto.price;
			self.originalData.photo.license = savedPhoto.license;
			self.originalData.photo.description = savedPhoto.description;
			self.originalData.photo.location = savedPhoto.location;
			self.originalData.photo.has_model_property = savedPhoto.has_model_property;
			self.originalData.photo.releases = savedPhoto.releases;
			self.originalData.photo.is_releasable = savedPhoto.is_releasable;
			self.originalData.photo.status = savedPhoto.status;
			self.originalData.photo.state = savedPhoto.state;
			self.originalData.photo.rotate_by = savedPhoto.rotate_by;
			self.originalData.photo.user_selection = savedPhoto.user_selection;
		}

		function closePopup() {
			$uibModalInstance.close('close button click');
		}

		function updateInstanceUpdateField() {
			var fields = ["star_count", "is_liked", "is_starred", "state", "status"];
			for (var i = 0; i < fields.length; i++) {
				if (self.originalData.photo[fields[i]] !== self.data.photo[fields[i]]) {
					self.originalData.photo[fields[i]] = self.data.photo[fields[i]];
				}
			}
			if (self.originalData.photo && self.originalData.photo.mission && self.data.photo && self.data.photo.mission) {
				self.originalData.photo.mission.prizes_grouped = self.data.photo.mission.prizes_grouped;
			}
		}

		function closeConfirm(uploadPhotoClosingEvent, reason, closed) {
			if (reason === 'close button click' || reason === 'backdrop click') {
				uploadPhotoClosingEvent.preventDefault();
				if (photoDetailSvc.isEdited(self.originalData.photo, self.data.photo, self.photoViewer, self.isEditing.data)) {
					var modal = messageSvc.warnLeavingWithoutSaving();
					modal.result.then(function () {
						window.removeEventListener("beforeunload", beforeUnloadHandler);
						$uibModalInstance.dismiss();
						modal.close();
					})
				} else {
					$uibModalInstance.dismiss();
				}
			}
		}

		function beforeUnloadHandler(event) {
			var confirmationMessage = "Are you sure?";
			if (photoDetailSvc.isEdited(self.originalData.photo, self.data.photo, self.photoViewer, self.isEditing.data)) {
				event.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
				return confirmationMessage;
			}
		}
		window.addEventListener("beforeunload", beforeUnloadHandler);
		$uibModalInstance.result.then(function () {
			window.removeEventListener("beforeunload", beforeUnloadHandler);
			updateInstanceUpdateField();
			photoDetailPopupSvc.setPopupShowing(false);
			photoDetailPopupSvc.setShouldSrollTop(false);
			if (data.onPhotoPopupClosed) {
				data.onPhotoPopupClosed({
					originalFile: self.originalData.photo,
					newFile: self.data.photo
				});
			}
		}, function () {
			window.removeEventListener("beforeunload", beforeUnloadHandler);
			updateInstanceUpdateField();
			photoDetailPopupSvc.setShouldSrollTop(false);
			photoDetailPopupSvc.setPopupShowing(false);
			if (data.onPhotoPopupClosed) {
				data.onPhotoPopupClosed({
					originalFile: self.originalData.photo,
					newFile: self.data.photo
				});
			}
		})
	}
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoDetailSvc', photoDetailSvc);
    photoDetailSvc.$inject = ['stringUtils', 'tagUtils', 'numberUtils', 'arrayUtils', 'systemUtils'];

    function photoDetailSvc(stringUtils, tagUtils, numberUtils, arrayUtils, systemUtils){
        
        var PHOTO_DETAIL_MOBILE_SCREEN =  768;
        function buildTakenInfo(cameraDetails){
            if(cameraDetails){
                if(cameraDetails.model && cameraDetails.model.indexOf(cameraDetails.make) === -1){
                    cameraDetails.cameraFormated = cameraDetails.make + " " + cameraDetails.model;
                } else {
                    cameraDetails.cameraFormated = cameraDetails.model;
                }
                cameraDetails.takenInfo = "";
                if(cameraDetails.focal_length){
                    cameraDetails.takenInfo += (' ' + stringUtils.buildString(numberUtils.fraction2Decimal(cameraDetails.focal_length)) + " mm");
                }
                if(cameraDetails.f_number){
                    cameraDetails.takenInfo += (' f/' + stringUtils.buildString(numberUtils.fraction2Decimal(cameraDetails.f_number)));
                }
                if(cameraDetails.exposure_time){
                    cameraDetails.takenInfo += (' ' + stringUtils.buildString(cameraDetails.exposure_time) + ' sec') ;
                }
                if(cameraDetails.iso){
                    cameraDetails.takenInfo += (' ISO ' + stringUtils.buildString(cameraDetails.iso));
                }
            }

        }
        function buildPhotoReleaseInfo(photo){
            if(photo.license === "editorial" || (photo.license === "commercial" && !photo.has_model_property)){
                return "No release required";
            } else if(photo.license === "commercial" && photo.has_model_property && photo.status === "approved"){
                return "Model/Property released";
            } else if(photo.license === "commercial" && photo.has_model_property && photo.status !== "approved"){
                return "Pending approval";
            }
            return "No release information";
        }
        function buildPhotoDetail(photo){
            if(!photo) return photo;
            if(photo.tags && photo.tags.length > 0 && typeof photo.tags[0] !== 'object'){
                photo.tags = tagUtils.text2TagObject(photo.tags);
            }
            if(photo.location){
                photo.location = photo.location ? photo.location : "Not Available";
            }
            if(photo.camera){
                photo.camera.imageCapturedDateFormated = photo.camera.date_taken ? moment(photo.camera.date_taken).format('DD MMMM YYYY') : "Not Available";
                photo.createdAtFormated = photo.inserted_at ? moment(photo.inserted_at).format('DD MMMM YYYY') : "Not Available";
                buildTakenInfo(photo.camera);
            }
            return photo;
        }
        function buildSocialShareContent(photo){
            return {'url': photo.path, 'description': photo.description, 'title': photo.title, 'media': photo.url };
        }
        function calculateSubTotal(photo){
            var subTotal = 0;
            for (var i = 0; i < photo.price.range.length; i ++){
                if(photo.price.range[i].isSelected){
                    subTotal += parseInt(photo.price.range[i].price);
                }
            }
            if(photo.extendedLicenses){
                for (var i = 0; i < photo.extendedLicenses.length; i ++){
                    if(photo.extendedLicenses[i].isSelected){
                        subTotal += parseInt(photo.extendedLicenses[i].price);
                    }
                }
            }
            return subTotal;
        }
        function isEdited(originalPhoto, editingPhoto, photoViewer, isEditing){
            if(!originalPhoto && !editingPhoto) return false;
            if(photoViewer && photoViewer.originRotateStep != photoViewer.rotateStep) return true;
            if(isEditing){
                return isPhotoDirty(originalPhoto, editingPhoto);
            }
            return false;
        }
        function isTagsEdited(originalPhoto, editingPhoto){
            editingPhoto.clarifai = editingPhoto.clarifai || [];
            if(!originalPhoto.tags || originalPhoto.tags.length === 0){
                return !arrayUtils.isEqual(editingPhoto.clarifai, editingPhoto.tags, "text", "text");
            }
            return !arrayUtils.isEqual(originalPhoto.tags, editingPhoto.tags, "text", "text");
        }
        function isPhotoDirty(originalPhoto, editingPhoto){
            return  !stringUtils.isEqual(originalPhoto.title, editingPhoto.title) ||
            isTagsEdited(originalPhoto, editingPhoto) ||
            originalPhoto.license != editingPhoto.license ||
            !stringUtils.isEqual(originalPhoto.description, editingPhoto.description) ||
            !stringUtils.isEqual(originalPhoto.location, editingPhoto.location) ||
            originalPhoto.has_model_property != editingPhoto.has_model_property ||
            !arrayUtils.isEqual(originalPhoto.releases, editingPhoto.releases, "id", "id") ||
            originalPhoto.rotate_by != editingPhoto.rotate_by ||
            !arrayUtils.isEqual(originalPhoto.galleries, editingPhoto.galleries, "id", "id") ||
            !arrayUtils.isEqual(originalPhoto.categories, editingPhoto.categories, "id", "id") ||
            (originalPhoto.price.id !== editingPhoto.price.id && originalPhoto.price.value !== editingPhoto.price.value);
        }
        var mOriginalPhoto = {
            data: null
        };
        var mPhoto = {
            data: null
        }
        function setOriginalPhoto(value) {
            mOriginalPhoto.data = value;
        }
        function getOriginalPhoto() {
            return mOriginalPhoto;
        }
        function setPhoto(value) {
            mPhoto.data = value;
        }
        function getPhoto() {
            return mPhoto;
        }
        function discardChanges(photo, originalPhoto){
            photo = originalPhoto;
            setPhoto(originalPhoto);
        }
        function reset(){
            setPhoto(null);
            setOriginalPhoto(null);
        }
        function buildPhotoKeyword(file, clarifai){
            file.tags = file.tags || [];
            file.suggestedKeywords = [];
            file.originalSuggestedKeywords = clarifai;
            var nNumberTags = file.tags.length;
            for(var i = 0; i < clarifai.length; i++){
                if(nNumberTags > 0){
                    var isExisted = _.find(file.tags, function(t){
                        return t.text === clarifai[i];
                    })
                    if(!isExisted){
                        file.suggestedKeywords.push(clarifai[i]);
                    }
                } else {
                    file.tags.push({text: clarifai[i]});
                }
                
            }
        }
        function isMobile(){
            return systemUtils.getViewportDimension().width  < PHOTO_DETAIL_MOBILE_SCREEN;
        }
		return {
            buildPhotoDetail: buildPhotoDetail,
            buildSocialShareContent: buildSocialShareContent,
            calculateSubTotal: calculateSubTotal,
            buildPhotoReleaseInfo: buildPhotoReleaseInfo,
            isPhotoDirty: isPhotoDirty,
            isEdited: isEdited,
            getOriginalPhoto: getOriginalPhoto,
            setOriginalPhoto: setOriginalPhoto,
            setPhoto: setPhoto,
            getPhoto: getPhoto,
            discardChanges: discardChanges,
            reset: reset,
            buildPhotoKeyword: buildPhotoKeyword,
            isMobile: isMobile
		};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photoDetailCtrl', photoDetailCtrl);

	photoDetailCtrl.$inject = ['$state', 'photoSvc', 'editCartBtnSvc', 'gallerySvc', 'cartUtils', 'cartSvc', 'messageConst', 'pixerfApiUserSvc', 'uploadPhotoDetailSvc', 
		'photoDetailSvc', '$scope', 'sessionManagerSvc', 'pixerfApiMediaSvc', 'pixerfApiCategorySvc', 'toastr', '$timeout', 'fileUtils', '$uibModalStack', 
		'messageSvc', '$translate', '$rootScope', 'pixerfApiDownloadSvc', 'pixerfUrl', 'FileSaver', '$http', 'addToCartBtnSvc', 'popoverCartSvc', 'store', 'accountConst'];

	function photoDetailCtrl($state, photoSvc, editCartBtnSvc, gallerySvc, cartUtils, cartSvc, messageConst, pixerfApiUserSvc, uploadPhotoDetailSvc, 
			photoDetailSvc, $scope, sessionManagerSvc, pixerfApiMediaSvc, pixerfApiCategorySvc, toastr, $timeout, fileUtils, $uibModalStack, 
			messageSvc, $translate, $rootScope, pixerfApiDownloadSvc, pixerfUrl, FileSaver, $http, addToCartBtnSvc, popoverCartSvc, store, accountConst) {
		var self = this;
		self.originalPhoto = photoDetailSvc.getOriginalPhoto();
		self.onSaveChangesBtnClicked = onSaveChangesBtnClicked;
		self.onNominateBtnClicked = onNominateBtnClicked;
		self.onEditBtnClicked = onEditBtnClicked;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.formError = null;
		self.isSaving = false;
		self.socialShareContent = photoDetailSvc.buildSocialShareContent($scope.photo);
		self.onCancelPhotoBtnClicked = onCancelPhotoBtnClicked;
		self.photoGrid = null;
		self.onPhotoGridInit = onPhotoGridInit;
		self.callToActionMesages = [];
		self.onGalleryItemClicked = onGalleryItemClicked;
		self.formatLicenseString = formatLicenseString;
		self.privateToolTip = "You haven't set price for this photo. Without prices, your photos won't be discoverable on the Marketplace.";
		self.onVariantSelected = onVariantSelected;
		self.onAddedToCart = onAddedToCart;
		self.onTagClicked = onTagClicked;
		self.onPhotoRotated = onPhotoRotated;
		self.onDownloadComp = onDownloadComp;
		self.cartItem = {};
		self.cart = cartSvc.getCart();
		self.isWorking = false;
		self.context = $scope.context;
		self.categories = {
			data: []
		};
		self.showAddToCart = !($scope.photo.type === 'portfolio' || $scope.photo.type === 5 || $scope.photo.isMine || $scope.photo.in_mission);
        self.onAddToCartBtnClicked = onAddToCartBtnClicked;
        self.isAddedToCart = cartSvc.getCartItemByMediaId(self.cart.data, $scope.photo.id) ? true: false;
		self.showShareBtn = (!self.loginnedUser || (self.loginnedUser && !self.loginnedUser.isBiz));

		init();
		getCategories();
		buildToolTipsText();

		self.onItemImageLoadHandler = {
			sucess: function (element) {
				var $img = $(".content-wrapper").find("img");
				self.originalPhotoDemission = {
					width: $img.width(),
					height: $img.height(),
				};
				overlayScale(self.originalPhotoDemission.width, self.originalPhotoDemission.height);
			}
		}

		$scope.$watchCollection("vm.cart.data.cart_items", function (newValue) {
			var foundItem = _.find(newValue, function (item) {
				return item.media.id === self.cartItem.media.id;
			})
			if (!foundItem) {
				delete self.cartItem.id;
			} else {
				self.cartItem.id = foundItem.id;
			}
		})

		function onTagClicked(tag) {
			var param = {};
			if (tag) {
				$uibModalStack.dismissAll("link clicked");
				$timeout(function () {
					param.keywords = '' + tag.text;
					param.type = 'images';
					// $state.go('buy-stock-page.search-result-page', param);
					var url = 'https://pixerf.com/#/buy-stock-page/search-result-page?keywords=' + param.keywords + '&type=images';
					window.open(url, '_blank');
				})
			}
		}

		function buildToolTipsText() {
			if (self.loginnedUser) {
				if (self.loginnedUser.stats.daily_nomination_balance === 1) {
					self.tooltips = {
						nomination: $translate.instant('have-one-nomination-remaning')
					}
				} else {
					self.tooltips = {
						nomination: $translate.instant('have-more-nominations-remaning', {
							number: self.loginnedUser.stats.daily_nomination_balance
						})
					}
				}
			}

			if ($scope.photo.is_nominated) {
				self.tooltips.nomination = $translate.instant('you-have-nominated') + '<br/>' + self.tooltips.nomination;
			}
		}

		function getCategories() {
			pixerfApiCategorySvc.get(function (response) {
				self.categories.data = response;
			}, function () {
				toastr.error($translate.instant('failed-to-get-categories'));
			});
		}

		function fetchPhotos(isRefresh) {
			self.photoGrid.fetchPhotos({
				mediaid: $scope.photo.id,
				action: 'more'
			}, isRefresh);
		}

		function onCancelPhotoBtnClicked() {
			setPhoto(self.originalPhoto.data);
			$scope.isEditMode.data = false;
		}

		function onGalleryItemClicked(file, gallery) {
			self.isSaving = true;
			var action = gallery.isSelected ? "addPhotoToGallery" : "removePhotoToGallery";
			photoSvc[action](file, gallery).then(function (response) {
				gallerySvc.updateGalleryCover(gallery);
				var message = messageSvc.compile(messageConst.success.PHOTO_GALLERY_ADDED_REMOVED, {
					action: action,
					gallery_name: gallery.title
				});
				toastr.success(message);
				photoDetailSvc.setOriginalPhoto($.extend(true, {}, $scope.photo));
				$timeout(function () {
					self.isSaving = false;
					$scope.onSaved({
						savedPhoto: $scope.photo
					});
				}, 2000);
			}, function () {
				self.isSaving = false;
			})
		}

		function onPhotoRotated() {
			$scope.onSaved({
				savedPhoto: $scope.photo
			});
		}

		function onDownloadComp(item) {
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;
			pixerfApiDownloadSvc.record_biz_download({}, {
				media_id: item.id
			}).$promise.then(function () {
				self.isWorking = false;
				var urlImage = item.thumbnails['w/866x'].replace("http", "https");
				return $http.get(urlImage, {
					responseType: 'blob'
				});
			}).then(function (response) {
				self.isWorking = false;
				var getFile = item.filename.split(".");
				var filename = item.user.displayName + "-" + item.id + "-" + item.license + "-license." + getFile[1];
				FileSaver.saveAs(response.data, filename);
			}).catch(function () {
				self.isWorking = false;
			})
		}

		function updatePhoto() {
			return pixerfApiMediaSvc.update({
				id: $scope.photo.id
			}, fileUtils.buildSavedFileObject($scope.photo)).$promise;
		}

		function overlayScale(width, height) {
			var $overlay = $(".photo-detail__overlay");
			$overlay.width(width);
			$overlay.height(height);
			self.isWorking = false;
		}

		function onSaveChangesBtnClicked() {
			self.isFormDirty = true;
			if (self.formError) {
				toastr.error(self.formError);
				return false;
			}
			var errorMsg = uploadPhotoDetailSvc.validate([$scope.photo]);

			if (errorMsg) {
				//self.pixerfAlert.error(errorMsg);
				toastr.error(errorMsg);
				return false;
			}
			self.isSaving = true;
			updatePhoto().then(function (response) {
				photoDetailSvc.setOriginalPhoto($.extend(true, {}, $scope.photo));
				$timeout(function () {
					self.isSaving = false;
					$scope.photo.location = response.location;
					$scope.photo.is_releasable = response.is_releasable;
					$scope.photo.status = response.status;
					$scope.isEditMode.data = false;
					self.socialShareContent = photoDetailSvc.buildSocialShareContent($scope.photo);
					self.callToActionMesages = uploadPhotoDetailSvc.buildCallToActionMessages($scope.photo);
					$scope.onSaved({
						savedPhoto: $scope.photo
					});
					toastr.success("This photo has been successfully updated!");
					updateUI($scope.photo, $scope.photo);
				}, 2000);
			}, function (response) {
				self.isSaving = false;
				var msg =  "Oops! Looks like something went wrong. Please try again!";
				if (response.data.errors && response.data.errors.length > 0) {
					var mappedMessage = messageConst.error[response.data.errors[0]];
					if (mappedMessage) {
						msg = mappedMessage;
					}
				}
				toastr.error(msg);
			})
		}

		function getFollowingStatus(photo) {
			pixerfApiUserSvc.isFollowed({
				id: photo.user.id
			}).$promise.then(function (response) {
				photo.user.is_followed = response.data
			}, function () {

			})
		}

		function setSelectedVariant(photo, cartItem) {
			if (cartItem) {
				self.cartItem = cartItem;
				self.cartItem.media.data = photo;
			} else {
				self.cartItem = {
					media: {
						id: photo.id,
						price: $.extend(true, {}, photo.price),
						data: photo
					}
				};
				self.cartItem.sub_total = 0;
				cartUtils.updateCartSelectedVariant(self.cartItem, {})
			}
		}

		function onPhotoGridInit(photoGridIntance) {
			self.photoGrid = photoGridIntance;
			if (self.photoGrid) {
				fetchPhotos(true);
			}
		}

		function updateUI(newValue, oldValue) {
			if (!$scope.photo) return;
			if (!oldValue) return;
			var isRefresh = true;

			var cartItem = cartSvc.getCartItemByMediaId(self.cart.data, newValue.id);
			setSelectedVariant(newValue, cartItem);

			photoDetailSvc.setPhoto($scope.photo);
			photoDetailSvc.setOriginalPhoto($.extend(true, {}, newValue));
			photoDetailSvc.buildPhotoDetail($scope.photo);
			$rootScope.$broadcast('builtCameraInfo');
			self.callToActionMesages = uploadPhotoDetailSvc.buildCallToActionMessages($scope.photo);
			if (!$scope.photo.isMine && self.loginnedUser) {
				getFollowingStatus($scope.photo);
			}
			if (self.photoGrid) {
				fetchPhotos(isRefresh);
			}
		}

		function init() {
			$scope.$watch("photo", function (newValue, oldValue) {
				updateUI(newValue, oldValue);
			})
			if ($scope.photo && $scope.photo.participation) {
				self.context += "-" + $scope.photo.participation.id;
			}
		}

		function onNominateBtnClicked() {
			if (self.loginnedUser.stats.daily_nomination_balance <= 0 || $scope.photo.isNominating || $scope.photo.is_nominated) {
				return;
			}
			$scope.photo.isNominating = true;
			pixerfApiMediaSvc.nominate({
				id: $scope.photo.id
			}).$promise.then(function (response) {
				self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
				delete $scope.photo.isNominating;
				$scope.photo.is_nominated = true;
				$scope.photo.nomination_count++;
				self.loginnedUser.stats.daily_nomination_balance--;
				sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
				buildToolTipsText();
			}, function (response) {
				delete $scope.photo.isNominating;
				if (response.data && response.data.message) {
					toastr.error(response.data.message);
				} else {

					toastr.error("Failed to nominate photo!");
				}
			})
		}

		function formatLicenseString(license) {
			if (!license) return 'Editorial';
			return license.charAt(0).toUpperCase() + license.substr(1);
		}

		function onVariantSelected(evt, price) {
			self.cartItem.sub_total = photoDetailSvc.calculateSubTotal(self.cartItem.media);

			if (self.cartItem.id && evt) {
				editCartBtnSvc.editCartItem(self.cartItem).then(function () {
					self.isCartItemDisabled = false;
				}, function () {
					self.isCartItemDisabled = false;
				});
			}
		}

		function onAddedToCart(addedCartItem) {
			self.cartItem.id = addedCartItem.id;
		}

		function setPhoto(value) {
			$scope.photo = value;
			photoDetailSvc.setPhoto(value);
		}

		function onEditBtnClicked() {
			$scope.isEditMode.data = !$scope.isEditMode.data;
			photoDetailSvc.setOriginalPhoto($.extend(true, {}, $scope.photo));
			if (!$scope.photo.clarifai || ($scope.photo.clarifai && $scope.photo.clarifai.length === 0)) {
				if (self.isLoadingClarifai) return;
				self.isLoadingClarifai = true;
				pixerfApiMediaSvc.get_clarifai({
					id: $scope.photo.id
				}).$promise.then(function (response) {
					$scope.photo.clarifai = response.data;
					photoDetailSvc.buildPhotoKeyword($scope.photo, response.data);
					self.isLoadingClarifai = false;
				}, function () {
					self.isLoadingClarifai = false;
				})
			} else {
				photoDetailSvc.buildPhotoKeyword($scope.photo, $scope.photo.clarifai);
			}
		}
		function onAddToCartBtnClicked(media){
			if(self.isWorking || self.isAddedToCart) return;
            self.isWorking = true;

			(self.loginUser) ? onAddToCartForLoggedUser(media) :  onAddToCartForGuestUser(media);
		}
		function onAddToCartForLoggedUser(media){
            var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media, true);
            console.log(savedCartItemData);
            var errMsg = addToCartBtnSvc.validate(savedCartItemData);
            if(errMsg){
                toastr.error(errMsg)
            };

            var action = "addItemToCart";
            cartSvc[action](savedCartItemData).then(function(response){
                self.isWorking = false;
                self.isAddedToCart = true;
                var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
                self.cartItem.id = addedCartItem.id
            }).catch(function(err){
                self.isWorking = false;
                var message =  "Oops! Looks like something went wrong. Please try again!";
                if(err.data && err.data.message === "MEDIA_IN_MISSION"){
                    message = messageSvc.compile(messageConst.error.MISSION_CART, {photo_name: ": " + media.data.title , quantity: 1});
                    media.data.in_mission = true;
                }
                toastr.error(message);
            });
        }

		function onAddToCartForGuestUser(media) {
            var guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
            if(guestUserToken){
                processAddToCard(guestUserToken, media);
            }else{
                cartSvc.generateUUID(10, processAddToCard, media);
            }

            function processAddToCard(uuid, media) {
                if( !store.get(accountConst.TOKEN.GUEST_USER_TOKEN)){
                    store.set(accountConst.TOKEN.GUEST_USER_TOKEN, uuid);
                }
                
                var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media, true);
                console.log(savedCartItemData);
                var errMsg = addToCartBtnSvc.validate(savedCartItemData);
                if (errMsg) toastr(errMsg);

                var action = "addItemToCart";
                cartSvc[action](savedCartItemData, uuid).then(function (response) {
                    self.isWorking = false;
                    self.isAddedToCart = true;
                    var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
                    self.cartItem.id = addedCartItem.id
                }).catch(function (err) {
                    self.isWorking = false;
                    var message =  "Oops! Looks like something went wrong. Please try again!";
                    if (err.data && err.data.message === "MEDIA_IN_MISSION") {
                        message = messageSvc.compile(messageConst.error.MISSION_CART, { photo_name: ": " + media.data.title, quantity: 1 });
                        media.data.in_mission = true;
                    }
                    toastr.error(message);
                });
            }
        }
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoDetail', photoDetail);
  photoDetail.$inject = ['systemUtils', 'photoDetailSvc']
  function photoDetail(systemUtils, photoDetailSvc) {

    var directive = {
      scope: {
          'onPhotoDeleted' :'&',
          'photo': '=',
          'context': '=',
          'onSaved' : '&',
          'nextPhoto': '=',
          'prevPhoto': '=',
          'alert': "=",
          "isEditMode": "=",
          "photoViewer": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/photo-detail/photo-detail.html',
      controller: 'photoDetailCtrl',
      controllerAs: 'vm',
      replace: true,
      link: function($scope, $element){
        $scope.isMobile = photoDetailSvc.isMobile();
      }
    };
    return directive;
  }

})();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .factory('photoSvc', photoSvc);

  photoSvc.$inject = ['pixerfApiMediaSvc', '$q', 'toastr', 'dateUtils', 'pixerfApiMissionSvc', 'pixerfApiMediaDetailSvc'];

  function photoSvc(pixerfApiMediaSvc, $q, toastr, dateUtils, pixerfApiMissionSvc, pixerfApiMediaDetailSvc) {
    function updateFileGalleriesInfo(file, gallery) {
      if (!file.galleries) {
        file.galleries = [];
      }
      if (gallery.isSelected) {
        file.galleries.push(gallery);
      } else {
        file.galleries = _.reject(file.galleries, function (gal) {
          return gal.id === gallery.id;
        })
      }
    }
    function isUploadedThisWeek(photo) {
      return dateUtils.isInWeek(photo.inserted_at);
    }
    function addPhotoToGallery(file, gallery) {
      var def = $q.defer();
      pixerfApiMediaSvc.add_to_gallery({
        id: file.id,
        gallery_id: gallery.id
      }, {}).$promise.then(function () {
        def.resolve();
        updateFileGalleriesInfo(file, gallery);
      }, function (err) {
        gallery.isSelected = !gallery.isSelected;
        def.reject(err);
        if (err.data.message) {
          toastr.error(err.data.message);
        } else {
          toastr.error("Oops looks like something went wrong");
        }
      });
      return def.promise;

    }
    function removePhotoToGallery(file, gallery) {
      var def = $q.defer();
      pixerfApiMediaSvc.remove_from_gallery({
        id: file.id,
        gallery_id: gallery.id
      }, {}).$promise.then(function () {
        def.resolve();
        updateFileGalleriesInfo(file, gallery);
      }, function () {
        gallery.isSelected = !gallery.isSelected;
        def.reject();
      });
      return def.promise;
    }
    function likePhoto(file) {
      var action = file.is_liked ? 'delete' : 'save';
      return pixerfApiMediaSvc[action]({ id: file.id, action: 'likes' }, {}).$promise;
    }
    function transitState(file, state, reason, rejectionTimes, missionId) {
      var params = {
        'state': state,
        'reason': reason
      };
      if(rejectionTimes){
        params.rejected_at = moment().unix();
      }
      if(file.in_mission && missionId){
        params.mission_id = missionId || file.mission_id;
      }
      return pixerfApiMediaSvc.update({ id: file.id, action: 'state' }, params).$promise;
    }

    function curationMission(action, reason, rejectionTimes, missionId, participationsId){
      var params = {
        'action': action
      };
      if(reason){
        params.reason = reason;
      }
      if(rejectionTimes){
        params.rejected_at = moment().unix();
      }
      return pixerfApiMissionSvc.curation_mission({ mission_id: missionId, participations_id: participationsId }, params).$promise;
    }

    function updatePhotoInfo(photo, override) {
      var defer = $q.defer();
      pixerfApiMediaDetailSvc.get({ id: photo.id }).$promise.then(function (response) {
        for (var key in response.data) {
          photo[key] = response.data[key];
        }
        defer.resolve();
      }, function (err) {
        if (err.status === 404) {
          toastr.error("Sorry, we cannot find this photo. It may not exist any more.");
        } else {
          toastr.error("Oops looks like something went wrong");
        }
        defer.reject();
      })
      return defer.promise;
    }
    return {
      addPhotoToGallery: addPhotoToGallery,
      removePhotoToGallery: removePhotoToGallery,
      likePhoto: likePhoto,
      transitState: transitState,
      curationMission: curationMission,
      updatePhotoInfo: updatePhotoInfo,
      updateFileGalleriesInfo: updateFileGalleriesInfo,
      isUploadedThisWeek: isUploadedThisWeek
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('photoCtrl', photoCtrl);

  photoCtrl.$inject = ['photoDetailSvc', '$scope', 'photoSvc', 'toastr', 'pixerfConfirmPopupSvc', 'sessionManagerSvc', 'photoDetailPopupSvc',
    'commonConst', '$state', 'pixerfApiMediaSvc', 'cartSvc', 'cartUtils', 'store', 'accountConst', 'addToCartBtnSvc', 'messageConst', 'messageSvc'
  ];

  function photoCtrl(photoDetailSvc, scope, photoSvc, toastr, pixerfConfirmPopupSvc, sessionManagerSvc, photoDetailPopupSvc,
    commonConst, $state, pixerfApiMediaSvc, cartSvc, cartUtils, store, accountConst, addToCartBtnSvc, messageConst, messageSvc) {
    var self = this;
    self.displaySize = scope.displaySize ? scope.displaySize : 'urlSmall';
    self.imageUrl = '"' + scope.file.thumbnails['x400'] + '"';
    self.likePhotoBtnClick = likePhotoBtnClick;
    self.removePhotoFromGallery = removePhotoFromGallery;
    self.onAddToCartBtnClicked = onAddToCartBtnClicked;
    self.isLogined = !!sessionManagerSvc.getCurrentLoginUser().data;
    self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
    self.guestUser = self.loginUser && !self.loginUser.account_type;
    self.adminInternal = self.loginUser && (self.loginUser.isAdminInternal || self.loginUser.isCurator);
    self.onPhotoClicked = onPhotoClicked;
    self.socialShareContent = scope.file ? photoDetailSvc.buildSocialShareContent(scope.file) : {};
    self.clickOutSide = clickOutSide;
    self.isPortfolioPhoto = (scope.file.type === 'portfolio' || scope.file.type === 5);
    self.onDeletePhoto = onDeletePhoto;
    self.isDeletedPhoto = false;
    self.showAddToCart = !(scope.file.type === 'portfolio' || scope.file.type === 5 || scope.file.isMine || scope.file.in_mission);
    self.isFlaggedUser = isFlaggedUser;
    self.cart = cartSvc.getCart();
    self.isAddedToCart = cartSvc.getCartItemByMediaId(self.cart.data, scope.file.id) ? true : false;

    self.photoStateBtnOptions = {
      isRejectedState: (scope.options ? scope.options.isRejectedState : null)
    };

    scope.$on(messageConst.BROADCAST.UPDATED_CART, function (event, args) {
      self.isAddedToCart = cartSvc.getCartItemByMediaId(self.cart.data, scope.file.id) ? true : false;
    })

    function isFlaggedUser() {
      var result = false;

      if (!self.adminInternal || !(scope.flaggedUsers && scope.flaggedUsers.length) || !scope || !scope.file || !scope.file.user) {
        return result;
      }
      var flaggedUserIds = _.pluck(scope.flaggedUsers, "id");
      result = _.contains(flaggedUserIds, scope.file.user.id);
      return result;
    }

    function clickOutSide($event) {
      $("body").trigger("click");
      $event.stopPropagation();
    }

    function likePhotoBtnClick(file) {
      if (file.isLiking) return;
      file.isLiking = true;
      photoSvc.likePhoto(file).then(function (response) {
        delete file.isLiking;
        file.is_liked = !file.is_liked;
      }, function () {
        delete file.isLiking;
      })
    }

    function removePhotoFromGallery(file, gallery) {
      var modal = pixerfConfirmPopupSvc.showPopup({
        message: 'Hi, This photo will be removed from this gallery.'
      });
      modal.result.then(function () {
        photoSvc.removePhotoToGallery(file, gallery).then(function () {
          file.galleries = _.reject(file.galleries, function (gl) {
            return gl.id === gallery.id;
          })
          scope.onFileRemoved({
            file: file
          });
        }, function () {
          toastr.error("Cannot " + (isRemove ? 'remove' : 'add') + " this photo to gallery. Please try again.");
        })
      }, function () {
        //do nothing
      })
    }

    function onDeletePhoto() {
      var message = "Do you want to delete this photo";
      var modal = pixerfConfirmPopupSvc.showPopup({
        hideTitle: true,
        hideConfirmText: true,
        message: message
      });

      modal.result.then(function () {
        pixerfApiMediaSvc.delete({
          id: scope.file.id
        }).$promise.then(function success(res) {
            // scope.onFileRemoved({file: scope.file});
            self.isDeletedPhoto = true;
            toastr.success("successfully deleted");
          },
          function error(err) {
            toastr.error("Failed to delete photo!");
          })
      })
    }

    function onAddToCartBtnClicked(media) {
      if (self.isWorking) return;
      if (self.isAddedToCart) {
        var cartItem = cartSvc.getCartItemByMediaId(self.cart.data, media.id);
        if (!cartItem) return;
        self.isWorking = true;
        cartSvc.removeItemFromCart(cartItem).then(function (response) {
          self.isWorking = false;
        }, function () {
          self.isWorking = false;
        });
      } else {
        self.isWorking = true;
        photoSvc.updatePhotoInfo(media).then(function () {
          self.isWorking = false;
          var cartItem = cartSvc.getCartItemByMediaId(self.cart.data, media.id);
          setSelectedVariant(media, cartItem);
          (self.loginUser) ? onAddToCartForLoggedUser(media): onAddToCartForGuestUser(media);
        }, function () {
          self.isWorking = false;
        });
      }
    }

    function onAddToCartForLoggedUser(media) {
      var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media, true);
      var errMsg = addToCartBtnSvc.validate(savedCartItemData);
      if (errMsg) {
        toastr.error(errMsg)
      };
      var action = "addItemToCart";
      cartSvc[action](savedCartItemData).then(function (response) {
        self.isWorking = false;
        self.isAddedToCart = true;
        var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
        self.cartItem.id = addedCartItem.id;
      }).catch(function (err) {
        self.isWorking = false;
        var message = "Oops! Looks like something went wrong.";
        if (err.data && err.data.message === "MEDIA_IN_MISSION") {
          message = messageSvc.compile(messageConst.error.MISSION_CART, {
            photo_name: ": " + media.data.title,
            quantity: 1
          });
          media.data.in_mission = true;
        }
        toastr.error(message);
      });
    }

    function onAddToCartForGuestUser(media) {
      var guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
      if (guestUserToken) {
        processAddToCard(guestUserToken, media);
      } else {
        cartSvc.generateUUID(10, processAddToCard, media);
      }

      function processAddToCard(uuid, media) {
        if (!store.get(accountConst.TOKEN.GUEST_USER_TOKEN)) {
          store.set(accountConst.TOKEN.GUEST_USER_TOKEN, uuid);
        }

        var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media, true);
        var errMsg = addToCartBtnSvc.validate(savedCartItemData);
        if (errMsg) toastr(errMsg);

        var action = "addItemToCart";
        cartSvc[action](savedCartItemData, uuid).then(function (response) {
          self.isWorking = false;
          self.isAddedToCart = true;
          var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
          self.cartItem.id = addedCartItem.id
        }).catch(function (err) {
          self.isWorking = false;
          var message = "Oops! Looks like something went wrong.";
          if (err.data && err.data.message === "MEDIA_IN_MISSION") {
            message = messageSvc.compile(messageConst.error.MISSION_CART, {
              photo_name: ": " + media.data.title,
              quantity: 1
            });
            media.data.in_mission = true;
          }
          toastr.error(message);
        });
      }
    }

    function setSelectedVariant(photo, cartItem) {
      if (cartItem) {
        self.cartItem = cartItem;
        self.cartItem.media.data = photo;
      } else {
        self.cartItem = {
          media: {
            id: photo.id,
            price: $.extend(true, {}, photo.price),
            data: photo
          }
        };
        self.cartItem.sub_total = 0;
        cartUtils.updateCartSelectedVariant(self.cartItem, {})
      }
    }

    function onPhotoClicked(file) {
      if (self.isWorking || file.type === 'portfolio' || file.type === 5) {
        return false;
      };
      self.isWorking = true;
      if (angular.isDefined(scope.onPhotoClicked)) {
        scope.onPhotoClicked({
          file: scope.file
        });
        self.isWorking = false;
      } else {
        photoSvc.updatePhotoInfo(scope.file).then(function () {
          self.isWorking = false;
          if (scope.context === "photo-page") {
            $state.go("photo", {
              id: scope.file.id
            });
          } else {
            photoDetailPopupSvc.setShouldSrollTop(new Date().getTime());
            if (photoDetailPopupSvc.isPopupShowing()) {
              photoDetailPopupSvc.updateUI({
                photo: scope.file
              });

            } else {
              var modal = photoDetailPopupSvc.showPopup({
                photo: scope.file,
                onPhotoPopupSaved: scope.onPhotoPopupSaved,
                onPhotoPopupClosed: scope.onPhotoPopupClosed
              });
              modal.result.then(function (response) {
                if (response.action === commonConst.ACTION.DELETE) {
                  scope.onFileRemoved({
                    file: response.photo
                  });
                } else {
                  scope.onAddedOrRemovedFromGallery({
                    file: scope.file
                  });
                }
              }, function (response) {
                scope.onAddedOrRemovedFromGallery({
                  file: scope.file
                });
              });
            }
          }

        }, function () {
          self.isWorking = false;
        });
        if (scope.onPhotoClickedCallback) {
          scope.onPhotoClickedCallback({
            file: scope.file
          });
        }
      }

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photo', photo);

  function photo() {

    var directive = {
      scope: {
          displaySize: "@",
          file: "=",
          gallery: "=",
          onFileRemoved: "&",
          onAddedOrRemovedFromGallery: "&",
          context: '=',
          onPhotoClicked: '&?',
          onPhotoClickedCallback: '&?',
          simpleSelectMode: '=',
          overlayMode: '=',
          onPhotoPopupSaved: '&',
          onPhotoPopupClosed: '&',
          options: '=',
          onRemoveBtnClick: '&?',
          flaggedUsers: '=?'
      },
      restrict: 'E',
      templateUrl: 'app/components/photo/photo.html',
      controller: 'photoCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('mainNavCtrl', mainNavCtrl);

	mainNavCtrl.$inject = ['$scope', '$state', 'sessionManagerSvc', '$rootScope'];

	function mainNavCtrl($scope, $state, sessionManagerSvc, $rootScope) {

		var self = this;
		self.toggleMenu = toggleMenu;
		self.navigateTo = navigateTo;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;

		$rootScope.$on('$stateChangeSuccess', function (event, toState) {
			self.stateName = ($state.current && $state.current.name) ? $state.current.name : 'homepage-nav';
			self.logoUrl = (self.stateName == 'home' || self.stateName == 'about') ? "../../ukraine-exclusive/assets/images/PIXERF_Logo_NEW-white.png" : "../../ukraine-exclusive/assets/images/PIXERF_Logo_NEW-black.png";
		});

		function toggleMenu() {
			self.isNavShowed = !self.isNavShowed;
			$('#hamburger-menu').toggleClass('open');
			if (self.isBtnToggleActive) {
				self.isBtnToggleActive = false;
				self.collapseText = 'MENU';
				$('body, html').removeClass('overflow-hidden');
				$('#content').removeClass('fit-height');
				$('.main-nav').removeClass('fixed-menu');
			} else {
				self.isBtnToggleActive = true;
				self.collapseText = 'CLOSE';
				$('body, html').addClass('overflow-hidden');
				$('#content').addClass('fit-height');
				$('.main-nav').addClass('fixed-menu');
			}
		}

		function navigateTo(page, variable){
			// $state.go(page, variable);
			toggleMenu();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('mainNav', mainNav);

	function mainNav() {

		var directive = {
			scope: {},
			restrict: 'E',
			templateUrl: 'app/components/main-nav/main-nav.html',
			controller: 'mainNavCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

﻿/*
 * Service handler for User Home Page module
 * We will implement all business logic for "home" module here
 */
/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .factory('gallerySvc', gallerySvc);

    gallerySvc.$inject = ['pixerfApiMediaSvc', 'toastr', 'sessionManagerSvc', 'pixerfApiGallerySvc', 'galleryUtils'];

    function gallerySvc(pixerfApiMediaSvc, toastr, sessionManagerSvc, pixerfApiGallerySvc, galleryUtils){
    	
        var mCurrentPage = {
            data: 0
        };

        var mPhotos = {data: []};
    	var mBufferPhotos = {data: []};

        function getCurrentPhotoPage(){
            return mCurrentPage;
        }
    	function getPhotos(){
            return mPhotos;
        }
        function getBufferPhotos(){
    		return mBufferPhotos;
    	}
        function reset(){
            mPhotos.data = [];
            mBufferPhotos.data = [];
            mCurrentPage.data = 0;
        }
    	function fetchPhotos(searchParam){
    		return pixerfApiMediaSvc.search({
                    page: searchParam.page
                }, {
                user:{
                    username: searchParam.username
                }
            }).$promise;
    	}
        function fetchMorePhotos(searchParam){
            console.log('fetchPhotos');
            mCurrentPage.data++;
            searchParam.page = mCurrentPage.data;
            return fetchPhotos(searchParam);
        }
        function updateGalleryCover(gallery){
            pixerfApiGallerySvc.get({id: gallery.id}).$promise.then(function(response){
                gallery.cover_media = response.data.cover_media;
                galleryUtils.updateThumnailPath(gallery);
            });
        }
		/*
		 * exports public methods
		 */
		return {
			getPhotos: getPhotos,
            getBufferPhotos: getBufferPhotos,
			fetchPhotos: fetchPhotos,
            reset: reset,
            fetchMorePhotos: fetchMorePhotos,
            getCurrentPhotoPage: getCurrentPhotoPage,
            updateGalleryCover: updateGalleryCover
		};
    }
})();

(function(){

  angular
    .module('pixerf')
    .controller('galleryCtrl', galleryCtrl);

    galleryCtrl.$inject = ['$scope', 'sessionManagerSvc', 'headerSvc', '$stateParams', 'toastr', 'createGallerySvc', 'commonConst', 'galleryConst', '$state', 'pixerfApiGallerySvc', '$q', '$translate', 'translationSvc', '$rootScope'];

    function galleryCtrl($scope, sessionManagerSvc, headerSvc, $stateParams, toastr, createGallerySvc, commonConst, galleryConst, $state, pixerfApiGallerySvc, $q, $translate, translationSvc, $rootScope){
        console.log($stateParams);

        var self = this;
        self.gallery = {data: null};
        self.photoGrid = null;
        self.user = null;
        self.showEditGalleryPopup = showEditGalleryPopup;
        self.onBackbtnClicked = onBackbtnClicked;
        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.isDoingFollow = false;
        self.isMine =  false;
        self.type = 'default';
        self.onFileRemoved = onFileRemoved;
        self.scrollToFixedHeaderSettings = headerSvc.getFixedByHeaderSetting();

        init();

        $rootScope.$on('$translateChangeSuccess', function(event, current) {
          genEmptyText();
        })

        function init(){
          genEmptyText();
        }

        function genEmptyText(){
          self.emptyText={
            default: $translate.instant("start-your-own-catalogue-of-photos"),
            curated: $translate.instant("start-curating-a-gallery-of-your-favourite-photos"),
          };
        }

        $scope.$watch("vm.photoGrid", function(){
            if(!$stateParams.gallery && !$stateParams.id){
                $state.go("404");
                return;
            }
            if(self.photoGrid){
                fetchData().then(function(gallery){
                    if(!gallery){
                        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('CANNOT_GET_GALLERY_DETAIL', false, true));
                        return;
                    }
                    self.type = gallery.is_curated ? galleryConst.GALLERY_TYPE.CURATED : galleryConst.GALLERY_TYPE.DEFAULT;
                    gallery.isMine = sessionManagerSvc.isMine(gallery.user);
                    self.gallery.data = gallery;
                    self.socialShareContent = buildSocialShareContent(self.gallery.data);
                    self.user = gallery.user;
                    updatePermision();
                    fetchPhotos();
                }, function(){
                    toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('CANNOT_GET_GALLERY_DETAIL', false, true));
                })
            }
        })

        $scope.$watch("vm.galleryGrid", function(){
            if(self.galleryGrid){
                self.galleryGrid.fetchGalleries({
                    type: 'similar',
                    id: $state.params.id,
                    page: $state.params.page ? $state.params.page : 1
                }, true).then(function(){
                }, function(){

                })
            }
        })

        function updatePermision(){
            self.isMine =  (self.loginnedUser && self.loginnedUser.id === self.gallery.data.user.id);
        }

        function fetchPhotos(){
            self.photoGrid.fetchPhotos({
                galleryIds: self.gallery.data.id + ""
            });
        }
        function fetchData(){
            var def = $q.defer();
            if($stateParams.gallery){
                def.resolve($stateParams.gallery);
            } else {
                fetchGallery({
                    id: $stateParams.id
                }).then(function(response){
                    def.resolve(response.data);
                }, function(){
                    def.reject();
                });
            }
            return def.promise;
        }
        function fetchGallery(param){
            return pixerfApiGallerySvc.get(param).$promise;
        }
        function showEditGalleryPopup(){
            var modal = createGallerySvc.showCreateGalleryModal({mode: commonConst.ACTION.EDIT, gallery: self.gallery.data});
            modal.result.then(function(response){
                if(response.mode === commonConst.ACTION.DELETE){
                    onBackbtnClicked();
                }
                self.socialShareContent = buildSocialShareContent(self.gallery.data);
            }, function(){

            })
        }
        function onBackbtnClicked(){
            window.history.back();

        }
        function buildSocialShareContent(gallery){
            return {'url': window.location.href, 'description': gallery.description, 'title': gallery.title, 'media': gallery.coverImagePath};
        }
        function onFileRemoved(file){
            self.gallery.data.media_count -= 1;
            if(file.isMine){
                self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
                self.loginnedUser.stats.media_count --;
                sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
            }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('gallery', {
        url: '/gallery/:id',
        templateUrl: 'app/gallery/gallery.html',
        controller: 'galleryCtrl',
        controllerAs: 'vm',
        data: {
          permissions: {
              only: ['EVERY_ONE']
          },
          pageTitle: "PIXERF - Gallery" ,
          hideFooter: true
        },
        params: {
            gallery: null
        }
      })
      
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('galleriesListSvc', galleriesListSvc);

    galleriesListSvc.$inject = ['pixerfApiGallerySvc', 'toastr'];

    function galleriesListSvc(pixerfApiGallerySvc, toastr) {

        var mGalleries = {
           data: null
        };
        var mCurrentPage = {
            data: 0
        };
        var mTotalPage = {
            data: 0
        };
        var mIsLastPage = {
            data: false
        };
        function getGalleries(type) {
            return mGalleries;
        }
        function setGalleries(value){
            mGalleries.data = value;
        }

        function getCurrentPage() {
            return mCurrentPage;
        }
        function getTotalPage(){
            return mTotalPage;
        }
        function setTotalPage(value){
            mTotalPage.data = value;
        }
        function fetchGallaries(param) {
            return pixerfApiGallerySvc.getUserGalleries(param).$promise;
        }

        function setIsLastPage(value){
            return mIsLastPage.data = value;
        }
        function isLastPage(){
            return mIsLastPage;
        }
        function checkGalleries(galleries, checkedGalleries){
            var addedGallery;
            console.log(checkedGalleries);
            for(var i = 0; i < galleries.length; i ++){
                var gallery = galleries[i];
                addedGallery = _.find(checkedGalleries, function(gl){
                    return gl.id === gallery.id;
                });
                gallery.isSelected  = !!addedGallery ;
            }
        }
        function reset() {
            mGalleries.data = null;
            mCurrentPage.data = 0;
        }
        return {
            getGalleries: getGalleries,
            setGalleries: setGalleries,
            getCurrentPage: getCurrentPage,
            fetchGallaries: fetchGallaries,
            checkGalleries: checkGalleries,
            getTotalPage : getTotalPage,
            setTotalPage : setTotalPage,
            setIsLastPage: setIsLastPage,
            isLastPage: isLastPage

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('galleriesListCtrl', galleriesListCtrl);

    galleriesListCtrl.$inject = ['$scope', 'galleriesListSvc', 'pagingUtils', 'toastr', 'galleryConst'];

    function galleriesListCtrl( $scope, galleriesListSvc, pagingUtils, toastr, galleryConst) {

        var self = this;

        $scope.instance = self;

        self.onGalleryItemClicked = onGalleryItemClicked;
        self.spinner = {isVisible: false};
        self.galleries = galleriesListSvc.getGalleries();
        self.currentPage = galleriesListSvc.getCurrentPage();
        self.isLastPage = galleriesListSvc.isLastPage();
        self.fetchMoreGallaries = fetchMoreGallaries;
        self.onWindowScroll = onWindowScroll;
        self.searchParams = {};
        self.filterFn = filterFn;
        $scope.$watch("vm.galleries.data", function(newGalleries, galleries){
            if($scope.onGalleriesChanged && newGalleries && newGalleries.length > 0){
                $scope.onGalleriesChanged({galleries: newGalleries});
            }
        })
        $scope.$watch("galleryType", _.debounce(function (newType) {
            $scope.$apply(function(){
                fetchGallaries({
                    type: newType,
                    userid: $scope.user.id
                }, true);
            })
        }, 300))
        function onWindowScroll(){
            $("body").trigger("click");
        }
        function onGalleryItemClicked(evt, gallery){
            if($scope.onGalleryItemClicked){
                $scope.onGalleryItemClicked({evt: evt, gallery: gallery});
            }
        }
        function fetchGallaries(params, isFresh){
            self.searchParams = params;
            if(self.spinner.isVisible) return;
            self.spinner.isVisible = true;
            galleriesListSvc.fetchGallaries(params).then(function(response){
                if(isFresh) self.galleries.data = [];
                self.spinner.isVisible = false;
                self.galleries.data = self.galleries.data.concat(response.data);
                self.isLastPage.data = pagingUtils.isNoMorePageToLoad(self.searchParams.page  ? self.searchParams.page : 1, response);
            }, function(){
                self.spinner.isVisible = false;
                toastr.error('failed to get galleries');
            });
        }
        function fetchMoreGallaries(){
            if(self.spinner.isVisible) return;
            if(self.isLastPage.data) return;
            if(self.searchParams && !self.searchParams.page) self.searchParams.page = 1;
            self.searchParams.page ++;
            fetchGallaries(self.searchParams);
        }
        function filterFn(value, index, array){
            if(!self.galleryType) return true;
            if(self.galleryType === galleryConst.GALLERY_TYPE.CURATED && value.is_curated){
                return true;
            } else if(self.galleryType === galleryConst.GALLERY_TYPE.DEFAULT && !value.is_curated) {
                return true;
            }
            return false;
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('galleriesList', galleriesList);

  function galleriesList() {

    var directive = {
      scope: {
        'onGalleryItemClicked': '&',
        'onGalleriesChanged': '&',
        'galleryType': '=',
        'user': '=',
        'instance': '='
      },
      templateUrl: 'app/components/galleries-list/galleries-list.html',
      restrict: 'E',
      controller: 'galleriesListCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('flexGrid', flexGrid);

  flexGrid.$inject = ['$timeout'];

  function flexGrid($timeout) {
    var directive = {
      restrict: 'AE',
      require: "?ngModel",
      link: function ($scope, element, attrs) {
        var ele = $(element);
        var genGrid = _.debounce(genPhotoGrid, 100);
        $scope.$watch(attrs['ngModel'], function (newVal, oldVal) {
          if (!Array.isArray(newVal) || (Array.isArray(newVal) && newVal.length)) {
            genGrid();
          }
        }, true);

        function genPhotoGrid() {
          ele.justifiedGallery({
            rowHeight: attrs.rowheight ? attrs.rowheight : 150,
            margins: attrs.margins ? attrs.margins : 10,
            lastRow: attrs.lastrow ? attrs.lastrow : 'nojustify',
            refreshSensitivity: attrs.sensitivity ? attrs.sensitivity : 20,
            border: attrs.borderStyle ? attrs.borderStyle : 0,
          })
        }
      }
    };
    return directive;
  }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('editCartBtnSvc', editCartBtnSvc);

	editCartBtnSvc.$inject = ['cartSvc', 'cartUtils', '$q', 'toastr', 'messageConst', 'messageSvc', 'sessionManagerSvc', 'store', 'accountConst'];

	function editCartBtnSvc(cartSvc, cartUtils, $q, toastr, messageConst, messageSvc, sessionManagerSvc, store, accountConst) {

		function buildSavedCartItem(cartItem) {
			var savedCartItemData = {
				"size": null,
				"is_unlimited_print": false,
				"is_multi_seat": false,
				"is_for_resale": false,
				"id": cartItem.id
			};
			for (var i = 0; i < cartItem.media.extendedLicenses.length; i++) {
				savedCartItemData[cartItem.media.extendedLicenses[i].key] = cartItem.media.extendedLicenses[i].isSelected;
			}
			for (var i = 0; i < cartItem.media.price.range.length; i++) {
				if (cartItem.media.price.range[i].isSelected) {
					savedCartItemData.size = cartItem.media.price.range[i].size;
				}
			}
			return savedCartItemData;

		}

		function validate(cartItemData) {
			var errMsg = "";
			if (!cartItemData.size) errMsg = "Size is not set";
			return errMsg;
		}

		function editCartItem(cartItem) {
			var def = $q.defer();
			var savedCartItemData = buildSavedCartItem(cartItem);
			var errMsg = validate(savedCartItemData);
			if (errMsg) toastr.error(errMsg);
			var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            if(!mLoginnedUser){
                var guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
            }

			cartSvc.updateItemInCart(savedCartItemData, guestUserToken).then(function (response) {
				def.resolve();
				var updatedCartItem = cartSvc.getCartItemById(response.data, cartItem.id);
				cartItem.sub_total = updatedCartItem.sub_total;
				cartItem.is_unlimited_print = updatedCartItem.is_unlimited_print;
				cartItem.is_multi_seat = updatedCartItem.is_multi_seat;
				cartItem.is_for_resale = updatedCartItem.is_for_resale;
				cartItem.size = updatedCartItem.size;
				cartItem.discounts = updatedCartItem.discounts;
			}, function (err) {
				def.reject();
				cartUtils.updateCartSelectedVariant(cartItem, cartItem);
				var message = 'Oops looks like something went wrong';
				if (err.data.error === "MEDIA_UNAVAILABLE") {
					message = messageSvc.compile(messageConst.error.CART_ITEM_REMOVED, {
						photo_name: ": " + cartItem.media.title,
						quantity: 1,
						action: 'update'
					});
					cartSvc.removeItem(cartItem);
				}
				toastr.error(message);
			});
			return def.promise;
		}
		return {
			buildSavedCartItem: buildSavedCartItem,
			validate: validate,
			editCartItem: editCartItem
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('editCartBtnCtrl', editCartBtnCtrl);

    editCartBtnCtrl.$inject = ['$scope', 'popoverCartSvc', '$uibModalStack', 'toastr', 'editCartBtnSvc', 'cartSvc', 'cartUtils'];

    function editCartBtnCtrl( $scope, popoverCartSvc, $uibModalStack, toastr, editCartBtnSvc, cartSvc, cartUtils) {

        var self = this;
        self.onEditCartBtnClicked = onEditCartBtnClicked;

        function onEditCartBtnClicked(cartItem){

            editCartBtnSvc.editCartItem(cartItem).then(function(){
                $uibModalStack.dismissAll();
                popoverCartSvc.toogle();
            });
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('editCartBtn', editCartBtn);

  function editCartBtn() {

    var directive = {
      scope: {
        "cartItem" : "=",
      },
      restrict: 'E',
      templateUrl: 'app/components/edit-cart-btn/edit-cart-btn.html',
      controller: 'editCartBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('createGallerySvc', createGallerySvc);
    createGallerySvc.$inject = ['pixerfApiGallerySvc', 'galleryUtils', '$uibModal', 'commonConst'];

    function createGallerySvc(pixerfApiGallerySvc, galleryUtils, $uibModal, commonConst){
		var mGallery = {
            data: galleryUtils.getInstance()
        };
        var mMode = {
            data: null
        };
        function getGallery(){
        	return mGallery;
        }
        function getMode(){
            return mMode;
        }

		function showCreateGalleryModal(data){
	    	return $uibModal.open({
				templateUrl: 'app/components/create-gallery/create-gallery.html',
				controller: 'createGalleryCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'create-gallery-popup',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
		    });

    	}
		function validate(form){
			form.$setDirty();
			var errMsg = ''
			if(form.title.$error.required){
				errMsg = "Please fill in Title of gallery!";
			} else if(form.description.$error.validationNoHyperlink){
                errMsg = "Sorry, Gallery's description cannot contain link or email.";
            }
			return errMsg;
		}
		function save(gallery, mode){
			return mode === commonConst.ACTION.EDIT ?  pixerfApiGallerySvc.put({id: gallery.id}, gallery).$promise : pixerfApiGallerySvc.save(gallery).$promise;
		}
        function deleteGallery(galleryId){
            return pixerfApiGallerySvc.delete({id: galleryId}).$promise;
        }
		function reset(){
			mGallery.data = galleryUtils.getInstance();
            mMode.data = commonConst.ACTION.CREATE;
		}
		return {
			getGallery : getGallery,
            getMode: getMode,
			save: save,
            deleteGallery: deleteGallery,
			validate: validate,
			reset: reset,
			showCreateGalleryModal: showCreateGalleryModal
		};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('createGalleryCtrl', createGalleryCtrl);

	createGalleryCtrl.$inject = ['$rootScope', '$scope', 'sessionManagerSvc', 'pixerfConfirmPopupSvc', 'createGallerySvc', '$uibModalInstance', '$timeout', 'commonConst', 'resolveData', 'galleryConst', 'toastr', '$translate', 'translationSvc', 'selectExistPhotosPopupSvc', 'systemUtils'];

	function createGalleryCtrl($rootScope, $scope, sessionManagerSvc, pixerfConfirmPopupSvc, createGallerySvc, $uibModalInstance, $timeout, commonConst, resolveData, galleryConst, toastr, $translate, translationSvc, selectExistPhotosPopupSvc, systemUtils) {

		var self = this;

		createGallerySvc.reset();

		self.gallery = (resolveData && resolveData.gallery && resolveData.mode) ? {
			data: $.extend(true, {}, resolveData.gallery)
		} : createGallerySvc.getGallery();
		self.onSaveBtnClicked = save;
		self.onCancelBtnClicked = close;
		self.alertSvc = {};
		self.mode = resolveData && resolveData.mode ? resolveData.mode : commonConst.ACTION.CREATE;
		self.type = resolveData && resolveData.type ? resolveData.type : galleryConst.GALLERY_TYPE.NORMAL;
		self.onDeleteGalleryBtnClicked = onDeleteGalleryBtnClicked;
		self.isWorking = false;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.popupTitle = getPopUpTitle();
		self.onEditCoverImage = onEditCoverImage;

		init()

		function init() {
			self.coverMedia = self.gallery.data && self.gallery.data.cover_media && self.gallery.data.cover_media.thumbnails ? self.gallery.data.cover_media.thumbnails['x400'] : null;
		}

		function getPopUpTitle() {
			if (self.mode === commonConst.ACTION.CREATE) {
				if (self.type === galleryConst.GALLERY_TYPE.CURATED) {
					return $translate.instant('add-new-curated-gallery');
				} else {
					return $translate.instant('add-new-gallery');
				}
			}
			return $translate.instant('edit', {
				name: $translate.instant('gallery')
			});
		}

		function close(reason) {
			$uibModalInstance.dismiss(reason);
		}

		function applyChanges(originalGallery, updatedGallery) {
			originalGallery.title = updatedGallery.title;
			originalGallery.description = updatedGallery.description;
			originalGallery.is_private = updatedGallery.is_private;
			originalGallery.cover_media = updatedGallery.cover_media;
		}

		function updateUserStat(gallery) {
			var step = self.mode === commonConst.ACTION.CREATE ? 1 : -1
			self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (gallery.is_curated) {
				self.loginnedUser.stats.curated_gallery_count += step;
			} else {
				self.loginnedUser.stats.default_gallery_count += step;
			}
			sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
		}

		function save(gallery, formData) {
			if (self.isWorking) return;
			var errMsg = createGallerySvc.validate(formData);
			if (errMsg) {
				toastr.error(errMsg);
				return;
			}
			if (self.mode === commonConst.ACTION.CREATE) {
				gallery.is_curated = self.type === galleryConst.GALLERY_TYPE.CURATED;
			}
			self.isWorking = true;
			createGallerySvc.save(gallery, self.mode).then(function (response) {
				if (self.mode === commonConst.ACTION.CREATE) {
					updateUserStat(gallery);
				}
				var message = self.mode === commonConst.ACTION.CREATE ? "Gallery created!" : "Gallery has been successfully updated!";
				if (!resolveData.overridSuccessMsg) {
					toastr.success(message);
				}
				$timeout(function () {
					self.isWorking = false;
					if (self.mode !== commonConst.ACTION.CREATE) {
						applyChanges(resolveData.gallery, response.data);
					}
					createGallerySvc.reset();
					$uibModalInstance.close(response);
				}, 1000);

			}, function () {
				self.isWorking = false;
				var action = self.mode === commonConst.ACTION.CREATE ? "create" : "edit"
				toastr.error("Oops! Failed to " + action + " gallery. Please try again.");
			});
		}

		function onDeleteGalleryBtnClicked(gallery) {
			if (self.isWorking) return;
			self.isWorking = true;
			var modal = pixerfConfirmPopupSvc.showPopup({
				message: translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("DELETE_THIS_GALLERY"),
				hideConfirmText: true,
				hideTitle: true
			});
			modal.result.then(function () {
				createGallerySvc.deleteGallery(gallery.id).then(function (response) {
					updateUserStat(gallery);
					console.log(response);
					toastr.success("Gallery has been successfully deleted!");
					$timeout(function () {
						self.isWorking = false;
						createGallerySvc.reset();
						$uibModalInstance.close({
							mode: commonConst.ACTION.DELETE
						});
					}, 1000);

				}, function () {
					self.isWorking = false;
					toastr.error("Oops! Failed to delete gallery. Please try again.");
				});
			}, function () {
				self.isWorking = false;
			})
		}

		function onEditCoverImage() {
			var existPhotoPopup = selectExistPhotosPopupSvc.showPopup({
				type: 'gallery',
				data: self.gallery.data,
				options: {
					title: 'Select Gallery Cover'
				}
			});

			existPhotoPopup.result.then(function (data) {
				self.coverMedia = data && data.thumbnails ? data.thumbnails['x400'] : null;
				self.gallery.data.cover_media_id = data.id;
				systemUtils.digest($scope);
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('comFooter', comFooter);

	comFooter.$inject = ['$timeout'];
	function comFooter($timeout) {

		var directive = {
			scope: {},
			restrict: 'E',
			templateUrl: 'app/components/com-footer/com-footer.html',
			replace: true,
			link: function($scope){
                var listener = function(event, toState) {

                    $timeout(function() {
                        $scope.isVisible = !(toState.data && toState.data.hideFooter);
                    });
                };

                $scope.$on('$stateChangeSuccess', listener);
            }
		};
		return directive;
	}

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .factory('cartSvc', cartSvc);

  cartSvc.$inject = ['pixerfApiCartSvc', 'toastr', '$q', '$translate', 'sessionManagerSvc', 'store', 'accountConst', '$rootScope', 'messageConst'];

  function cartSvc(pixerfApiCartSvc, toastr, $q, $translate, sessionManagerSvc, store, accountConst, $rootScope, messageConst) {

    var mCart = {
      data: {
        cart_items: [],
        total: 0
      }
    };

    function getCart() {
      return mCart;
    }

    function setCart(value) {
      mCart.data = value;
    }

    function fetchCart(guestUserToken) {
      var def = $q.defer();
      var guestUserTokenFromStore = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
      if (!guestUserToken && guestUserTokenFromStore) {
        guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
      }

      pixerfApiCartSvc.get(buildGuestUuidParam(guestUserToken)).$promise.then(function (response) {
        mCart.data = response.data;
        def.resolve(response);
      }, function (error) {
        def.reject(error);
      });
      return def.promise;
    }

    function removeItem(cartItem) {
      mCart.data.cart_items = _.reject(mCart.data.cart_items, function (item) {
        return item.id === cartItem.id;
      });
      mCart.data.total -= cartItem.sub_total;
    }

    function removeItemFromCart(cartItem) {
      var def = $q.defer();
      var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
      var guestUserToken = null;
      var queryParam = {
        'id': cartItem.id
      };
      if (!mLoginnedUser) {
        guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
        queryParam = Object.assign({}, queryParam, buildGuestUuidParam(guestUserToken));
      }

      pixerfApiCartSvc.delete(queryParam).$promise.then(function (response) {
        removeItem(cartItem);
        var message = "Photo: " + cartItem.media.title + " has been successfully removed from your cart!";
        toastr.success(message,
          {
            closeHtml: '<button class="toast-close-button icon-icon-close custome-close-icon" ></button>'
          });
        $rootScope.$broadcast(messageConst.BROADCAST.UPDATED_CART);
        def.resolve(response);
      }, function (err) {
        if (err.status !== 404) {
          console.log(err);
          toastr.error('Oops looks like something went wrong');
        } else {
          removeItem(cartItem);
        }
        def.reject(err);
      })
      return def.promise;
    }

    function buildGuestUuidParam(uuid) {
      return uuid ? {
        'guest_id': uuid
      } : {};
    }

    function addItemToCart(savedCartItemData, guestUserId) {
      var def = $q.defer();

      pixerfApiCartSvc.post(buildGuestUuidParam(guestUserId), savedCartItemData).$promise.then(function (response) {
        var justAddedItem = _.find(response.data.cart_items, function (item) {
          return item.media.id === savedCartItemData.media_id;
        });
        mCart.data.cart_items.unshift(justAddedItem);
        mCart.data.total = response.data.total;
        def.resolve(justAddedItem);
      }, function (err) {
        def.reject(err);
      });
      return def.promise;
    }

    function getCartItemById(cart, id) {
      if (!cart) cart = mCart.data;
      return _.find(cart.cart_items, function (item) {
        return item.id === id;
      })
    }

    function getCartItemByMediaId(cart, id) {
      if (!cart) cart = mCart.data;
      return _.find(cart.cart_items, function (item) {
        return item.media.id === id;
      })
    }

    function updateItemInCart(cartItem, guestUserId) {
      var def = $q.defer();

      pixerfApiCartSvc.put(buildGuestUuidParam(guestUserId), cartItem).$promise.then(function (response) {
        mCart.data.total = response.data.total;
        def.resolve(response);
      }, function (err) {
        def.reject(err);
      });
      return def.promise;
    }

    function reset() {
      mCart.data = {
        cart_items: [],
        total: 0
      };
    }

    function resetCartValidity(items) {
      for (var i = 0; i < items.length; i++) {
        items[i].is_invalid = false;
      }
    }

    function checkGuestUserId(uuid) {
      var def = $q.defer();
      pixerfApiCartSvc.checkGuestUserId({
        uuid: uuid
      }).$promise.then(
        function (response) {
          def.resolve();
        },
        function (err) {
          def.reject(err);
        }
      )
      return def.promise;
    }

    function generateUUID(count, callback, param) {
      if (count <= 0) {
        return;
      }
      var uuid = sessionManagerSvc.uuid();
      checkGuestUserId(uuid).then(
        function (response) {
          console.log(uuid);
          if (callback) callback(uuid, param);
        },
        function (err) {
          generateUUID(--count, callback, param)
        }
      )
    }
    return {
      getCart: getCart,
      setCart: setCart,
      fetchCart: fetchCart,
      removeItem: removeItem,
      removeItemFromCart: removeItemFromCart,
      updateItemInCart: updateItemInCart,
      addItemToCart: addItemToCart,
      getCartItemById: getCartItemById,
      getCartItemByMediaId: getCartItemByMediaId,
      reset: reset,
      resetCartValidity: resetCartValidity,
      checkGuestUserId: checkGuestUserId,
      generateUUID: generateUUID
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('cartCtrl', cartCtrl);

  cartCtrl.$inject = ['$scope', 'cartSvc', '$rootScope', 'toastr', 'messageConst'];

  function cartCtrl($scope, cartSvc, $rootScope, toastr, messageConst) {

    var self = this;

    self.onCartItemClicked = onCartItemClicked;
    self.onRemoveItemClicked = onRemoveItemClicked;
    self.isWorking = false;
    self.spinner = {
      isVisible: false
    };
    self.cart = cartSvc.getCart();

    function onCartItemClicked(params) {
      if ($scope.onCartItemClicked) {
        $scope.onCartItemClicked(params);
      }
    }

    function fetchCart(isFresh) {
      self.spinner.isVisible = true;
      if (isFresh) self.cart.data.cart_items = [];
      cartSvc.fetchCart().then(function (response) {
        self.spinner.isVisible = false;
      }, function () {
        toastr.error('failed to get cart item list');
        self.spinner.isVisible = false;
      });
    }

    function onRemoveItemClicked($event, cartItem) {
        if(self.isWorking) return;
        var isExist = cartSvc.getCartItemById(self.cart.data, cartItem.id);
        if(!isExist) return;
        self.isWorking = true;
        cartSvc.removeItemFromCart(cartItem).then(function(response){
            self.isWorking = false;
            if($scope.onCartItemRemoved) $scope.onCartItemRemoved();
        }, function(){
            self.isWorking = false;
        });
        $event.stopPropagation();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('cart', cart);

  function cart() {

    var directive = {
      scope: {
        'items': '=',
        'onCartItemClicked': '&',
        'onCartItemRemoved': '&?'
      },
      templateUrl: 'app/components/cart/cart.html',
      restrict: 'E',
      controller: 'cartCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('authSvc', authSvc);

	authSvc.$inject = ['messageConst', 'accountConst', '$state', 'signInSvc', 'sessionManagerSvc', '$rootScope', 'commonConst', 'selectSignUpTypePopupSvc'];

	function authSvc(messageConst, accountConst, $state, signInSvc, sessionManagerSvc, $rootScope, commonConst, selectSignUpTypePopupSvc) {

		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			updateUserInfo(sessionManagerSvc.getCurrentLoginUser().data);
		});

		var mUser = {
			data: null
		}

		function getUser() {
			var userData = sessionManagerSvc.getCurrentLoginUser().data;
			updateUserInfo(userData);
			return mUser;
		}

		function updateUserInfo(newData) {
			if (newData) {
				mUser.data = newData;
			}
		}

		function showSignUpModal() {
			selectSignUpTypePopupSvc.showPopup();
		}

		function showSignInModal() {
			signInSvc.showSignInModal();
		}

		function navigateTo() {
			var loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
			switch (loginedUser.account_type) {
				case accountConst.ACCOUNT_TYPE.BUSINESS:
					$state.go(commonConst.STATE.EDIT_BUSINESS_PROFILE);
					break;
				default:
					$state.go(commonConst.STATE.EDIT_PERSONAL_PROFILE);
			}
		}

		return {
			getUser: getUser,
			showSignUpModal: showSignUpModal,
			showSignInModal: showSignInModal,
			navigateTo: navigateTo,
			updateUserInfo: updateUserInfo
		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.controller('authCtrl', authCtrl);

	authCtrl.$inject = ['authSvc', '$scope', '$state', 'sessionManagerSvc', 'uploadPhotoSvc', '$timeout', '$translate', 'commonConst', '$rootScope', 'messageConst', 'selectSignUpTypePopupSvc', 'signInPopupSvc', 'settingSvc'];

	function authCtrl(authSvc, $scope, $state, sessionManagerSvc, uploadPhotoSvc, $timeout, $translate, commonConst, $rootScope, messageConst, selectSignUpTypePopupSvc, signInPopupSvc, settingSvc) {

		var self = this;
		self.user = authSvc.getUser();
		self.onSignUpBtnClicked = onSignUpBtnClicked;
		self.onSignInBtnClicked = onSignInBtnClicked;
		self.isAuthenticated = function () {
			return !!sessionManagerSvc.getCurrentLoginUser().data;
		};
		self.showUploadModal = showUploadModal;
		self.selectedDefaultIndex = 0;
		self.onSettingClicked = authSvc.navigateTo;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.onManageMissionClicked = onManageMissionClicked;
		self.onManageCommissionClicked = onManageCommissionClicked;
		self.onManageCommunityClicked = onManageCommunityClicked;
		self.onManageEventClicked = onManageEventClicked;
		self.onManageReportsClicked = onManageReportsClicked;
        self.onManageMediaPostClicked = onManageMediaPostClicked;
		self.onProfileMenuToggle = onProfileMenuToggle;
		self.isViewMoreActived = isViewMoreActived;
        self.isAbleToChangePassword = settingSvc.isAbleToChangePassword();
		self.isWorking = false;
		self.selectedLanguage = 'en';
		self.onLanguagesSelected = onLanguagesSelected;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.guestUser = self.loginedUser && !self.loginedUser.account_type;
		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
			self.updatingdAvatar = true;
			self.guestUser = self.loginedUser && !self.loginedUser.account_type;
			$timeout(function () {
				self.updatingdAvatar = false;
			}, 500)
		});

		$rootScope.$on('initLang', function(event, language){
			self.selectedLanguage = language || 'en';
		})

		function showUploadModal() {
			onCloseBtnClicked();
			uploadPhotoSvc.showUploadModal();
		}

		function onSignUpBtnClicked() {
			onCloseBtnClicked();
			selectSignUpTypePopupSvc.showPopup();
		}

		function onSignInBtnClicked() {
			onCloseBtnClicked();
			signInPopupSvc.showPopup();
		}

		function onCloseBtnClicked() {
			$timeout(function () {
				$("body").trigger("click");
			});
		}

		function onManageMissionClicked() {
			if (self.user && self.user.data && self.user.data.canCreateMission) {
				// $state.go("setting.manage-missions.create-mission.getting-started");
				$state.go("setting.manage-missions.on-going");
			}
			onCloseBtnClicked();
		}

		function onManageCommissionClicked() {
			$state.go("setting.manage-custom-commissions.on-going");
		}

		function onProfileMenuToggle(open) {
			self.isProfileMenuOpen = open;
		}

		function onLanguagesSelected(language) {
			$translate.use(language.value);
			$rootScope.lang = language.value;
			moment.locale(language.value);
			self.selectedLanguage = language.value;
		}

		function onManageCommunityClicked() {
			$state.go('setting.manage-communities.communities');
			onCloseBtnClicked();
		}

		function onManageEventClicked() {
			if (self.user && self.user.data && self.user.data.canManageCommunity) {
				$state.go(commonConst.STATE.MANAGE_EVENTS);
			} else {
				$state.go(commonConst.STATE.MANAGE_JOINED_COMMUNITIES);
			}
			onCloseBtnClicked();
		}

		function onManageReportsClicked() {
			if (self.user && self.user.data && self.user.data.canManageCommunity) {
				$state.go(commonConst.STATE.MANAGE_REPORTS);
			} else {
				$state.go(commonConst.STATE.MANAGE_JOINED_COMMUNITIES);
			}
			onCloseBtnClicked();
		}

		function isViewMoreActived(){
			if (!$state || !$state.current) return;

			var currentStateName = $state.current.name;
			var viewMoreStates = ['buy-stock-page.temporary-photos', 'buy-stock-page.photographers.featuredPhotographer', 'buy-stock-page.pending-photos', 'buy-stock-page.pending-portfolio', 'buy-stock-page.rejected-photos', 'buy-stock-page.general-photos'];
			return viewMoreStates.includes(currentStateName);
		}

        function onManageMediaPostClicked(){
            $state.go("setting.manage-media-post.create-post");
        }
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('pixerfAuth', pixerfAuth);

  function pixerfAuth() {

    var directive = {
      scope: {},
      restrict: 'E',
      templateUrl: 'app/components/auth/auth.html',
      controller: 'authCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('addToGallerySvc', addToGallerySvc);

     addToGallerySvc.$inject = ['galleryUtils'];

    function addToGallerySvc(galleryUtils) {

        var mScope = null;
        function getScope(){
            return mScope;
        }
        function setScope(value){
            return mScope = value;
        }
        var mIsOpen = null;
        function turnOffOthers(isOpen){
            if(mIsOpen){
                mIsOpen.data = false;
            }
            mIsOpen = isOpen;
        }
        
        function buildGalleriesNames(galleries){
            var names = galleryUtils.extractGalleriesName(galleries);
            return (names.length > 0 ? names.join(', ') : 'Choose Gallery');
        }
        return {
            getScope: getScope,
            setScope: setScope,
            buildGalleriesNames: buildGalleriesNames,
            turnOffOthers: turnOffOthers
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('addToGalleryCtrl', addToGalleryCtrl);

    addToGalleryCtrl.$inject = ['$rootScope','$scope', 'createGallerySvc', 'addToGallerySvc', 'galleriesListSvc', 'sessionManagerSvc', 'galleryConst', 'pixerfApiMediaSvc', '$q', 'toastr', 'systemUtils'];

    function addToGalleryCtrl($rootScope, $scope, createGallerySvc, addToGallerySvc, galleriesListSvc, sessionManagerSvc, galleryConst, pixerfApiMediaSvc, $q, toastr, systemUtils) {

        var self = this;

        self.galleryListInstance = null;
        self.isOpen = {data: false};
        self.isEnable = true;
        self.onCreateGalleryBtnClicked = onCreateGalleryBtnClicked;
        self.onGalleryItemClicked = onGalleryItemClicked;
        self.onGalleriesChanged = onGalleriesChanged;
        self.galleryType = null;
        self.loginUser =  sessionManagerSvc.getCurrentLoginUser().data;
        self.clickOutSide = clickOutSide;
        self.isCuratedGalleryChecked = true;
        self.isMyGalleryChecked = true;
        self.onGalleryCheckboxCheck = onGalleryCheckboxCheck;
        $scope.$watch("vm.isOpen.data", function(){
            if(!self.loginUser) {
                self.isEnable = false;
                return;
            }

            setGalleryType();
            if(self.isOpen.data){
                if($scope.file && $scope.file.id){
                    if(!$scope.file.galleries  || !$scope.file.categories){
                        getMediaDetail($scope.file.id).then(function(response){
                            $scope.file.galleries = response.data.galleries;
                            $scope.file.categories = response.data.categories;
                        }, function(){
                            toastr.error("Failed to get photo information");
                        })
                    }
                }
                onOpen();
            } else {
                onClose();
            }
        });
        function onGalleryCheckboxCheck(){
            if(self.isMyGalleryChecked && self.isCuratedGalleryChecked ||
               (!self.isMyGalleryChecked && !self.isCuratedGalleryChecked)){
                    self.galleryType = null;
            } else {
                self.galleryType = self.isMyGalleryChecked ? galleryConst.GALLERY_TYPE.DEFAULT : galleryConst.GALLERY_TYPE.CURATED;
            }
        }
        function clickOutSide(){
            $("body").trigger("click");
        }
        function getMediaDetail(mediaid){
            var def = $q.defer();

            pixerfApiMediaSvc.get({id: $scope.file.id}).$promise.then(function(response){
                def.resolve(response);
            }, function(err){
                def.reject(err);
            })
            return def.promise;
        }
        function setGalleryType(){
            if(!$scope.file) return;
            var isMyPhoto = sessionManagerSvc.isMyPhoto($scope.file);
            $scope.file.isMine = isMyPhoto;
            if(isMyPhoto){
                self.isMyGalleryChecked = true;
                self.isCuratedGalleryChecked = false;
                self.galleryType = galleryConst.GALLERY_TYPE.DEFAULT;
            } else {
                self.galleryType = galleryConst.GALLERY_TYPE.CURATED;
            }
        }
        function onGalleriesChanged(galleries){
            if($scope.file && $scope.file.galleries && $scope.file.galleries.length > 0){
                galleriesListSvc.checkGalleries(galleries,  $scope.file.galleries);
            }
        }
        function onGalleryItemClicked(evt, gallery){
            if($scope.file && $scope.file.state==="r"){
                toastr.error("Hi, this photo cannot be added to gallery because it's rejected photo!");
                return;
            }
            gallery.isSelected  = !gallery.isSelected;
            if($scope.onGalleryItemClicked){
                $scope.onGalleryItemClicked({file: $scope.file, gallery: gallery});
            }
            if($scope.closeOnClick && evt && !evt.shiftKey){
                $("body").trigger("click");
                evt.stopPropagation();
            } else {
                systemUtils.preventTextSelection();
            }
        }
        function onClose(){
            if($scope.onClose && !self.isOpen.data){
                $scope.onClose({file:  $scope.file});
            }
        }
        function onOpen(){
            if($scope.onOpen && self.isOpen.data){
                $scope.onOpen({file:  $scope.file});
            }
        }
        function onCreateGalleryBtnClicked(){
            var modal = createGallerySvc.showCreateGalleryModal({type: self.galleryType, overridSuccessMsg: true});
            modal.result.then(function(newCreatedGallery){
                if($scope.addWhenGalleryCreated){
                    self.onGalleryItemClicked(null, newCreatedGallery);
                }
            }, function(){

            })
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('addToGallery', addToGallery);

  function addToGallery() {

    var directive = {
      scope: {
        'isDisabled': '=',
        'onGalleryItemClicked': '&',
        'file': '=',
        'onOpen': '&',
        'onClose': '&',
        'spinner': '=',
        'loadMoreGalleries': '&',
        'isLastPage': '=',
        'closeOnClick': '@',
        'addWhenGalleryCreated': '='
      },
      restrict: 'E',
      controller: 'addToGalleryCtrl',
      controllerAs: 'vm',
      replace: false,
      transclude: true,
      link: function(scope, element, attrs, ctrl, transclude){
          transclude(scope, function(clone, scope) {
            element.append(clone);
          });
      }
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .factory('addToCartBtnSvc', addToCartBtnSvc);

  addToCartBtnSvc.$inject = ['commonConst'];

  function addToCartBtnSvc(commonConst) {

    function buildSavedCartItem(media, isSelectLowestPrice) {
      var savedCartItemData = {
        "size": null,
        "is_unlimited_print": false,
        "is_multi_seat": false,
        "is_for_resale": false,
        "media_id": media.id
      };
      if (media && media.extendedLicenses && media.extendedLicenses.length) {
        for (var i = 0; i < media.extendedLicenses.length; i++) {
          savedCartItemData[media.extendedLicenses[i].key] = media.extendedLicenses[i].isSelected;
        }
      }
      for (var i = 0; i < media.price.range.length; i++) {
        if (media.price.range[i].isSelected) {
          savedCartItemData.size = media.price.range[i].size;
        }
      }

      if (isSelectLowestPrice) {
        savedCartItemData.size = media.price.range[0].size;
      }
      if (isSelectLowestPrice && (media.data && media.data.user && commonConst.CHEATED_USERS.DEFINERS.includes(media.data.user.id)) ||
        (media.user && commonConst.CHEATED_USERS.DEFINERS.includes(media.user.id))) {
        savedCartItemData.size = "S";
      }
      return savedCartItemData;

    }

    function validate(cartItemData) {
      var errMsg = "";
      if (!cartItemData.size) errMsg = "Size is not set";
      return errMsg;
    }
    return {
      buildSavedCartItem: buildSavedCartItem,
      validate: validate
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('addToCartBtnCtrl', addToCartBtnCtrl);

    addToCartBtnCtrl.$inject = ['$scope', 'popoverCartSvc', '$uibModalStack', 'toastr', 'addToCartBtnSvc', 'cartSvc', 'commonConst', 'messageConst', 'messageSvc',
     'sessionManagerSvc', 'store', 'accountConst', '$rootScope'];

    function addToCartBtnCtrl( $scope, popoverCartSvc, $uibModalStack, toastr, addToCartBtnSvc, cartSvc, commonConst, messageConst, messageSvc
        , sessionManagerSvc, store, accountConst, $rootScope) {

        var self = this;
        self.onAddToCartClicked = onAddToCartClicked;
        self.onRequestLicenseBtnClicked = onRequestLicenseBtnClicked;

        self.isWorking = false;
        function onAddToCartClicked(media){
            if(self.isWorking) return;
            self.isWorking = true;
            var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            if(!mLoginnedUser){
                return onAddToCartForGuestUser(media);
            }
            var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media);
            console.log(savedCartItemData);
            var errMsg = addToCartBtnSvc.validate(savedCartItemData);
            if(errMsg) toastr(errMsg);

            var action = $scope.mode === commonConst.ACTION.EDIT ? "updateItemInCart" : "addItemToCart";
            cartSvc[action](savedCartItemData).then(function(response){
                self.isWorking = false;
                $uibModalStack.dismissAll();
                if($scope.onAdded){
                    var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
                    $scope.onAdded({'addedCartItem': addedCartItem});
                }
            }).catch(function(err){
                self.isWorking = false;
                var message = "Oops! Looks like something went wrong. Please try again!";
                if(err.data && err.data.message === "MEDIA_IN_MISSION"){
                    message = messageSvc.compile(messageConst.error.MISSION_CART, {photo_name: ": " + media.data.title , quantity: 1});
                    media.data.in_mission = true;
                }
                toastr.error(message);
            });
        }
        function onAddToCartForGuestUser(media) {
            var guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
            if(guestUserToken){
                processAddToCard(guestUserToken, media);
            }else{
                cartSvc.generateUUID(10, processAddToCard, media);
            }

            function processAddToCard(uuid, media) {
                if( !store.get(accountConst.TOKEN.GUEST_USER_TOKEN)){
                    store.set(accountConst.TOKEN.GUEST_USER_TOKEN, uuid);
                }
                
                var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media);
                console.log(savedCartItemData);
                var errMsg = addToCartBtnSvc.validate(savedCartItemData);
                if (errMsg) toastr(errMsg);

                var action = $scope.mode === commonConst.ACTION.EDIT ? "updateItemInCart" : "addItemToCart";
                cartSvc[action](savedCartItemData, uuid).then(function (response) {
                    self.isWorking = false;
                    $uibModalStack.dismissAll(); 
                    $rootScope.$broadcast(messageConst.BROADCAST.UPDATED_CART);
                    if ($scope.onAdded) {
                        var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
                        $scope.onAdded({ 'addedCartItem': addedCartItem });
                    }
                }).catch(function (err) {
                    self.isWorking = false;
                    var message = "Oops! Looks like something went wrong. Please try again!";
                    if (err.data && err.data.message === "MEDIA_IN_MISSION") {
                        message = messageSvc.compile(messageConst.error.MISSION_CART, { photo_name: ": " + media.data.title, quantity: 1 });
                        media.data.in_mission = true;
                    }
                    toastr.error(message);
                });
            }
        }
        function onRequestLicenseBtnClicked(media){

        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('addToCartBtn', addToCartBtn);

  function addToCartBtn() {

    var directive = {
      scope: {
        "media" : "=",
        "mode": '@',
        "onAdded": '&?',
        "isDisabled": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/add-to-cart-btn/add-to-cart-btn.html',
      controller: 'addToCartBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {

  angular
    .module('pixerf')
    .factory('workpageSvc', workpageSvc);

  workpageSvc.$inject = ['pixerfApiUserSvc'];

  function workpageSvc(pixerfApiUserSvc) {

    function getUser(id) {
      return pixerfApiUserSvc.get({
        id: id,
        action: 'profile'
      }).$promise;
    }

    return {
      getUser: getUser
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .controller('workPageCtrl', workPageCtrl)

  workPageCtrl.$inject = ['$scope', 'pixerfApiUserSvc', 'userPromise', 'pagingUtils'];

  function workPageCtrl($scope, pixerfApiUserSvc, userPromise, pagingUtils) {
    var self = this;
    self.user = userPromise;
    self.fetchMorePhotos = fetchMorePhotos;
    self.onScrollToPage = onScrollToPage;
    self.onLoadMorePage = onLoadMorePage;
    self.onPhotoSelected = onPhotoSelected;
    self.search = search;
    self.submissionPagination = {
      page: 1
    }
    self.spinner = {
      isVisible: false
    }
    self.searchParams = {
      page: 1,
      userId: self.user.id,
      sort: 'popularity'
    };

    init();

    function init() {
      // fetchPhotos(self.searchParams, true);
      $scope.$watch("vm.photoGrid", function () {
        if (self.photoGrid) {
          self.search(self.searchParams);
        }
      });
    }

    function search(params) {
      self.photoGrid.fetchPhotos(params, true).then(function () {
        if ($scope.$parent && self) {
          self.totalPage = self.photoGrid.totalPage;
          self.totalPhotos = self.photoGrid.totalPhotos;
        }
      });
    }

    function onScrollToPage(page) {
      self.submissionPagination.page = page;
    }

    function onLoadMorePage(page) {
      self.submissionPagination.page = page;
    }

    function fetchPhotos(searchParams, isFresh) {
      if (self.spinner.isVisible) return;
      self.searchParams = searchParams;
      self.spinner.isVisible = true;
      var urlParams = {
        id: searchParams.userId,
        page: searchParams.page
      }
      pixerfApiUserSvc.get_medias(urlParams, searchParams).$promise.then(function (response) {
        if (isFresh) self.bidingItems = [];
        self.bidingItems = self.bidingItems.concat(response.data);
        self.photoIds = _.pluck(self.bidingItems, "id");
        self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
        self.totalPhotos = pagingUtils.getTotalCount(response);
        self.totalPage = pagingUtils.getTotalPage(response);
        self.spinner.isVisible = false;
      }).catch(function () {
        self.spinner.isVisible = false;
      })
    }

    function fetchMorePhotos() {
      if (self.spinner.isVisible) {
        return;
      }
      self.searchParams.page++;
      fetchPhotos(self.searchParams);
    }

    function onPhotoSelected(file){
      console.log(file)
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('work', {
        url: '/work/:id',
        templateUrl: 'app/work-page/work-page.html',
        controller: 'workPageCtrl',
        controllerAs: 'vm',
        data: {},
        resolve: {
          userPromise: function ($stateParams, workpageSvc, $q) {
            var userid = parseInt($stateParams.id);
            var defer = $q.defer();
            var promise = workpageSvc.getUser(userid);
            var handlers = [function (userData) {
              defer.resolve(userData);
            }, function () {
              defer.reject();
            }]
            promise.then.apply(promise, handlers);
            return defer.promise;
          }
        }
      });
  }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('tagUtils', tagUtils);

	tagUtils.$inject = [];

	function tagUtils() {

		function text2TagObject(texts) {
			if (!texts) return texts;
			var arr = [];
			for (var i = 0; i < texts.length; i++) {
				arr.push({
					text: texts[i]
				})

			}
			return arr;
		}

		function extractTagsText(tags) {
			return _.reduce(tags, function (memo, tag) {
				memo.push(tag.text);
				return memo;
			}, []);
		}

		function stringsToTag(arrString) {
			return _.reduce(arrString, function (memo, tag) {
				memo.push({
					text: tag
				});
				return memo;
			}, []);
		}

		function tagsToString(tags) {
			return _.reduce(tags, function (memo, tag) {
				memo += tag.text;
				return memo;
			}, []);
		}

		return {
			text2TagObject: text2TagObject,
			extractTagsText: extractTagsText,
			tagsToString: tagsToString,
			stringsToTag: stringsToTag
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('systemUtils', systemUtils);

    systemUtils.$inject = ['$timeout'];

    function systemUtils($timeout) {
        function apply(scope){
            $timeout(function(){
                scope.$apply();
            })
        }
        function isMobile(){
            return window.innerWidth < 667;
        }
        function scrollTo(options){
            var body = $("html, body");
            body.stop().animate({ scrollTop: 0 }, '500', 'swing');
        }
        function getViewportDimension() {
			return {
				width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
				height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
			}
		}
        function digest(scope) {
			$timeout(function () {
				scope.$apply();
			})
		}
    //------------------------------------------------------------------------------------------------------------------
        return {
            apply: apply,
            isMobile: isMobile,
            scrollTo: scrollTo,
            getViewportDimension: getViewportDimension,
            digest: digest
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('stringUtils', stringUtils);

	stringUtils.$inject = ['$sce'];

	function stringUtils($sce) {
		function buildString(value, fallback) {
			if (value) return value;
			return fallback ? fallback : '';
		}

		function arrayToString(array) {
			var str = null;
			if (array && array.length > 0) {
				str = array.join(",");
			}
			return str;
		}

		function capitalizeChar(str, index) {
			return str.charAt(index).toUpperCase() + str.substr(index + 1);
		}

		function camelCaseToTitleCase(input) {
			return input.replace(/([A-Z])/g, ' $1')
				.replace(/^./, function (str) {
					return str.toUpperCase();
				})
		}

		function toTitleCase(input) {
			input = input || '';
			input = input.toLowerCase();
			var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
			return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
				if (index > 0 && index + match.length !== title.length &&
					match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" &&
					(title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
					title.charAt(index - 1).search(/[^\s-]/) < 0) {
					return match.toLowerCase();
				}

				if (match.substr(1).search(/[A-Z]|\../) > -1) {
					return match;
				}

				return match.charAt(0).toUpperCase() + match.substr(1);
			});
		}

		function toSnakeCase(input) {
			if (!input) return;
			return input.replace(/ /g, '-');
		}

		function extractNumberFromString(str) {
			return str.match(/\d+/)[0];
		}

		function replaceAt(string, index, replacement) {
			return string.substr(0, index) + replacement + string.substr(index + replacement.length);
		}

		function htmlToPlaintext(text) {
			return text ? String(text).replace(/<[^>'"]+>/gm, '') : '';
		}

		function removeSpecialChar(text) {
			return text ? String(text).replace(/[^\w\s]/gi, '') : '';
		}

		function convertToTrustHtml(text) {
			return $sce.getTrustedHtml(text);
		}

		function isEqual(str1, str2) {
			if (str1 && str2) return str1 === str2;
			if (!str1 && !str2) return true;
			return false;
		}

		function extractJSON(str) {
			var firstOpen, firstClose, candidate;
			firstOpen = str.indexOf('{', firstOpen + 1);
			do {
				firstClose = str.lastIndexOf('}');
				if (firstClose <= firstOpen) {
					return null;
				}
				do {
					candidate = str.substring(firstOpen, firstClose + 1);
					try {
						var res = JSON.parse(candidate);
						return res;
					} catch (e) {
						console.log('...failed');
					}
					firstClose = str.substr(0, firstClose).lastIndexOf('}');
				} while (firstClose > firstOpen);
				firstOpen = str.indexOf('{', firstOpen + 1);
			} while (firstOpen != -1);
		}

		function removeDashAndCamelCase(string) {
			return string.replace(/-([a-z])/ig, function (all, letter) {
				return letter.toUpperCase();
			});
		}

		function replaceDashBySpace(string) {
			return string.replace(/-/g, ' ');
		}

		function isValueString(ele) {
			if (ele == null) {
				return false;
			} else {
				return true;
			}
		}

		function cutStringByCount(string, index, replacement) {
			return string.substr(0, index) + replacement;
		}

		return {
			buildString: buildString,
			arrayToString: arrayToString,
			capitalizeChar: capitalizeChar,
			extractNumberFromString: extractNumberFromString,
			toTitleCase: toTitleCase,
			replaceAt: replaceAt,
			htmlToPlaintext: htmlToPlaintext,
			convertToTrustHtml: convertToTrustHtml,
			isEqual: isEqual,
			extractJSON: extractJSON,
			camelCaseToTitleCase: camelCaseToTitleCase,
			toSnakeCase: toSnakeCase,
			removeDashAndCamelCase: removeDashAndCamelCase,
			replaceDashBySpace: replaceDashBySpace,
			isValueString: isValueString,
			cutStringByCount: cutStringByCount,
			removeSpecialChar: removeSpecialChar
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('responsiveUtils', responsiveUtils);

    responsiveUtils.$inject = ['$timeout'];

    function responsiveUtils($timeout) {
        
        function isPortrait(){
            var $window = $(window);
            return $window.height() > $window.width();
        }
        function isIphoneOrAndroid(){
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/android/i.test(userAgent)) {
                return "Android";
            }
        
            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }
        }
    //------------------------------------------------------------------------------------------------------------------
        return {
           isPortrait: isPortrait,
           isIphoneOrAndroid: isIphoneOrAndroid
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('portfolioUtils', portfolioUtils);

	portfolioUtils.$inject = ['pathUtils'];

	function portfolioUtils(pathUtils) {

		function getInstance() {
			return {
				title: '',
				description: '',
				privateOnly: false,
				type: 'portfolio'
			}
		}

		function extractIdsFromGalleries(galleries) {
			return _.reduce(galleries, function (memo, gallery) {
				memo.push(gallery.id);
				return memo;
			}, []);
		}

		function buildGalleriesFromIds(galleryIds) {
			return _.reduce(galleryIds, function (memo, id) {
				memo.push({
					id: id
				});
				return memo;
			}, []);
		}

		function extractGalleriesName(galleries) {
			var arr = _.reduce(galleries, function (memo, gallery) {
				memo.push(gallery.title);
				return memo;
			}, []);
			return _.uniq(arr);
		}

		function updateThumnailPath(gallery) {
			if (!gallery.media.length) return;
			if (!gallery.media[0].id || /\s/.test(gallery.media[0].id)) {
				//null id or it has any kind of whitespace
				Sentry.captureException(gallery);
			}
			gallery.coverPath = gallery.media[0].id ? pathUtils.buildFilePath(gallery.media[0].id, "600x") : '';
			gallery.thumbnailPath = [];
			for (var i = 0; i < gallery.media.length; i++) {
				var thumbnailPath = pathUtils.buildFilePath(gallery.media[i].id, "600x");
				gallery.thumbnailPath.push(thumbnailPath);
			}
		}

		return {
			getInstance: getInstance,
			extractIdsFromGalleries: extractIdsFromGalleries,
			buildGalleriesFromIds: buildGalleriesFromIds,
			extractGalleriesName: extractGalleriesName,
			updateThumnailPath: updateThumnailPath
		};
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .factory('photoGridUtils', photoGridUtils);

  photoGridUtils.$inject = ['galleryUtils', 'sessionManagerSvc', 'accountUtils'];

  function photoGridUtils(galleryUtils, sessionManagerSvc, accountUtils) {
    function transformMedia(photo) {
      var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;

      photo.url = photo.thumbnails["w/1024x"];
      photo.urlSmall = photo.thumbnails["x400"];
      photo.urlMedium = photo.thumbnails["x650"];
      photo.thumbnail = photo.thumbnails["160x"];
      photo.path = window.location.protocol + "//" + window.location.host + "/#!/photo/" + photo.id;
      photo.isMine = (mLoginnedUser && photo.user) ? mLoginnedUser.id === photo.user.id : false;
      photo.price = photo.price == -1 ? null : photo.price;
      if (photo.user) accountUtils.transformUserData(photo.user);
      if (!photo.galleries && photo.gallery_ids || (photo.galleries && photo.gallery_ids && photo.gallery_ids.length !== photo.galleries.length)) {
        photo.galleries = galleryUtils.buildGalleriesFromIds(photo.gallery_ids);
      }
    }

    function transformMedias(photos) {
      for (var i = 0; i < photos.length; i++) {
        transformMedia(photos[i]);
      }
    }

    return {
      transformMedias: transformMedias,
      transformMedia: transformMedia
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('pathUtils', pathUtils);

    pathUtils.$inject = ['fileConst', 'pixerfUrl'];

    function pathUtils(fileConst, pixerfUrl) {
        function getWebrootUrl(){
            return window.location.protocol + "//" + window.location.host;
        }
        function getFallbackFileUrl(){
            return getWebrootUrl()  + "/assets/images/icon-market.png";
        }
        function buildUserProfilePath(userId, size, noCache){
            if(!size) size = '300x';
            return pixerfUrl.full + 'api/users/' + userId + '/profile/' + size + (noCache ? '?' + new Date().getTime() : '');
        }
        function buildFilePath(fileId, size, type){
            if(!fileId){
                return getFallbackFileUrl();
            }
            return type ? pixerfUrl.full + 'thumbnail/' + type + '/' +  fileId + '/' +  size  : pixerfUrl.full + 'thumbnail/' +  fileId + '/' +  size;
        }
        return {
            getWebrootUrl: getWebrootUrl,
            buildFilePath: buildFilePath,
            buildUserProfilePath: buildUserProfilePath
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('pagingUtils', pagingUtils);

    pagingUtils.$inject = [];

    function pagingUtils() {
        function isNoMorePageToLoad(currentPage, response){
            var totalPage = getTotalPage(response);
            if(typeof currentPage !== "number") currentPage = parseInt(currentPage);
            if(totalPage <= 1) return true;
            return currentPage >= totalPage;
        }
        function scrollToTop(){
            var $target = $("html, body");
            $target.stop().animate({ scrollTop: 0 }, '500', 'swing');

        }
        function getTotalPage(response){
            var pageNum = response.headers("total-pages");
            if(!pageNum) pageNum = response.headers("Total-Pages");
            if(!pageNum) return 0;
            return parseInt(pageNum);
        }
        function getTotalCount(response){
            var totalCount = response.headers("total");
            if(!totalCount) totalCount = response.headers("Total");
            if(!totalCount) return 0;
            return parseInt(totalCount);
        }
    //------------------------------------------------------------------------------------------------------------------
        return {
           isNoMorePageToLoad: isNoMorePageToLoad,
           scrollToTop: scrollToTop,
           getTotalPage: getTotalPage,
           getTotalCount: getTotalCount
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('numberUtils', numberUtils);

    numberUtils.$inject = [];

    function numberUtils() {
        function fraction2Decimal(value){
            try{
                return eval(value);
            }catch(ex){
                return null;
            }
        }
        function parseInt(str){
            try{
                return window.parseInt(str);
            }catch(ex){
                return null;
            }
        }
        function formatNumber(number, separtor, numCharacter){
            separtor = separtor ? separtor : ",";
            numCharacter = numCharacter ? numCharacter : 3;
            if(!number) return "0";
            var re = new RegExp('\\B(?=(\\d{' + numCharacter +  '})+(?!\\d))', 'g');
            return number.toString().replace(re, separtor);
        }
        function getRandomInRange(start, end){
            return Math.floor(Math.random() * end) + start;
        }
        function formatNumberByK(number){
            var thousand = 1000;
            if(number < thousand) return number;
            var mod = number % thousand;
            if(mod === 0){
                return (number/thousand) + "K";
            }
            if(mod < thousand*0.1){
                return (number/thousand).toFixed(0) + 'K';
            }
            return (number/thousand).toFixed(1) + 'K';
        }
    //------------------------------------------------------------------------------------------------------------------
        return {
           fraction2Decimal: fraction2Decimal,
           parseInt: parseInt,
           formatNumber: formatNumber,
           getRandomInRange: getRandomInRange,
           formatNumberByK: formatNumberByK
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .factory('galleryUtils', galleryUtils);

  galleryUtils.$inject = ['pathUtils', 'galleryConst', 'systemUtils'];

  function galleryUtils(pathUtils, galleryConst, systemUtils) {

    function getInstance() {
      return {
        title: '',
        description: '',
        privateOnly: false
      }
    }

    function extractIdsFromGalleries(galleries) {
      return _.reduce(galleries, function (memo, gallery) {
        memo.push(gallery.id);
        return memo;
      }, []);
    }

    function buildGalleriesFromIds(galleryIds) {
      return _.reduce(galleryIds, function (memo, id) {
        memo.push({
          id: id
        });
        return memo;
      }, []);
    }

    function extractGalleriesName(galleries) {
      var arr = _.reduce(galleries, function (memo, gallery) {
        memo.push(gallery.title);
        return memo;
      }, []);
      return _.uniq(arr);
    }

    function updateThumnailPath(gallery, getOriginal) {
      if (getOriginal && gallery.cover_media) {
        gallery.thumbnailPath = systemUtils.wrapQuotes(gallery.cover_media.thumbnails["x400"]);
        gallery.coverImagePath = gallery.cover_media.thumbnails["original"] ? systemUtils.wrapQuotes(gallery.cover_media.thumbnails["original"]) : systemUtils.wrapQuotes(gallery.cover_media.thumbnails["1440x"]);
      } else if (!gallery.cover_media) {
        gallery.thumbnailPath = systemUtils.wrapQuotes(gallery.cover_image ? pathUtils.buildFilestackPath(gallery.cover_image, "resize=height:600") : '');
        gallery.coverImagePath = systemUtils.wrapQuotes(gallery.cover_image ? pathUtils.buildFilestackPath(gallery.cover_image, "resize=width:1440") : '');
      } else {
        gallery.thumbnailPath = systemUtils.wrapQuotes(gallery.cover_media.thumbnails["x400"]);
        gallery.coverImagePath = systemUtils.wrapQuotes(gallery.cover_media.thumbnails["1440x"]);
      }
    }

    function getGalleryType(gallery, user) {
      if (gallery.is_curated) return galleryConst.GALLERY_TYPE.CURATED;
      if (gallery.user.id !== user.id) return galleryConst.GALLERY_TYPE.FOLLOWING;
      return galleryConst.GALLERY_TYPE.DEFAULT;
    }

    return {
      getInstance: getInstance,
      extractIdsFromGalleries: extractIdsFromGalleries,
      buildGalleriesFromIds: buildGalleriesFromIds,
      extractGalleriesName: extractGalleriesName,
      updateThumnailPath: updateThumnailPath,
      getGalleryType: getGalleryType
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('fileUtils', fileUtils);

    fileUtils.$inject = ['fileConst', 'pathUtils', 'sessionManagerSvc'];

    function fileUtils(fileConst, pathUtils, sessionManagerSvc) {
        function findFileById(files, id){
            if(typeof id !=="number") id = parseInt(id);
            return _.find(files, function(p){
                return p.id === id;
            });

        }
        function transform(photo, freshImage){
            var fingerPrint = freshImage ? ("?" + new Date().getTime()) : '';
            var sizeSmall = photo.width > photo.height ? "x400" : "400x";
            photo.url =  pathUtils.buildFilePath(photo.id, "1024x") + fingerPrint;
            photo.urlSmall = pathUtils.buildFilePath(photo.id, sizeSmall) + fingerPrint;
            if(photo.user){
                photo.user.displayName = buildUserDisplayName(photo.user);
            }
        }
        function transforms(photos){
            for (var i =0; i < photos.length; i ++){
                transform(photos[i]);
            }
            return photos;
        }
        function buildUserDisplayName(loginedUser){
            if(!loginedUser) return '';
            var username = '';

            if(loginedUser.organization && loginedUser.organization.name){
                username = loginedUser.organization.name;
            } else if (loginedUser.first_name || loginedUser.last_name) {
                var first_name = loginedUser.first_name ? loginedUser.first_name : '';
                var last_name = loginedUser.last_name ? loginedUser.last_name : '';
                username = first_name + ' '+ last_name;
            }
            if(!username){
                username = loginedUser.email;
            }
            return username;
        }

    //------------------------------------------------------------------------------------------------------------------
        return {
           findFileById: findFileById,
           transforms: transforms,
           transform: transform
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('dateUtils', dateUtils);

	dateUtils.$inject = ['numberUtils'];

	function dateUtils(numberUtils) {
		function getRecentYears(howManyYears) {
			var currentYear = new Date().getFullYear();
			var result = [];
			for (var i = 0; i < howManyYears; i++) {
				result.push(currentYear - i);
			}

			return result;
		}

		function formatToString(value, formatPattern) {
			if (!formatPattern) formatPattern = 'DD MMMM YYYY';
			return moment(value).format(formatPattern);
		}

		function getDateFrom(fromDate, howMany, unit) {
			return fromDate.subtract(numberUtils.parseInt(howMany), unit).valueOf();
		}

		function getStartOfYear(year) {
			return moment("01/01/" + year, "DD/MM/YYYY").valueOf();
		}

		function getEndOfYear(year) {
			return moment("31/12/" + year, "DD/MM/YYYY").valueOf();
		}

		function getMonthDateRange(month, year) {
			var startDate = moment([year, month - 1]).valueOf();
			var endDate = moment(startDate).endOf('month').valueOf();
			return {
				start: startDate,
				end: endDate
			};
		}

		function now(format) {
			if (!format) return moment().valueOf();
			return moment().format(format);
		}

		function isInWeek(time) {
			var today = moment();
			return today.diff(moment.utc(time).local(), "days") <= 7;
		}

		function countDown(deadline, step) {
			if (!moment.isMoment(deadline)) return "Not momment object";
			var diff = deadline.diff(moment(), "milliseconds");
			var duration = moment.duration(diff, 'milliseconds');
			return duration - step; //step in ms
		}

		function preciseDiff(from, to){
			var result = []
			var duration = moment.duration(from.diff(to));

			var years = duration.years();
			if(years) result.push(years + 'y');

			var months = duration.months();
			if(months) result.push(months+ 'm');

			var days = duration.days();
			if(days || !result.length) result.push(days+ 'd');

			return result.join(' ');
		}

		return {
			formatToString: formatToString,
			getRecentYears: getRecentYears,
			getDateFrom: getDateFrom,
			getStartOfYear: getStartOfYear,
			getEndOfYear: getEndOfYear,
			getMonthDateRange: getMonthDateRange,
			now: now,
			isInWeek: isInWeek,
			countDown: countDown,
			preciseDiff: preciseDiff
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('arrayUtils', arrayUtils);

    arrayUtils.$inject = [];

    function arrayUtils() {
        function shuffle(array) {
            var currentIndex = array.length, temporaryValue, randomIndex;

            // While there remain elements to shuffle...
            while (0 !== currentIndex) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }

            return array;
        }
        function indexOf(array, iterator){
            for(var i = 0; i < array.length; i ++){
                if(iterator(array[i])) return i;
            }
            return -1;
        }
        function swapElement(array, one, two){
            var indexOne = _.indexOf(array, one);
            var indexTwo = _.indexOf(array, two);
            if(indexOne !== -1 && indexTwo !== -1) {
                var temp = array[indexOne];
                array[indexOne] = array[indexTwo];
                array[indexTwo] = temp;
            }
        }
        function isEqual(one, two, propertyOne, propertyTwo){
            if((!one && two) || (one && !two)) return false;
            if(one.length !== two.length) return false;
            for (var i = 0; i < one.length; i++){
                var found = _.find(two, function(gl){
                    var oneValue = one[i].hasOwnProperty(propertyOne) ? one[i][propertyOne] : one[i];
                    var twoValue = gl.hasOwnProperty(propertyTwo) ? gl[propertyTwo] : gl;
                    
                    return oneValue === twoValue;

                })
                if(!found) return false;
            }
            return true;
        }
        function getIntersection(arrays, comparedProperty) {
            var i, all, shortest, nShortest, n, len, ret = [], obj={}, nOthers;
            nOthers = arrays.length-1;
            nShortest = arrays[0].length;
            shortest = 0;
            for (i=0; i<=nOthers; i++){
              n = arrays[i].length;
              if (n<nShortest) {
                shortest = i;
                nShortest = n;
              }
            }
          
            for (i=0; i<=nOthers; i++) {
              n = (i===shortest)?0:(i||shortest); //Read the shortest array first. Read the first array instead of the shortest
              len = arrays[n].length;
              for (var j=0; j<len; j++) {
                  var elem = arrays[n][j][comparedProperty];
                  if(obj[elem] === i-1) {
                    if(i === nOthers) {
                      ret.push(arrays[n][j]);
                      obj[elem]=0;
                    } else {
                      obj[elem]=i;
                    }
                  }else if (i===0) {
                    obj[elem]=0;
                  }
              }
            }
            return ret;
        }  
    //------------------------------------------------------------------------------------------------------------------
        return {
           shuffle: shuffle,
           indexOf: indexOf,
           swapElement: swapElement,
           isEqual: isEqual,
           getIntersection: getIntersection
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('accountUtils', accountUtils);

    accountUtils.$inject = ['pathUtils', 'pixerfUrl'];

    function accountUtils(pathUtils, pixerfUrl) {

        function buildUserDisplayName(loginedUser){
            if(!loginedUser) return '';
            var username = '';

            if(loginedUser.organization && loginedUser.organization.name){
                username = loginedUser.organization.name;
            } else if (loginedUser.first_name || loginedUser.last_name) {
                var first_name = loginedUser.first_name ? loginedUser.first_name : '';
                var last_name = loginedUser.last_name ? loginedUser.last_name : '';
                username = first_name + ' '+ last_name;
            }
            if(!username){
                username = loginedUser.email;
            }
            return username;
        }
        function isSocialAccount(loginedUser){
            if(loginedUser && loginedUser.facebook) return true;
            if(!loginedUser || !loginedUser.username) return false;
            return loginedUser.username.indexOf("auth0|") === -1 ;
        }
        function getUserDefaultAvatarUrl(user){
            var isFacebookAccount = isSocialAccount(user);
            var facebookId = "";
            if(isFacebookAccount){
                facebookId = user.facebook ? user.facebook : user.username.split("|")[1];
            }

            var avatar = {
                coverImage:  'assets/images/default/default-cover.png',
                profileImage:  isFacebookAccount  ? "http://graph.facebook.com/" + facebookId + "/picture?type=large" : pixerfUrl.full + 'api/avatar?name=' + user.displayName,
                profileImageBig: isFacebookAccount  ? "http://graph.facebook.com/" + facebookId + "/picture?type=large" : pixerfUrl.full + 'api/avatar?name=' + user.displayName,
                profileImageSmall: isFacebookAccount  ? "http://graph.facebook.com/" + facebookId + "/picture?type=large" : pixerfUrl.full + 'api/avatar?name=' + user.displayName
            };
            return avatar;

        }
        function buildUserProfilePhotoUrl(userid, noCache){
            return {
                profileImageSmall : pathUtils.buildUserProfilePath(userid, "100x", noCache),
                profileImage : pathUtils.buildUserProfilePath(userid, "300x", noCache),
                profileImageBig : pathUtils.buildUserProfilePath(userid, "800x", noCache)
            }
        }
        function buildUserAvatarPhotoUrl(user, noCache){
            if(!user) return {};
            var avatarUrl = getUserDefaultAvatarUrl(user);
            if (user.profile_image){
                var paths = buildUserProfilePhotoUrl(user.id, noCache);

                avatarUrl.profileImageSmall = paths.profileImageSmall;
                avatarUrl.profileImage = paths.profileImage;
                avatarUrl.profileImageBig = paths.profileImageBig;
            }
            return avatarUrl;
        }
        
        
        function transformUserData(rawData){
            if(rawData){
                rawData.isJudge = rawData.role === "judge";
                rawData.isCurator = rawData.role === "curator_internal";
                rawData.isAdmin = rawData.isCurator || rawData.role == "admin" || rawData.role == "admin_internal"
                rawData.displayName =  buildUserDisplayName(rawData);
                rawData.avatar = buildUserAvatarPhotoUrl(rawData);
            }
            return rawData;
        }
        return {
            buildUserDisplayName: buildUserDisplayName,
            isSocialAccount: isSocialAccount,
            buildUserAvatarPhotoUrl: buildUserAvatarPhotoUrl,
            transformUserData: transformUserData,
            buildUserProfilePhotoUrl: buildUserProfilePhotoUrl
        };
    }
})();
(function(){
'use strict';
  angular
    .module('pixerf')
    .factory('socketSvc', socketSvc);

    socketSvc.$inject = ['pixerfUrl', '$log', 'systemUtils'];
    function socketSvc (pixerfUrl, $log, systemUtils){
        var PIXERF_TOPICS = {
            IOA: {
                name: 'ioa',
                isSubscribed: false
            }
        };
        var mTopicSubscribeStatus = {
            
        }
        var mIsGeneralChannelSubscribed = false;
        var mSocket = null;
        var mGeneralChannel = null;
        var mPrivateChannel = null;
        function connect(){
            if(!mSocket) {
                mSocket = new Phoenix.Socket('wss://' + pixerfUrl.domainOnly + '/socket' , {});
                mSocket.connect();
            }
            mSocket.onOpen(function(){
                $log.info("Socket Open");
            })
            mSocket.onError(function(){
                mSocket = null;
                $log.error("Socket error");
            })
            mSocket.onClose(function(){
                mSocket = null;
                $log.info("Socket close");
            })
        }
        function joinPublicChannel(){
            if(mSocket) return;
            connect();
            mGeneralChannel = mSocket.channel("room:general", {});
            mGeneralChannel.join();
            mGeneralChannel.on("joined" ,function(){
                console.log('joined');
            })
            return mGeneralChannel;
        }
        function joinPrivateChannel(username, token){
            if(mSocket) return;
            connect();
            mPrivateChannel = mSocket.channel("room:" + username, { guardian_token: token });
            mPrivateChannel.join();
        }
        function close(){
            mSocket.close();
        }
        function getPrivateChannel(){
            return mPrivateChannel;
        }
        function getPublicChannel(){
            return mGeneralChannel;
        }
        function subscribeTopic(topic, handler){
            if(mGeneralChannel && mGeneralChannel.state === "joined" && !PIXERF_TOPICS[topic].isSubscribed){
                PIXERF_TOPICS[topic].isSubscribed = true;
                mGeneralChannel.off(PIXERF_TOPICS[topic].name);
                mGeneralChannel.on(PIXERF_TOPICS[topic].name, function(msg){
                    console.log(msg);
                    handler(msg);
                })
                mGeneralChannel.onClose(PIXERF_TOPICS.NOTIFICATIONS, function(msg){
                    PIXERF_TOPICS[topic].isSubscribed = false;
                })
                mGeneralChannel.onError(PIXERF_TOPICS.NOTIFICATIONS, function(msg){
                    PIXERF_TOPICS[topic].isSubscribed = false;
                })
            }
        }


        return { 
            joinPrivateChannel: joinPrivateChannel,
            joinPublicChannel: joinPublicChannel,
            getPrivateChannel: getPrivateChannel,
            getPublicChannel: getPublicChannel,
            PIXERF_TOPICS: PIXERF_TOPICS,
            subscribeTopic: subscribeTopic
        };
    }
})();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .factory('pixerfApiUserSvc', pixerfApiUserSvc);

  pixerfApiUserSvc.$inject = ['$resource', 'pixerfUrl', 'accountUtils', 'photoGridUtils'];

  function pixerfApiUserSvc($resource, pixerfUrl, accountUtils, photoGridUtils) {
    return $resource(pixerfUrl.full + 'api/users/:id/:action', {}, {
      'me': {
        url: pixerfUrl.full + 'api/me',
        method: 'GET',
        params: {},
        interceptor: {
          response: function (response) {
            return accountUtils.transformUserData(response.data);
          }
        }
      },
      'get': {
        method: 'GET',
        params: {},
        interceptor: {
          response: function (response) {
            return accountUtils.transformUserData(response.data);
          }
        }
      },
      'get_medias': {
        method: "POST",
        isArray: true,
        params: {
          action: "media"
        },
        interceptor: {
          response: function (response) {
            photoGridUtils.transformMedias(response.data);
            return response;
          }
        }
      },
    });
  }
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiPortfolioSvc', pixerfApiPortfolioSvc);

	pixerfApiPortfolioSvc.$inject = ['$resource', 'pixerfUrl', 'portfolioUtils'];

	function pixerfApiPortfolioSvc($resource, pixerfUrl, portfolioUtils) {

		function transformGalleriesData(galleries) {
			var gallery;
			for (var i = 0; i < galleries.length; i++) {
				gallery = galleries[i];
				transformGalleryData(gallery);
			}
			return galleries;
		}

		function transformGalleryData(gallery) {
			portfolioUtils.updateThumnailPath(gallery);
		}

		return $resource(pixerfUrl.full + 'api/portfolios/:id/:action/:photoid', {
			id: '@id'
		}, {
			'get': {
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getById': {
				url: pixerfUrl.full + 'api/users/:userid/portfolios/:portfoliosid',
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getUserPortfolios': {
				method: 'GET',
				url: pixerfUrl.full + 'api/users/:userid/portfolios',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						response.data = transformGalleriesData(response.data);
						return response;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiMissionSvc', pixerfApiMissionSvc);

	pixerfApiMissionSvc.$inject = ['$resource', 'pixerfUrl', 'accountUtils', 'pathUtils'];

	function pixerfApiMissionSvc($resource, pixerfUrl, accountUtils, pathUtils) {
		
		function transformMedia(media){
			if(media.user) accountUtils.transformUserData(media.user);
			media.urlSmall = pathUtils.buildFilePath(media.id, "x600");
			media.url =  pathUtils.buildFilePath(media.id, "1024x");
		}
		function transformPrizes(prizes){
			for(var i = 0; i < prizes.length; i ++){
				var prize = prizes[i];
				if(prize.type !== "WINNER" && prize.type !== "CONSOLATION"){
					prize.type = "WINNER";
				}
				if(prize.winner){
					transformMedia(prizes[i].winner.media);
				}
			}
		}
		return $resource(pixerfUrl.full + 'api/missions/:id', {}, {
			'get': {
				method: 'GET',
				interceptor: {
					response: function (response) {
						transformPrizes(response.data.mission.prizes);
						return response.data;
					}
				}
			}
		});
	}
})();

(function () {
    'use strict';
    angular
        .module('pixerf')
        .factory('pixerfApiMediaSvc', pixerfApiMediaSvc);

    pixerfApiMediaSvc.$inject = ['$resource', 'pixerfUrl', 'fileUtils', 'localStorageService'];

    function pixerfApiMediaSvc($resource, pixerfUrl, fileUtils, localStorageService) {
        function transformVote(vote){
            return {id: vote.id, point: vote.vote_count};
        }
        return $resource(pixerfUrl.full + 'api/missions/:id/participations/:participation_id/:action', {}, {
            'get_submissions': {
                method: 'GET',
                isArray: true,
                interceptor: {
                    response: function (response) {
                        fileUtils.transforms(response.data);
                        return response;
                    },
                    responseError: function(){
                        var response = {
                            data: []
                        };
                        
                    }
                }
            },
            'get_votes': {
                method: 'GET',
                params: {'action': 'votes'},
                interceptor: {
                    response: function(response){
                        for(var i =0; i < response.data.votes.length; i ++){
                            response.data.votes[i].user.displayName = response.data.votes[i].user.first_name + ' ' + response.data.votes[i].user.last_name;
                        }
                        return response.data.votes;
                    }
                }
            },
            'vote': {
                url: pixerfUrl.full + 'api/missions/:id/participations/:participationId/vote',
                method: 'POST',
                interceptor: {
                    response: function (response) {
                        response.data = transformVote(response.data.vote);
                        return response.data;
                    }
                }
            },
            'updateVote': {
                url: pixerfUrl.full + 'api/missions/:id/participations/:participationId/vote',
                method: 'PUT',
                interceptor: {
                    response: function (response) {
                        response.data = transformVote(response.data.vote);
                        return response.data;
                    }
                }
            },
            'unvote': {
                url: pixerfUrl.full + 'api/missions/:id/participations/:participationId/unvote',
                method: 'DELETE',
                interceptor: {
                    response: function (response) {
                        response.data = transformVote(response.data.vote);
                        return response.data;
                    }
                }
            },
            'winners': {
                url: pixerfUrl.full + 'api/events/2/winners',
                method: 'GET',
                interceptor: {
                    response: function (response) {
                        fileUtils.transforms(response.data.data);
                        return response;
                    }
                }
            },


        });
    }
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiMediaDetailSvc', pixerfApiMediaDetailSvc);

		pixerfApiMediaDetailSvc.$inject = ['$resource', 'pixerfUrl', 'accountUtils', 'fileUtils'];

	function pixerfApiMediaDetailSvc($resource, pixerfUrl, accountUtils, fileUtils) {

		return $resource(pixerfUrl.full + 'api/media/:id/:action/:commentid/:api_version', {
			id: '@id'
		}, {
			'get_clarifai': {
				method: 'GET',
				params: {
					action: 'clarifai'
				}
			},
			'delete_by_handles': {
				url: pixerfUrl.full + 'api/media/handles/:handles',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'get': {
				method: 'GET',
				interceptor: {
					response: function (response) {
						fileUtils.transform(response.data);
						return response;
					}
				}
			},
			'update': {
				method: 'PUT'
			},
			'multipleUpdate': {
				params: {
					action: 'many'
				},
				method: 'PUT',
				isArray: true
			},
			'getComment': {
				url: pixerfUrl.full + 'api/media/:id/:action/:commentid',
				params: {
					action: 'comments'
				},
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data.length > 0) {
							for (var i = 0; i < response.data.length; i++) {
								accountUtils.transformUserData(response.data[i].user);
							}
						}
						return response;
					}
				}
			},
			'createComment': {
				url: pixerfUrl.full + 'api/media/:id/:action/:commentid',
				params: {
					action: 'comments'
				},
				method: 'POST'
			},
			'editComment': {
				params: {
					action: 'comments'
				},
				method: 'PUT'
			},
			'deleteComment': {
				params: {
					action: 'comments'
				},
				method: 'DELETE'
			},
			'getLikes': {
				params: {
					action: 'likes'
				},
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data.length > 0) {
							for (var i = 0; i < response.data.length; i++) {
								accountUtils.transformUserData(response.data[i]);
							}
						}
						return response;
					}
				}
			},
			'nominate': {
				params: {
					action: 'nominations'
				},
				method: 'POST'
			},
			'star': {
				params: {
					action: 'stars'
				},
				method: 'POST'
			},
			'delete_star': {
				params: {
					action: 'stars'
				},
				method: 'DELETE'
			},
			'search': {
				method: 'POST',
				params: {
					action: 'search'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						fileUtils.transforms(response.data);
						return response;
					}
				}
			},
			'getTemporary': {
				method: 'GET',
				url: pixerfUrl.full + 'api/media/temporary',
				isArray: true,
				interceptor: {
					response: function (response) {
						fileUtils.transforms(response.data);
						return response;
					}
				}
			},
			'getSimilar': {
				method: 'GET',
				params: {
					action: 'more_like_this'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						fileUtils.transforms(response.data);
						return response;
					}
				}
			},
			'send_release_form': {
				url: pixerfUrl.full + 'api/release',
				method: 'POST'
			},
			'upload_release_form': {
				url: pixerfUrl.full + 'api/media/release',
				method: 'POST'
			},
			'upload': {
				url: pixerfUrl.full + 'api/media/store',
				method: 'POST'
			},
			'upload_to_mission': {
				url: pixerfUrl.full + 'api/missions/:mission_id/participations/upload',
				method: 'POST'
			},
			'get_release_form': {
				url: pixerfUrl.full + 'api/media/releases',
				method: 'GET'
			},
			'request_release_form': {
				url: pixerfUrl.full + 'api/media/releases/reminder',
				method: 'POST',
				interceptor: {
					responseError: function (response) {
						return response.data;
					}
				}
			},
            'download_release_by_id':{
                url: pixerfUrl.full + 'api/media/releases/:id/prepare_download',
				method: 'POST',
                interceptor: {
					responseError: function (response) {
						return response.data;
					}
				}
            },
			'review': {
				method: 'PUT',
				params: {
					action: 'review'
				}
			},
			'price_range': {
				url: pixerfUrl.full + 'api/media/:handle/price_range',
				method: 'GET',
				isArray: true
			},
			'add_to_gallery': {
				url: pixerfUrl.full + 'api/media/:id/add_to_gallery/:gallery_id',
				method: 'PUT'
			},
			'remove_from_gallery': {
				url: pixerfUrl.full + 'api/media/:id/remove_from_gallery/:gallery_id',
				method: 'DELETE'
			},
			'removeFromPortfolioGallery': {
				url: pixerfUrl.full + 'api/media/:id/remove_from_portfolio_gallery/:portfolio_gallery_id',
				method: 'DELETE',
				interceptor: {
					responseError: function (response) {
						return response;
					}
				}
			},
			'reject_reasons': {
				url: pixerfUrl.full + 'api/media/reject_reasons',
				method: 'GET',
				isArray: true
			},
			'get_showcased_gallery': {
				url: pixerfUrl.full + 'api/showcased_gallery',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						fileUtils.transforms(response.data);
						return response;
					}
				}
			},
			'set_showcased_gallery': {
				url: pixerfUrl.full + 'api/showcased_gallery',
				method: 'PUT'
			},
			'remove_showcased_gallery': {
				url: pixerfUrl.full + 'api/showcased_gallery',
				method: 'DELETE'
			},
			'overrideUnstar': {
				url: pixerfUrl.full + 'api/media/:media_id/stars/:id',
				method: 'DELETE'
			},
			'get_stars': {
				url: pixerfUrl.full + 'api/media/:id/stars',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i].user);
						}
						return response;
					}
				}
			},
		});
	}
})();

(function(){
'use strict';
  angular
    .module('pixerf')
    .factory('pixerfApiMailSvc', pixerfApiMailSvc);

    pixerfApiMailSvc.$inject = ['$resource', 'pixerfUrl'];

    function pixerfApiMailSvc ($resource, pixerfUrl){
    	return $resource(pixerfUrl.full + '', {}, {
            'sendReservation': {
                url: pixerfUrl.full + 'api/events/:id/register',
                method: 'POST'

            },

        });
    }
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiKeywordSvc', pixerfApiKeywordSvc);

	pixerfApiKeywordSvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiKeywordSvc($resource, pixerfUrl) {
		function transform(keywords) {
			return _.reduce(keywords, function (memo, keyword) {
				memo.push(keyword.trim());
				return memo;
			}, []);
		}
		return $resource(pixerfUrl.full + 'api/thesaurus', {}, {
			'query': {
				interceptor: {
					response: function (response) {
						return transform(response.data.data);
					}
				},
				isArray: false
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiGallerySvc', pixerfApiGallerySvc);

	pixerfApiGallerySvc.$inject = ['$resource', 'pixerfUrl', 'accountUtils', 'galleryUtils', 'photoGridUtils'];

	function pixerfApiGallerySvc($resource, pixerfUrl, accountUtils, galleryUtils, photoGridUtils) {
		function transformGalleriesData(galleries) {
			var gallery;
			for (var i = 0; i < galleries.length; i++) {
				gallery = galleries[i];
				transformGalleryData(gallery);
			}
			return galleries;
		}

		function transformGalleryData(gallery) {
			galleryUtils.updateThumnailPath(gallery);
			accountUtils.transformUserData(gallery.user);
		}
		return $resource(pixerfUrl.full + 'api/galleries/:id/:action/:photoid', {
			id: '@id'
		}, {
			'query': {
				method: 'GET',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						if (response.data.length > 0) {
							response.data = transformGalleriesData(response.data);
						}
						return response;
					}
				}
			},
			'get_medias': {
				isArray: true,
				params: {
					action: "media"
				},
				interceptor: {
					response: function (response) {
						photoGridUtils.transformMedias(response.data);
						return response;
					}
				}
			},
			'getUserGalleries': {
				method: 'GET',
				url: pixerfUrl.full + 'api/users/:userid/galleries',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						if (response.data.length > 0) {
							response.data = transformGalleriesData(response.data);
						}
						return response;
					}
				}
			},
			'get': {
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						if (response.data) {
							transformGalleryData(response.data);
						}
						return response;
					}
				}
			},
			'put': {
				method: 'PUT',
				params: {},
				interceptor: {
					response: function (response) {
						if (response.data) {
							transformGalleryData(response.data);
						}
						return response;
					}
				}
			},
			'save': {
				method: 'POST',
				params: {},
				interceptor: {
					response: function (response) {
						if (response.data) {
							transformGalleryData(response.data);
						}
						return response.data;
					}
				}
			},
			'star': {
				params: {
					action: 'stars'
				},
				method: 'POST'
			},
			'delete_star': {
				params: {
					action: 'stars'
				},
				method: 'DELETE'
			},
			'get_stars': {
				url: pixerfUrl.full + 'api/galleries/:id/stars',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i].user);
						}
						return response;
					}
				}
			},
			'toggle_signature': {
				url: pixerfUrl.full + 'api/galleries/:id/toggle_signature',
				params: {},
				method: 'POST'
			},
			'overrideUnstar': {
				url: pixerfUrl.full + 'api/galleries/:gallery_id/stars/:id',
				method: 'DELETE'
			},
			'getMoreLikeThis': {
				url: pixerfUrl.full + 'api/galleries/:id/more_like_this',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i].user);
							galleryUtils.updateThumnailPath(response.data[i]);
						}
						return response;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiDownloadSvc', pixerfApiDownloadSvc);

	pixerfApiDownloadSvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiDownloadSvc($resource, pixerfUrl) {
		return $resource(pixerfUrl.full + 'api/prepare_download', {}, {
			'order_receipt': {
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'transaction_receipt': {
				url: pixerfUrl.full + 'api/prepare_download_transaction_receipt',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'record_biz_download':{
				url: pixerfUrl.full + 'api/media/create_comp_download',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiCategorySvc', pixerfApiCategorySvc);

	pixerfApiCategorySvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiCategorySvc($resource, pixerfUrl) {
		return $resource(pixerfUrl.full + 'api/categories/:id/:categoryProperty', {}, {
			'get': {
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiCartSvc', pixerfApiCartSvc);

	pixerfApiCartSvc.$inject = ['$resource', 'pixerfUrl', 'pathUtils', 'cartUtils'];

	function pixerfApiCartSvc($resource, pixerfUrl, pathUtils, cartUtils) {

		function transform(data) {
			for (var i = 0; i < data.cart_items.length; i++) {
				var cartItem = data.cart_items[i];
				if (!cartItem.media.id || /\s/.test(cartItem.media.id)) {
					//null id or it has any kind of whitespace
					Sentry.captureException(cartItem);
				}
				cartItem.media.thumbnail = pathUtils.buildFilePath(cartItem.media.id, "x500");
				cartItem.media.user.displayName = cartItem.media.user.first_name + ' ' + cartItem.media.user.last_name;

				cartUtils.updateCartSelectedVariant(cartItem, cartItem);
			}
		}
		return $resource(pixerfUrl.full + 'api/cart/:id/:photoid', {
			id: '@id'
		}, {
			'get': {
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						transform(response.data);
						return response;
					}
				}
			},
			'put': {
				method: 'PUT',
				params: {},
				interceptor: {
					response: function (response) {
						transform(response.data);
						return response;
					}
				}
			},
			'post': {
				method: 'POST',
				params: {},
				interceptor: {
					response: function (response) {
						transform(response.data);
						return response;
					}
				}
			},
			'delete': {
				params: {},
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						transform(response.data);
						return response;
					}
				}
			},
			'validate': {
				url: pixerfUrl.full + 'api/cart/validate',
				method: 'POST'
			},
			'checkGuestUserId': {
				url: pixerfUrl.full + 'api/cart/check_guest_id?id=:uuid',
				method: 'GET'
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('cartUtils', cartUtils);

	cartUtils.$inject = ['priceConst'];

	function cartUtils(priceConst) {
		function getLicenseById(extendedLicenses, id) {
			return _.find(extendedLicenses, function (item) {
				return item.id === id;
			});
		}

		function setSelectedLicense(extendedLicenses, license) {
			if (license.id === "UNLIMITED_PRINT" && license.isSelected) {
				var relatedLicense = getLicenseById(extendedLicenses, "MULTI_SEAT");
				relatedLicense.isSelected = !license.isSelected;
			} else if (license.id === "MULTI_SEAT" && license.isSelected) {
				var relatedLicense = getLicenseById(extendedLicenses, "UNLIMITED_PRINT");
				relatedLicense.isSelected = !license.isSelected;
			}
		}

		function updateCartSelectedVariant(cartItem, rawData) {
			if (!cartItem.media.extendedLicenses) {
				cartItem.media.extendedLicenses = $.extend(true, [], priceConst.EXTENDED_LICENSES);
			}

			for (var i = 0; i < cartItem.media.extendedLicenses.length; i++) {
				var license = cartItem.media.extendedLicenses[i];
				license.isSelected = !!rawData[license.key];
				setSelectedLicense(cartItem.media.extendedLicenses, license);
			}

			var priceRange = cartItem.media.price.range;
			for (var i = 0; i < priceRange.length; i++) {
				priceRange[i].isSelected = priceRange[i].size === rawData.size;
			}
		}

		function getPhotoByLineId(items, lineId) {
			var item = _.find(items, function (it) {
				return it.id === lineId;
			});
			if (item) return item.media;
		}

		return {
			updateCartSelectedVariant: updateCartSelectedVariant,
			setSelectedLicense: setSelectedLicense,
			getPhotoByLineId: getPhotoByLineId
		};
	}
})();

(function () {
    'use strict';
    angular
        .module('pixerf')
        .controller('homePageCtrl', homePageCtrl)

    homePageCtrl.$inject = ['$scope', '$timeout', '$location', '$anchorScroll', 'photoDetailPopupSvc', 'photoSvc', 'pixerfApiMediaDetailSvc'];
    function homePageCtrl($scope, $timeout, $location, $anchorScroll, photoDetailPopupSvc, photoSvc, pixerfApiMediaDetailSvc) {
        var self = this;
        self.navigate = navigate;
        self.onScrollToTopClicked = onScrollToTopClicked;
        self.onGoDownBtnClicked = onGoDownBtnClicked;
        self.onPortfolioClicked = onPortfolioClicked;
        self.spinner = {isVisible: false};
        
		self.carouselConfig = {
			slidesToShow: 4,
			slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 1500,
            infinite: true,
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 2
				}
			}]
		};

        $(document).ready(function () {
            $('#portfolioCarousel').not('.slick-initialized').slick(self.carouselConfig);
        });

        self.portfolios = [
            {
                cover_media: null,
                id: 342486,
                qaId: 26971,
                media: {},
                url: '../../ukraine-exclusive/assets/images/home-page/image-item-1.png'
            },
            {
                cover_media: null,
                id: 342483,
                qaId: 20371,
                media: {},
                url: '../../ukraine-exclusive/assets/images/home-page/image-item-2.png'
            },
            {
                cover_media: null,
                id: 342319,
                qaId: 18318,
                media: {},
                url: '../../ukraine-exclusive/assets/images/home-page/image-item-3.png'
            },
            {
                cover_media: null,
                id: 342491,
                qaId: 26440,
                media: {},
                url: '../../ukraine-exclusive/assets/images/home-page/image-item-4.png'
            }   ,
            {
                cover_media: null,
                id: 342489,
                qaId: 27397,
                media: {},
                url: '../../ukraine-exclusive/assets/images/home-page/image-item-5.png'
            } 
        ];

        function navigate(direction){
            if(direction === 'next'){
                self.slick.slickNext();
            } else {
                self.slick.slickPrev();
            }
        }

        $(window).on("orientationchange", function() {
			$timeout(function(){
				if($(window).outerHeight() > 660){
					self.isBindSlick = true;
					$scope.$apply();
				} else {
					self.isBindSlick = false;
					self.showScrollBtn = false;
					$scope.$apply();
				}
			})
		});

        function onScrollToTopClicked(){
            self.slick.slickGoTo(0);
        }

        function onGoDownBtnClicked() {
			$timeout(function(){
				$location.hash('photoSlider');
				$anchorScroll();
			})
		}

        function onPhotoPopupSaved(){

        }

        function onPhotoPopupClosed(){

        }

        function showPhotoDetailPopup(file){
            if (self.isWorking || file.type === 'portfolio' || file.type === 5) {
                return false;
            };
            self.isWorking = true;
            if (angular.isDefined($scope.onPhotoClicked)) {
                $scope.onPhotoClicked({
                    file: file
                });
                self.isWorking = false;
            } else {
                photoSvc.updatePhotoInfo(file).then(function () {
                    self.isWorking = false;
                    if ($scope.context === "photo-page") {
                        $state.go("photo", {
                            id: file.id
                        });
                    } else {
                        photoDetailPopupSvc.setShouldSrollTop(new Date().getTime());
                        if (photoDetailPopupSvc.isPopupShowing()) {
                            photoDetailPopupSvc.updateUI({
                                photo: file
                            });

                        } else {
                            var modal = photoDetailPopupSvc.showPopup({
                                photo: file,
                                onPhotoPopupSaved: onPhotoPopupSaved,
                                onPhotoPopupClosed: onPhotoPopupClosed
                            });
                            modal.result.then(function (response) {
                                if (response.action === commonConst.ACTION.DELETE) {
                                    // $scope.onFileRemoved({
                                    //     file: response.photo
                                    // });
                                } else {
                                    // $scope.onAddedOrRemovedFromGallery({
                                    //     file: file
                                    // });
                                }
                            }, function (response) {
                                // $scope.onAddedOrRemovedFromGallery({
                                //     file: file
                                // });
                            });
                        }
                    }

                }, function () {
                    self.isWorking = false;
                });
                if ($scope.onPhotoClickedCallback) {
                    // $scope.onPhotoClickedCallback({
                    //     file: file
                    // });
                }
            }
        }

        function onPortfolioClicked(file) {
            self.spinner.isVisible = true;
            var pixerfEnv = new PixerfEnv().getEnv();
            var mediaId = (pixerfEnv === "PRODUCTION") ? file.id : file.qaId;
            pixerfApiMediaDetailSvc.get({
                id: mediaId
              }).$promise.then(function (response) {
                showPhotoDetailPopup(response.data);
                self.spinner.isVisible = false;
              }, function (err) {
                toastr.error("Failed to get photo detail. Please try again.");
                self.spinner.isVisible = false;
              })
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('home', {
				url: '/',
				templateUrl: 'app/home-page/home-page.html',
				controller: 'homePageCtrl',
				controllerAs: 'vm',
				data: {
				}
			});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('priceConst', {
			FREE_USER: [
				10, 20, 30, 40, 50
			],
			EXTENDED_LICENSES: [{
				"id": "PRODUCTS_FOR_RESALE",
				"title": "products-for-resale",
				"price": 500,
				"key": "is_for_resale",
				"tooltips": "tool-tip-products-for-resale"
			}, {
				"id": "UNLIMITED_PRINT",
				"title": "unlimited-print",
				"price": 300,
				"key": "is_unlimited_print",
				"tooltips": "tool-tip-unlimited-print"
			}, {
				"id": "MULTI_SEAT",
				"title": "Multi-seat",
				"price": 100,
				"key": "is_multi_seat",
				"tooltips": "tool-tip-multiseat"
			}]
		});
})();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .constant('galleryConst', {
      TOP_PIXERFER_GALLERY: 5,
      GALLERY_TYPE: {
        CURATED: "curated",
        DEFAULT: "default",
        FOLLOWING: "following",
        PIXERF: 'pixerf'
      }
    });
})();

(function () {
    'use strict';
    angular
        .module('pixerf')
        .constant('fileConst', function () {
            var conObj = {
                PATH: {
                    UNSAFE: "http://52.76.226.116/unsafe/",
                    FILESTACK: "https://process.filestackapi.com/"
                },
                FILESTACK_CONTAINER: {
                    USER_PROFILE: "pixerf-filepicker-profile",
                    USER_COVER: "pixerf-filepicker-cover",
                },
                SIZE_DEFINITION: [
                    { name: "SMALL", value: 1 },
                    { name: "MEDIUM", value: 3 },
                    { name: "LARGE", value: 4 },
                    { name: "X-LARGE", value: 12 },
                    { name: "XX-LARGE", value: 24 }
                ],
                FILE_STATE_NAME: {
                    'TRENDING': 'trending',
                    'GENERAL': 'general',
                    'REJECTED': 'rejected',
                    'PENDING': 'pending',
                    'DISCOVER': 'discover',
                    'EDITOR_PICK': "editor's-pick"
                },
                BADGES: {
                    CODES: {
                        MISSION_WINNER: "M",
                        MISSION_CONSOLATION: "MC",
                        EDITOR_PICK: "PC"
                    }
                },
                UPLOAD_PHOTO_VALIDATION: {
                    ERROR_CODE: {
                        FAILED_TO_UPLOAD: "FAILED_TO_UPLOAD",
                        INVALID_FILETYPE: "UPLOAD_VALIDATION_INVALID_FILETYPE",
                        DUPLICATED: "UPLOAD_VALIDATION_DUPLICATED",
                        INVALID_MIN_RESOLUTION: "UPLOAD_VALIDATION_INVALID_MIN_RESOLUTION",
                        INVALID_MIN_INSPIRATION_RESOLUTION: "INVALID_MIN_INSPIRATION_RESOLUTION",
                        INVALID_MAX_INSPIRATION_RESOLUTION: "INVALID_MAX_INSPIRATION_RESOLUTION",
                        INVALID_MAX_FILESIZE: "UPLOAD_VALIDATION_INVALID_MAX_FILESIZE",
                        EXCEED_NUMBER_OF_UPLOAD_PER_WEEK: "EXCEED_NUMBER_OF_UPLOAD_PER_WEEK",
                        EXCEED_NUMBER_OF_UPLOAD_PER_MISSION: "EXCEED_NUMBER_OF_UPLOAD_PER_MISSION",
                        EXCEED_NUMBER_OF_INSPIRATION_UPLOAD_PER_MISSION: "EXCEED_NUMBER_OF_INSPIRATION_UPLOAD_PER_MISSION"
                    },
                    PHOTO_SIZE: {
                        MIN_RESOLUTION: 5,
                        MIN_INSPIRATION_RESOLUTION: 0.5,
                        MAX_INSPIRATION_RESOLUTION: 4,
                        MAX_FILE_SIZE: 40
                    },
                    MISSION_LIMIT: 6,
                    MISSION_INSPIRATIONLIMIT: 15,
                },
                PHOTO_GRID_PAGE_SIZE: 17
            };
            conObj.FILE_STATE_DEFINITION = function () {
                var obj = {};
                for (var key in conObj.FILE_STATE_NAME) {
                    if (key === 'PENDING') {
                        obj[conObj.FILE_STATE_NAME[key]] = 'h';
                    } else {
                        obj[conObj.FILE_STATE_NAME[key]] = conObj.FILE_STATE_NAME[key][0];
                    }
                }
                return obj;
            }();
            return conObj;
        }());
})();
(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('commonConst', {
			CHEATED_USERS:{
				DEFINERS: [72432, 233]
			},
			ACTION: {
				CREATE: "CREATE",
				EDIT: "EDIT",
				DELETE: "DELETE"
			},
			SCREEN: {
				MOBILE: 1023
			},
			IPGEOLOCATION: {
				URL: "https://api.ipgeolocation.io/ipgeo?apiKey=",
				API_KEYS: [
					'65ea095f88204515986b0e02d8c12a23',
					'dbf2391a8382456d815df7e7c796cac4',
					'cd2226c85ce8495fb1bcfb7ffc442bbf',
					'4f739a3c42ea443294ab80a1a93145de',
					'a80274d346274c9b991feedc79d887e4'
				]
			},
			REPORT:{
				NO_IF_STRIKE: 3
			},
			STATE: {
				USER_HOMEPAGE: "user-home-page.homepage",
				SIGN_UP_PERSONAL_INFO: "sign-up.sign-up-personal-info",
				CHECKOUT_PAYMENT: "checkout.payment",
				COMPLETE_PROFILE_SKILL: "complete-profile-skills",
				SELECT_ACCOUNT_TYPE: "sign-up.select-account-type",
				EXPLORE_COMMUNITY: "for-creator-page.about-community",
				ABOUT_CUSTOM_COMMISSION: "about-custom-commissions-page",
				ABOUT_MISSION: "run-a-challenge-page.about-challenge",
				MARKETPLACE_PHOTOS: "buy-stock-page.trending",
				FEATURED_PHOTOGRAPHER: "marketplace.photographers.featuredPhotographer",
				PHOTO_BY_TYPE: "marketplace.photosByType",
				RELEASES: "introduction-support.releases",
				LET_TALK: "email-us-page",
				FAQ_PERSONAL: "introduction-support.faq.personal",
				FAQ_BUSINESS: "introduction-support.faq.business",
				TERMS: "introduction-company.terms",
				PRIVACY: "introduction-company.privacy",
				ABOUT_PIXERF: "about-pixerf",
				JOBS: "jobs",
				GALLERY_BY_TYPE: "marketplace.galleries",
				CASE_STUDIES: "case-studies",
				MISSION_JOINED: "run-a-challenge-page.joined-challenges",
				MISSION_CLOSED: "run-a-challenge-page.past-challenges",
				MISSION_ONGOING: "run-a-challenge-page.live-challenges",
				MISSION_SUBMISSIONS: "mission-detail-page.submissions",
				MANAGE_PHOTO_PENDING: "setting.manage-photos.pending-review",
				MANAGE_COMMUNITIES: "setting.manage-communities.communities",
				MANAGE_EVENTS: "setting.manage-events.manage-going-events",
				MANAGE_EVENT: "manage-event.edit-event",
				MANAGE_REPORTS: "setting.manage-reports.manage-pending-reports",
				JOINED_COMMUNITIES: "setting.manage-communities.joined-communities",
				PORTFOLIO_PHOTOS: "user-home-page.personal.portfolio.portfolio-detail.portfolio-photos",
				USER_PROFILE_PHOTO: "user-home-page.personal.photos",
				USER_PROFILE_HOME: "user-home-page.personal.home",
				CUSTOMCOMMISSIONS_DETAIL_APPROVAL: "custom-commissions-detail-page.approval",
				CUSTOMCOMMISSIONS_DETAIL_DELIVERY: "custom-commissions-detail-page.delivery",
				MANAGE_COMMUNITIES_BRIEF: "manage-community.edit-community",
				MANAGE_COMMUNITIES_INVITED_MEMBERS: 'manage-detail-community.manage-detail-community-members.manage-detail-community-invited-members',
				MANAGE_COMMUNITIES_REQUESTED_MEMBERS: 'manage-detail-community.manage-detail-community-members.manage-detail-community-requested-members',
				MANAGE_COMMUNITIES_PENDING_DISCUSSIONS: 'manage-detail-community.manage-detail-community-discussions.manage-detail-community-pending-discussions',
				MANAGE_COMMUNITIES_UNPUBLISHED_DISCUSSIONS: 'manage-detail-community.manage-detail-community-discussions.manage-detail-community-unpublished-discussions',
				MANAGE_COMMUNITIES_CURRENT_MEMBERS: 'manage-detail-community.manage-detail-community-members.manage-detail-community-current-members',
				MANAGE_COMMUNITIES_BLOCKED_MEMBERS: 'manage-detail-community.manage-detail-community-members.manage-detail-community-blocked-members',
				MANAGE_JOINED_COMMUNITIES: "setting.manage-communities.manage-joined-communities",
				MANAGE_COMMUNITIES_INVITATION: "setting.manage-communities.manage-invited-communities",
				MANAGE_REQUESTED_COMMUNITIES: "setting.manage-communities.manage-requested-communities",
				MANAGE_PENDING_COMMUNITIES: "setting.manage-communities.manage-pending-communities",
				MANAGE_PENDING_APPROVAL_COMMUNITIES: "setting.manage-communities.manage-pending-approval-communities",
				MANAGE_ACTION_REQUIRED_COMMUNITIES: "setting.manage-communities.manage-action-required-communities",
				MANAGE_ACTIVE_COMMUNITIES: "setting.manage-communities.manage-active-communities",
				MANAGE_INREVIEW_COMMUNITIES: "setting.manage-communities.manage-inreview-communities",
				MANAGE_DEACTIVATED_COMMUNITIES: "setting.manage-communities.manage-deactivated-communities",
				COMMUNITIES_DETAILS_BRIEF: "community-detail-page.community-detail-page-brief",
				COMMUNITIES_DETAILS_MEMBERS: "community-detail-page.community-detail-page-members",
				COMMUNITIES_DETAILS_DISCUSSIONS: "community-detail-page.community-detail-discussions",
				COMMUNITIES_DETAILS_EVENTS: "community-detail-page.community-detail-events",
                COMMUNITIES_DETAILS_CLASSES: "community-detail-page.community-detail-classes",
				COMMUNITIES_DETAILS_PHOTOS: "community-detail-page.community-detail-photos",
				MANAGE_COMMUNITIES_MEMBERS: "manage-detail-community.manage-detail-community-members",
				MANAGE_GOING_EVENTS: "setting.manage-events.manage-going-events",
				MANAGE_PAST_EVENTS: "setting.manage-events.manage-past-events",
				MANAGE_DRAFT_EVENTS: "setting.manage-events.manage-draft-events",
				MANAGE_INREVIEW_EVENTS: "setting.manage-events.manage-in-review-events",
				COMMUNITY_NOT_FOUND: 'community-not-found',
				DISCUSSION_DETAIL: 'discussion-detail-page',
				EVENT_FEED: 'event-detail-page.event-feed',
				EVENT_SCHEDULE: 'event-detail-page.event-schedule',
				EVENT_PHOTOS: 'event-detail-page.event-photos',
				MARKETPLACE_SIGNATURE_GALLERIES: 'buy-stock-page.galleries.signature-galleries',
				CHECKOUT_CREADIT_PALN_LIST: 'checkout.credit-plan.credit-plan-list',
				EDIT_PERSONAL_PROFILE: 'setting.edit_profile_personal',
				EDIT_BUSINESS_PROFILE: 'setting.edit_profile_business',
				MANAGE_PENDING_REPORTS: "setting.manage-reports.manage-pending-reports",
				MANAGE_PAST_REPORTS: "setting.manage-reports.manage-past-reports"
			}
		});
})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .constant('authenticationConst', {
            AUTHENTICATION_STATE: {
                NOT_LOGIN: "NOT_LOGIN",
                TOKEN_EXPIRED: "TOKEN_EXPIRED",
                FAILED_RETREIVE_ACCOUNT_INTO: "FAILED_RETREIVE_ACCOUNT_INTO",
                FAILED_RE_AUTHENTICATE: "FAILED_RE_AUTHENTICATE",
                FAILED_SIGNUP: "FAILED_SIGNUP"
            },
            AUTH0_CONNECTION_TYPE:{
                FACEBOOK: "facebook",
                USERNAME_PASSWORD: "Username-Password-Authentication"
            }
        });
})();
(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('accountConst', {
			ACCOUNT_TYPE: {
				PERSONAL: "personal",
				BUSINESS: "business",
				GUEST: "guest"
			},
			SOCIAL_TYPE: {
				FACEBOOK: "facebook",
				GOOGLE: "google"
			},
			ACCOUNT_ROLE: {
				CURATOR: "curator",
				CURATOR_INTERNAL: "curator_internal",
				MARKETER: "marketer",
				ADVERTISER: "advertiser"
			},
			AMBASSADORSHIP: {
				PRO: "pro",
				MAESTRO: "maestro"
			},
			BADGES: {
				CODES: {
					AMBASSADOR_PRO: "ABP",
					AMBASSADOR_MAESTRO: "ABM"
				}
			},
			FREE_EMAIL_LIST: /yahoo.com|gmail.com|facebook.com|outlook.com|aol.com|icloud.com/gi,
			OFFICE_TYPE: [{
					name: 'Head Office',
					id: 'head'
				},
				{
					name: 'Asia Pacific Office',
					id: 'flagship'
				},
				{
					name: 'Country Office',
					id: 'country'
				}
			],
			COMMISSION_RATE: {
				PIXERFER: 50,
				AMBASSADOR_PRO: 60,
				AMBASSADOR_MAESTRO: 70
			},
			INTERACT_TYPE: {
				LIKE: 'LIKE',
				FOLLOWING: 'FOLLOWING',
				FOLLOWER: 'FOLLOWER',
				LIKE_EVENT_POST: 'LIKE-EVENT-POST',
				LIKE_DISCUSSION: 'LIKE-DISCUSSION',
				REPLY_DISCUSSION: 'REPLY-DISCUSSION',
				REPLY_EVENT_POST: 'REPLY-EVENT-POST',
				LIKE_REPLY_DISCUSSION: 'LIKE-REPLY-DISCUSSION',
				LIST_INTERESTED_EVENT: 'LIST-INTERESTED-EVENT',
				LIST_JOINED_EVENT: 'LIST-JOINED-EVENT',
				LIST_INVITED_EVENT: 'LIST-INVITED-EVENT'
			},
			VERIFICATION_COOKIE: "email-verification-",
			ROLES: function () {
				return [{
						name: 'Marketer',
						id: this.ACCOUNT_ROLE.MARKETER
					},
					{
						name: 'Curator',
						id: this.ACCOUNT_ROLE.CURATOR
					},
					{
						name: 'Advertiser',
						id: this.ACCOUNT_ROLE.ADVERTISER
					}
				]
			},
			PROFILE: {
				SERVICES_RATE_MIN: 30,
				SERVICES_RATE_MAX: 15000
			},
			AGE: {
				MIN_AGE: 18,
				MAX_AGE: 100
			},
			TOKEN:{
				GUEST_USER_TOKEN: 'PIXERF.GUEST_USER_TOKEN',
				PAYMENT_INFO: "PAYMENT_INFO",
				PAYMENT_MENTHOD: "PAYMENT_MENTHOD",
				PAY_AFTER_SIGNED: "PAY_AFTER_SIGNED",
				SUBCRIBLE_NEWS_LETTER: "SUBCRIBLE_NEWS_LETTER",
				CREDIT_PLAN_AFTER_SIGNED_EMAIL: "CREDIT_PLAN_AFTER_SIGNED_EMAIL",
				CREDIT_PLAN_AFTER_SIGNED_PAGE: "CREDIT_PLAN_AFTER_SIGNED_PAGE",
				PAYMENT_EVENT_AFTER_SIGNED: "PAYMENT_EVENT_AFTER_SIGNED"
			}
		});
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .filter('toSnakeCase', toSnakeCase);

    toSnakeCase.$inject = ['stringUtils'];
    function toSnakeCase(stringUtils) {
       	return function(input) {
			return stringUtils.toSnakeCase(input)
		};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('scrollSpy', scrollSpy);
	scrollSpy.$inject = ['$timeout'];

	function scrollSpy($timeout) {
		return {
			restrict: "AC",
			link: function (scope, element, attr) {
				var menuItems = [];
				var config = {
					offset: 0,
					duration: 500
				};
				var userConfig = scope.$eval(attr.scrollSpy);
				var namespace = "scroll-" + moment().unix();
				angular.extend(config, userConfig);


				var scrollTo = function (event) {
					event.preventDefault();
					var target = $(event.target.hash);

					$('body').animate({
						scrollTop: target.offset().top - Number(config.offset) + 1
					}, config.duration);
				}

				//bind click events of menu items
				var setup = function () {
					angular.forEach(element.find('a'), function (el) {
						var self = $(el);
						var target = $(self.attr('href'));
						if (target.length) {
							self.click(scrollTo);
							menuItems.push({
								self: self,
								target: target
							});
						}
					});
				}

				$timeout(setup, 0);

				// Bind to scroll
				$(window).on('scroll.' + namespace, function () {
					var winTop = $(self).scrollTop() + Number(config.offset);
					var current = menuItems[0];

					angular.forEach(menuItems, function (item) {
						item.fromTop = item.target.offset().top - winTop;
						if (item.fromTop < 0)
							current = item;
					});

					angular.forEach(menuItems, function (item) {
						if (item === current) {
							item.self.addClass('active');
							if(attr.scrollSpyId){
								scope.$emit(attr.scrollSpyId + item.self[0].hash);
							}
						} else {
							item.self.removeClass('active');
						}
					});

				});

				scope.$on('$destroy', function () {
					$(window).unbind('scroll.' +  namespace);
				});
			}
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('pixerfScrollSpy', pixerfScrollSpy);
  pixerfScrollSpy.$inject = ['$timeout', 'systemUtils'];

  function pixerfScrollSpy($timeout, systemUtils) {

    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        $timeout(function () {
          if (attrs.pixerfScrollSpy) {
            var $elem = $(elem);
            var scrollSpyId = $elem.attr("scroll-spy-id");
            var scrollDirection = $elem.attr("pixerf-scroll-spy-direction");
            var isFirstSpyItem = $elem.attr("is-first-spy-item");
            var isLastSpyItem = $elem.attr("is-last-spy-item");
            var lastScrollTop = 0;
            var isScrollUp = false;
            var $window = $(window);
            $window.off("scroll.pixerfScrollSpy" + scrollSpyId);
            $window.on("scroll.pixerfScrollSpy" + scrollSpyId, function (event) {
              if (!$elem.is(":visible")) {
                $window.off("scroll.pixerfScrollSpy" + scrollSpyId);
                return;
              }
              var currentScrollTop = $(this).scrollTop();
              isScrollUp = (currentScrollTop <= lastScrollTop);
              lastScrollTop = currentScrollTop;

              if ((isScrollUp && scrollDirection === "up") || (!isScrollUp && scrollDirection === "down") || scrollDirection === "both") {
                var windowHeight = $window.height();
                var scrollTop = $window.scrollTop();
                var eleHeight = $elem.height();
                var y = $elem.offset().top - scrollTop;
                var max = windowHeight;
                var min = windowHeight - $elem.height() / 2;
                var isTop = scrollTop === 0;
                var isBottom = scrollTop + windowHeight == $(document).height();
                if ((isTop && isFirstSpyItem) || (isBottom && isLastSpyItem)) {
                  scope.$eval(attrs.pixerfScrollSpy);
                  systemUtils.digest(scope);
                } else {
                  if (y < max && y > min) {
                    scope.$eval(attrs.pixerfScrollSpy);
                    systemUtils.digest(scope);
                  }
                }
              }
            });

          }
        });
      }
    };
  }
})();

angular.module("pixerf") 
    .directive('scrollOnClick', function () {
        return {
            restrict: 'A',
            scope: {
                scrollTo: "@",
                offsetTop: "@"
            },
            link: function (scope, $elm, attrs) {
                //var idToScroll = attrs.href;
                $elm.on('click', function () {
                    $('html,body').animate({ scrollTop: $(scope.scrollTo).offset().top  + parseInt(scope.offsetTop)}, "slow");
                });
            }
        }
    });
(function () {
    angular.module('pixerf')
        .directive('owlSlider', owlSlider);
        owlSlider.$inject = ['$rootScope', 'systemUtils'];
    function owlSlider($rootScope, systemUtils) {
        return {
            scope: {
                owlSliderStartPosition: "=",
                onSliderInit: '&?'
            },
            restrict: 'A',
            link: function (scope, element) {
                setTimeout(function(){
                    var $element = $(element);
                    $rootScope.mainOwl =  $element.owlCarousel({
                        autoPlay: true,
                        navigation: false,
                        pagination: true,
                        transitionStyle: "fade", // fade, backSlide, goDown, fadeUp
                        singleItem: true,
                        items: 1,
                        autoHeight: true,
                        stopOnHover: false,
                        nav: true,
                        URLhashListener:true,
                        startPosition: 'URLHash',
                        navText: ["<div class='icon-arrow_left'></div>","<div class='icon-arrow_right'></div>"]
                    });
                    $element.on("translated.owl.carousel", function(event){
                        systemUtils.scrollTo();
                    })
    
                    var owl = $(element).data('owl.carousel');
    
                    scope.onSliderInit({owlInstance: owl});
                })

            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('enter', enter);
    enter.$inject = [];
    function enter() {
        return {
            link : function(scope, elem, attrs) {
                var selector = attrs.selector;
                var handler = function (event) {
                    if(event.which === 13) {
                        scope.$apply(function (){
                            scope.$eval(attrs.enter);
                        });
                        event.preventDefault();
                    }
                }
                if(selector){
                   $(elem).on("keydown keypress", selector, handler);
                } else {
                    $(elem).on("keydown keypress", handler);
                }
            }
        };
    }
})();                                                                  
(function () {
    'use strict';

    angular.module('fancyboxplus', [])
        .service('fancyboxService', fancyboxService)
        .directive('fancyboxable', fancyboxableDirective)
        .directive('fancybox', fancyboxDirective);

    function fancyboxService() {

        //Fancybox-Plus JavaScript API reference:
        // http://igorlino.github.io/fancybox-plus/api.htm

        var service = {
            fancyboxPlus: fancyboxPlus, //returns the fancyboxplus jquery plugin

            showActivity: showActivity,//Shows loading animation
            hideActivity: hideActivity,//Hides loading animation
            next: next,//Displays the next gallery item
            prev: prev,//Displays the previous gallery item
            pos: pos,//Displays item by index from gallery
            cancel: cancel,//Cancels loading content
            close: close,//Hides FancyBox. Within an iframe use - parent.close();
            resize: resize,//Auto-resizes FancyBox height to match height of content
            center: center//Centers FancyBox in viewport
        };
        return service;

        function fancyboxPlus() {
            return $.fancyboxPlus;
        }

        function showActivity() {
            fancyboxPlus().showActivity();
        }

        function hideActivity() {
            fancyboxPlus().hideActivity();
        }

        function pos() {
            fancyboxPlus().pos();
        }

        function cancel() {
            fancyboxPlus().cancel();
        }

        function center() {
            fancyboxPlus().center();
        }

        function next() {
            fancyboxPlus().next();
        }

        function prev() {
            fancyboxPlus().prev();
        }

        function close() {
            fancyboxPlus().close();
        }

        function resize() {
            fancyboxPlus().resize();
        }
    }

    fancyboxableDirective.$inject = ['$compile', '$rootScope', '$http', '$parse', '$timeout', 'fancyboxService'];
    function fancyboxableDirective($compile, $rootScope, $http, $parse, $timeout, fancyboxService) {
        var service = {
            restrict: 'A',
            link: fancyboxableLink,
            priority: 100 // must lower priority than ngSrc (99)
        };
        return service;

        fancyboxableLink.$inject = ['$scope', '$element', '$attributes'];
        function fancyboxableLink($scope, $element, $attributes) {
            var fbp = null;

            $scope.$on('$destroy', function () {
                $element.remove();
            });

            init();

            function init(open) {
                var options = {
                    href: $attributes.src ? $attributes.src : $attributes.href,
                    onComplete: function () {
                        onComplete();
                    }
                };

                //generic way that sets all (non-function) parameters of fancybox-plus.
                if ($attributes.fancyboxable && $attributes.fancyboxable.length > 0) {
                    var fbpOptionsFunc = $parse($attributes.fancyboxable);
                    var fbpOptions = fbpOptionsFunc($scope);
                    angular.extend(options, fbpOptions);
                }

                //clean undefined
                for (var key in options) {
                    if (options.hasOwnProperty(key)) {
                        if (typeof(options[key]) === 'undefined') {
                            delete options[key];
                        }
                    }
                }

                if (typeof(open) !== 'undefined') {
                    options.open = open;
                }

                //wait for the DOM view to be ready
                $timeout(function () {

                    if (!$attributes.ngSrc) {
                        //opens the fancybox using an href.
                        fbp = $($element).fancyboxPlus(options);
                    } else {
                        //$element.bind('load', function() {
                        /*$scope.$apply(function () {
                         options.href = $attributes.src ? $attributes.src : $attributes.href;
                         cb = $.colorbox(options);
                         });*/
                        //wait for the DOM view to be ready
                        $timeout(function () {
                            options.href = $attributes.src ? $attributes.src : $attributes.href;
                            fbp = $($element).fancyboxPlus(options);
                        }, 300);
                        //});
                    }


                }, 0);
            }

            function onComplete() {
                $rootScope.$apply(function () {
                    var content = $('#fbplus-content');
                    $compile(content)($rootScope);
                });
            }
        }


    }

    fancyboxDirective.$inject = ['$compile', '$rootScope', '$http', '$parse', '$timeout', 'fancyboxService'];
    function fancyboxDirective($compile, $rootScope, $http, $parse, $timeout, fancyboxService) {
        var service = {
            restrict: 'E',
            scope: {
                open: '=',
                options: '=',
                templateUrl: '&',

                onStart: '&', //Will be called right before attempting to load the content
                onCancel: '&', //Will be called after loading is canceled
                onComplete: '&', //Will be called once the content is displayed
                onCleanup: '&', //Will be called just before closing
                onClosed: '&' //Will be called once FancyBox is closed

            },
            // require: 'fancybox',
            link: link
            // controller: controller,
            // controllerAs: 'vm'
        };
        return service;

        link.$inject = ['$scope', '$element', '$attributes'];
        function link($scope, $element, $attributes) {
            var fbp = null;

            $scope.$watch('open', function (newValue, oldValue) {
                if (oldValue !== newValue) {
                    updateOpen(newValue);
                }
            });

            $scope.$on('$destroy', function () {
                $element.remove();
            });

            init();

            function updateOpen(newValue) {
                if (newValue) {
                    init(newValue);
                } else {
                    fancyboxService.close();
                }
            }

            function init(open) {
                var options = {
                    href: $attributes.src,
                    boxFor: $attributes.boxFor,
                    onOpen: function () {
                        if ($scope.onOpen && $scope.onOpen()) {
                            $scope.onOpen()();
                        }
                    },
                    onCancel: function () {
                        if ($scope.onCancel && $scope.onCancel()) {
                            $scope.onCancel()();
                        }
                    },
                    onComplete: function () {
                        onComplete();
                        if ($scope.onComplete && $scope.onComplete()) {
                            $scope.onComplete()();
                        }
                    },
                    onCleanup: function () {
                        if ($scope.onCleanup && $scope.onCleanup()) {
                            $scope.onCleanup()();
                        }
                    },
                    onClosed: function () {
                        $scope.$apply(function () {
                            $scope.open = false;
                        });
                        if ($scope.onClosed && $scope.onClosed()) {
                            $scope.onClosed()();
                        }
                    }
                };

                //generic way that sets all (non-function) parameters of fancybox-plus.
                if ($scope.options) {
                    angular.extend(options, $scope.options);
                }

                //clean undefined
                for (var key in options) {
                    if (options.hasOwnProperty(key)) {
                        if (typeof(options[key]) === 'undefined') {
                            delete options[key];
                        }
                    }
                }

                if (typeof(open) !== 'undefined') {
                    options.open = open;
                }

                //wait for the DOM view to be ready
                $timeout(function () {
                    if (options.boxFor) {
                        //opens the element by id boxFor
                        fbp = $(options.boxFor).fancyboxPlus(options);
                    } else if (options.href) {
                        //opens the fancybox-plus using an href.
                        fbp = $.fancyboxPlus(options);
                    }
                }, 0);
            }

            function onComplete() {
                $rootScope.$apply(function () {
                    var content = $('#fbplus-content');
                    $compile(content)($rootScope);
                });
            }
        }
    }

})
();
function PixerfEnv(){
    this.ENV = {
        PRODUCTION : "PRODUCTION",
        STAGING: "STAGING",
        TESTING: "TESTING",
        DEVELOPING: "DEVELOPING"
    }
    
    
}
PixerfEnv.prototype = (function(){
    function getEnv(){
        var URL_PRFIX = "https://";
        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function(searchString, position) {
                position = position || 0;
                return this.indexOf(searchString, position) === position;
            };
        }
        if(location.href.startsWith(URL_PRFIX + "ioa.pixerf.com")){
            return this.ENV.PRODUCTION;
            // return this.ENV.TESTING;
        }
        else if (location.href.startsWith(URL_PRFIX + 'staging.pixerf.com')){
            return this.ENV.STAGING;
        }
        else if (location.href.startsWith(URL_PRFIX + 'qa.pixerf.com')){
            return this.ENV.TESTING;
        }
        return this.ENV.TESTING;
    }
    return {
        getEnv: getEnv
    }
})();
function PixerfAuth0Configurer(){
    this.ENV = {
        "PRODUCTION": {
            clientID: "CX71vZ6A5B2CRUWycgcwSjqRJomeQL1n",
            domain: "pixerf.au.auth0.com"
        },
        "STAGING": {
            clientID: "Qtn7RYBZ4tpP35pXDBj9PR0zYIEDPv4N",
            domain: "pixerf-staging.au.auth0.com"
        },
        "TESTING": {
            clientID: "d5Ehkv7aRKGthnC6l8AgHZmU2GaNK7K4",
            domain: "pixerf-qa.au.auth0.com"
        },
        "DEVELOPING": {
            clientID: "d5Ehkv7aRKGthnC6l8AgHZmU2GaNK7K4",
            domain: "pixerf-qa.au.auth0.com"
        }
    }
}
PixerfAuth0Configurer.prototype = (function(){
    function getEnv(){
        var pixerfEnv = new PixerfEnv();
        return this.ENV[pixerfEnv.getEnv()];
    }
    return {
        getEnv: getEnv
    }
})();
function PixerfAPIUrlConfigurer(){
    this.URL_PRFIX = "https://";
    this.URL_AFFIX = "/";
    this.ENV = {
        DEVELOPING: "phoenix.pixerf.com",
        PRODUCTION : "pixerf.com",
        STAGING: "staging.pixerf.com",
        TESTING: "qa.pixerf.com"
    }
}
PixerfAPIUrlConfigurer.prototype = (function(){
    function getBaseUrl(){
        var pixerfEnv = new PixerfEnv();
        return this.ENV[pixerfEnv.getEnv()];
    }
    return {
        getBaseUrl: getBaseUrl
    }
})();
(function () {
  'use strict';
  angular
    .module('pixerf')
    .controller('aboutPageCtrl', aboutPageCtrl)

  aboutPageCtrl.$inject = ['$scope'];

  function aboutPageCtrl($scope) {
    var self = this;
  }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('about', {
				url: '/about',
				templateUrl: 'app/about-page/about-page.html',
				controller: 'aboutPageCtrl',
				controllerAs: 'vm',
				data: {
					hideFooter: true
				}
			});
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('indexCtrl', indexCtrl);

    indexCtrl.$inject = ['$window', 'cartSvc', 'accountConst', 'store', '$interval'];

    function indexCtrl($window, cartSvc, accountConst, store, $interval) {
        var self = this;

        getCart();
        $window.onfocus = function(){
            getCart()
        }

        function getCart(){
            if(store.get(accountConst.TOKEN.GUEST_USER_TOKEN)){
                cartSvc.fetchCart();
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .run(runBlock);

  runBlock.$inject = ['$rootScope', 'socketSvc', 'auth0AuthenticationSvc', 'systemUtils', '$route'];

  function runBlock($rootScope, socketSvc, auth0AuthenticationSvc, systemUtils, $route) {
    $rootScope.message = {
      votable: true,
      published: {
        data: false
      },
      winners: {
        data: []
      }
    }
    socketSvc.joinPublicChannel();
    setTimeout(function(){
      socketSvc.subscribeTopic(socketSvc.PIXERF_TOPICS.IOA.name.toUpperCase(), function(message){
        console.log(message);
        $rootScope.message.published = message.published;
        // $rootScope.message.winners.data = fileUtils.transforms(message.winners);
        $rootScope.message.votable = message.votable;
        systemUtils.apply($rootScope);
        $route.reload();
        ///
        location.reload();
      })
    }, 3000);

  }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

  function routerConfig($stateProvider, $urlRouterProvider) {
    'ngInject';
    $urlRouterProvider.when('', '/');
  }

})();

// /* global malarkey:false, moment:false */
// (function() {
//   'use strict';

//   angular
//     .module('pixerf')
//     .constant('moment', moment);

// })();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .config(config)
    .provider('pixerfUrl', function () {

      var pixerfAPIUrlConfigurer = new PixerfAPIUrlConfigurer(); 
      var baseUrl = pixerfAPIUrlConfigurer.getBaseUrl();

      this.$get = function () {
        return {
          full: pixerfAPIUrlConfigurer.URL_PRFIX + baseUrl + pixerfAPIUrlConfigurer.URL_AFFIX,
          domainOnly: baseUrl
        }
      }

    });
  config.$inject = ['toastrConfig', '$httpProvider', 'angularAuth0Provider', 'jwtInterceptorProvider', 'jwtOptionsProvider'];
   function config(toastrConfig, $httpProvider, angularAuth0Provider, jwtInterceptorProvider,jwtOptionsProvider) {
    $httpProvider.defaults.withCredentials = true;
    toastrConfig.maxOpened = 1;
    toastrConfig.autoDismiss = true;
    toastrConfig.allowHtml = true;
    toastrConfig.extendedTimeOut = 15000;
    toastrConfig.closeButton = true;
    toastrConfig.positionClass = 'toast-top-center';
    toastrConfig.toastClass = 'pixerf-alert-message';

    jwtOptionsProvider.config({ whiteListedDomains: ["qa.pixerf.com", "pixerf.com"] });

    jwtInterceptorProvider.tokenGetter = ['localStorageService', function (localStorageService) {
      var token = localStorageService.get('PIXERF.TOKEN');
      return token;
    }];

    $httpProvider.interceptors.push('jwtInterceptor');

    var pixerfAuth0Evn = new PixerfAuth0Configurer().getEnv();
    angularAuth0Provider.init({
      domain: pixerfAuth0Evn.domain,
      clientID: pixerfAuth0Evn.clientID,
      responseType: 'token id_token',
      redirectUri: window.location.href
    });

  }

})();

angular.module("pixerf").run(["$templateCache", function($templateCache) {$templateCache.put("app/about-page/about-page.html","<div class=about-page><div class=about-page__content><div class=about-page__col-left><div class=about-page__col-left__content><div class=about-page__name>Matthias Heng</div><div class=about-page__signature><img class=about-page__signature__icon src=../../ukraine-exclusive/assets/images/home-page/definer-logo.svg alt=Definer><div class=about-page__signature__text>Photojournalism Phototgrapher</div></div></div></div><div class=about-page__col-right><div class=about-page__col-right__content><p>Mathias Heng is an international photojournalist who spends much of his time on assignments and conducting photography workshops.</p><p>Much of his work is emotionally charged; focusing on the documentary narrative of conflicts, natural disaster, poverty, social issues and its effects on the civilian population. He captures the turning points of human history and always approaches his subjects with respect and dignity.</p><p>His work appears internationally in a range of publications for both NGOs and editorial organisations throughout Asia and Europe. He is also a sought after workshop instructor and speaker who inspires his participants through his works and actions.</p><p>Despite his exposure to many atrocities, Mathias has never lost his passion and commitment to humanity; he continues to capture images which speak to people around the globe.</p></div></div></div><div class=about-page__col-bottom><div class=about-page__col-bottom__content><p>Mathias Heng is an international photojournalist who spends much of his time on assignments and conducting photography workshops.</p><p>Much of his work is emotionally charged; focusing on the documentary narrative of conflicts, natural disaster, poverty, social issues and its effects on the civilian population. He captures the turning points of human history and always approaches his subjects with respect and dignity.</p><p>His work appears internationally in a range of publications for both NGOs and editorial organisations throughout Asia and Europe. He is also a sought after workshop instructor and speaker who inspires his participants through his works and actions.</p><p>Despite his exposure to many atrocities, Mathias has never lost his passion and commitment to humanity; he continues to capture images which speak to people around the globe.</p></div></div></div>");
$templateCache.put("app/home-page/home-page.html","<div class=\"home-page pixerf-page-wrapper\"><spinner-win spinner=vm.spinner ng-if=vm.spinner.isVisible></spinner-win><div class=home-page__panel><div class=home-page__panel__icon><img src=../../ukraine-exclusive/assets/images/home-page/definer-logo.svg alt=Definer></div><div class=home-page__panel__content><div class=home-page__panel__text-header><span class=step-1>From the frontlines of </span><br><span class=step-2>Ukraine-Russian conflict</span></div><div class=home-page__panel__sub-header>Matthias Heng takes us deep into Kyiv to capture stories untold.</div><div class=\"home-page__panel__view-more-btn home-page__view-more-btn\" ui-sref=work({id:233})><span>View Ukraine Photos </span><span class=icon-bold-arrow-right></span></div></div></div><div class=home-page__panel__nav-btn scroll-on-click scroll-to=#photoSlider offset-top=-96><img class=cirle-down-icon src=../../ukraine-exclusive/assets/images/home-page/cirle-down-icon.svg alt=\"Go down\"><!-- <img class=\"ball-icon\" src=\"../../ukraine-exclusive/assets/images/home-page/ball.gif\" alt=\"Go down\"> --></div><div class=home-page__slider id=photoSlider><pixerf-animation-carousel data=vm.portfolios config=vm.carouselConfig instance=portfolioCarousel limit=9><item-template><portfolio-tile portfolio=$parent.data speciality={{$parent.data.speciality}} on-portfolio-clicked=vm.onPortfolioClicked($parent.data)></portfolio-tile></item-template></pixerf-animation-carousel></div><div class=home-page__updates-news><div class=home-page__section-news__desc>In March 2022, Singapore-born Australian photojournalist Matthias Heng entered Kyiv, a city devastated by loss and destruction. His images reveal powerful stories on the ground and documents the strength of the people swept up in the tidal waves of relentless attacks.</div></div><div class=home-page__section-news><div class=home-page__section-news__image><img src=../../ukraine-exclusive/assets/images/home-page/news-image.png alt=\"view details\"></div><div class=home-page__section-news__desc><div class=home-page__section-news__header><strong>Ukraine: Updates from PIXERF</strong><br>Photographers in the field</div><div class=home-page__section-news__content><p>In support of the people of Ukraine, PIXERF and Matthias have pledged to donate part of the proceeds from the sales of images from his coverage of the ongoing Russian-Ukraine conflict.</p><!-- <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut\r\n                    labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores\r\n                    et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor.</p> --></div></div></div><div class=home-page__quotes><div class=\"home-page__quotes__desc desktop\">“These images give voice to the people of Ukraine, the truth of the war and its impact.”</div><div class=\"home-page__quotes__desc mobile\">“These images give voice to the people of Ukraine, the truth of the war and its impact.”</div><div class=home-page__quotes__name>Matthias Heng</div><div class=home-page__quotes__detail>Photojournalist</div></div><div class=home-page__live-news id=liveNewsSection><p>Time stands suspended for the people of Kyiv as the world watches their city ravaged and their lives transformed at blinding speed through a series of disturbing images emerging from a war that has no rules and no limits.</p><img src=../../ukraine-exclusive/assets/images/home-page/news1.jpg alt=news><p>Transformed and united, Ukrainians have answered the call to arms to protect Ukraine’s sovereignty and their love of the country they call home.</p><div class=home-page__live-news__group><img src=../../ukraine-exclusive/assets/images/home-page/news2.jpg alt=news> <img src=../../ukraine-exclusive/assets/images/home-page/news3.jpg alt=news></div><p>We stand with Ukraine for peace. All images in the Ukraine photo exclusive are available for licensing and PIXERF has pledged to donate half of its share of licensing fees to the people of Ukraine.</p><div class=home-page__live-news__view-more-wrap><div class=\"home-page__live-news__view-more-btn home-page__view-more-btn\" ui-sref=work({id:233})><span>View Ukraine Photos </span><span class=icon-bold-arrow-right></span></div></div></div><!-- <div class=\"home-page__slider pixerf-slide-wrapper\" ng-if=\"vm.isBindSlick\" slick-slider=\'{{vm.slickSettings}}\' init=\"vm.slickSettings.init(event, slick)\"\r\n        after-change=\"vm.slickSettings.afterChange(event, slick, currentSlide, nextSlide)\" before-change=\"vm.slickSettings.beforeChange(event, slick, currentSlide, nextSlide)\">\r\n        <div class=\"home-page__slide-item pixerf-slide-item\">\r\n            <photography-competition></photography-competition>\r\n        </div>\r\n        <div class=\"home-page__slide-item pixerf-slide-item\" ng-repeat=\"category in vm.categories\">\r\n            <mission-category category=\"category\"></mission-category>\r\n        </div>\r\n    </div>\r\n    <div class=\"home-page__slider pixerf-slide-wrapper\" ng-if=\"!vm.isBindSlick\">\r\n        <div class=\"home-page__slide-item pixerf-slide-item\">\r\n            <photography-competition></photography-competition>\r\n        </div>\r\n        <div class=\"home-page__slide-item pixerf-slide-item\" ng-repeat=\"category in vm.categories\">\r\n            <mission-category category=\"category\"></mission-category>\r\n        </div>\r\n    </div>\r\n    <div class=\"home-page__navigation clearfix\">\r\n        <div class=\"home-page__navigation-btn navigation-btn-previous icon-arrow-up\" ng-click=\"vm.navigate(\'prev\')\"></div>\r\n        <div class=\"home-page__navigation__slide-count clearfix\">\r\n            <div class=\"home-page__navigation__current-slide\">0{{vm.slick.currentSlide + 1}}</div>\r\n            <div class=\"home-page__navigation__splash-slide\">/</div>\r\n            <div class=\"home-page__navigation__total-slides\">0{{vm.slick.slideCount}}</div>\r\n        </div>\r\n        <div class=\"home-page__navigation-btn navigation-btn-next icon-arrow-down\" ng-click=\"vm.navigate(\'next\')\"></div>\r\n    </div>\r\n    <div ui-view></div>\r\n    <div class=\"scroll-top-top-btn\" title=\"Scroll to Top\" ng-click=\"vm.onScrollToTopClicked()\" ng-if=\"vm.showScrollBtn\"><span class=\"icon-arrow-up-2\"></span></div>\r\n    <scroll-to-top class=\"scroll-no-slide\"></scroll-to-top> --></div>");
$templateCache.put("app/work-page/work-page.html","<section class=work-page><div class=work-page__banner></div><div id=pagingBar class=work-page__stick-bar><div class=work-page__title>Ukraine Exclusive</div><div class=work-page__photo-grid-pager><photo-grid-pager total-photos=vm.totalPhotos is-shown-num-photos=true total-page=vm.totalPage page=vm.submissionPagination.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-show-page-text=true></photo-grid-pager></div></div><div class=work-page__photo-grid><div><photo-grid instance=vm.photoGrid on-file-removed=\"vm.onSubmissionRemoved(file, \'others\')\" on-load-more-page=vm.onLoadMorePage(page) on-photo-clicked-callback=vm.onPhotoSelected(file) on-scroll-to-photo=vm.onScrollToPage(page) options=\"{hidePhotoInfo: true}\"><div class=\"text-center submission__other__empty-state\"><div class=submission__other__empty-state__gallery></div><h4 class=\"text--semibold text--color-black submission__other__empty-state__title\">There are no images submitted.</h4><div class=submission__other__empty-state__notices>Every uploaded image spends a little time here before they’re sorted<br>into our Marketplace, Trending, or Discover.</div></div></photo-grid></div></div></section>");
$templateCache.put("app/components/add-to-cart-btn/add-to-cart-btn.html","<div class=\"text-center add-to-cart-btn\"><div><button ng-disabled=\"vm.isWorking || isDisabled\" ng-click=vm.onAddToCartClicked(media) class=\"container-full btn btn-submit btn-block\"><img src=assets/images/cart-icon-lighter.svg class=icon-icon-cart> {{mode === \"EDIT\" ? \'Edit Cart\' : \'Add to Cart\'}}</button></div></div>");
$templateCache.put("app/components/add-to-gallery/add-to-gallery-popover-tmpl.html","<div><div class=\"popover-title clearfix add-to-gallery__header\"><div class=\"pull-left text--bold text--color-black\" translate>{{\'add-to-gallery\'}}</div><button type=button class=\"add-to-gallery__btn-close close pull-right\" ng-click=\"vm.isOpen.data = false\"><span class=icon-icons_close></span></button></div><div class=add-to-gallery__body><div class=add-to-gallery__create-new-gallery-btn-wrapper authentication-click=vm.onCreateGalleryBtnClicked() check-verified-email=true><span class=icon-icons-plus-box></span> <span class=add-to-gallery__create-new-gallery-btn__btn-label translate>{{\'create-new-gallery\'}}</span></div><div class=\"add-to-gallery__gallery-type-checkbox-wrapper clearfix\" ng-if=file.isMine><stick-checkbox is-disabled=vm.galleryListInstance.spinner.isVisible model=vm model-property=isMyGalleryChecked on-changed=vm.onGalleryCheckboxCheck() label=my-gallery layout-style=solid-square></stick-checkbox><stick-checkbox is-disabled=vm.galleryListInstance.spinner.isVisible model=vm model-property=isCuratedGalleryChecked on-changed=vm.onGalleryCheckboxCheck() label=my-curated-gallery layout-style=solid-square></stick-checkbox></div><galleries-list instance=vm.galleryListInstance ng-if=vm.loginUser user=vm.loginUser gallery-type=vm.galleryType on-galleries-changed=\"vm.onGalleriesChanged(galleries, checkedGalleries)\" on-gallery-item-clicked=\"vm.onGalleryItemClicked(evt, gallery)\"></galleries-list></div><div class=\"clearfix add-to-gallery__tips\" ng-show=closeOnClick><div class=text--color-black>{{\'tip\' | translate}}: {{\'add-photo-to-multiple-gallery\' | translate}}</div></div></div>");
$templateCache.put("app/components/auth/auth.html","<ul ng-switch=vm.isAuthenticated() class=user-panel ng-class=\"vm.isAuthenticated() ? \'user-panel--authenticated\' : \'\'\"><!-- <popover-selection-btn ng-if=\"vm.languagesSetting\" class=\"multi-language-dropdown\" close-on-click=\"true\"\r\n		on-selection-changed=\"vm.onLanguagesSelected(item)\" selected-model=\"vm.language\" settings=\'vm.languagesSetting\'\r\n		selected-default-index=\"{{vm.selectedDefaultIndex}}\">\r\n	</popover-selection-btn> --><!-- <li uib-dropdown=\"\" class=\"user-panel__multi-language dropdown open\" ng-class=\"{\'style-open\': businessMenu.isopen}\"\r\n		ng-mouseover=\"businessMenu.isopen = true\" ng-mouseleave=\"businessMenu.isopen = false\">\r\n		<div uib-dropdown-toggle=\"\" class=\"user-panel__multi-language__button dropdown-toggle\" aria-haspopup=\"true\"\r\n			aria-expanded=\"true\">\r\n			<span class=\"user-panel__multi-language__selected-language\">{{vm.selectedLanguage}}</span>\r\n			<span class=\"icon-icons_chevron-down arrow-direct-with-menu dropdown-icon-menu\"></span>\r\n		</div>\r\n		<ul class=\"dropdown-menu user-panel__multi-language__submenu-btn\" uib-dropdown-menu=\"\" role=\"menu\"\r\n			aria-labelledby=\"single-button\">\r\n			<li ng-click=\"vm.onLanguagesSelected({name: \'English\', value: \'en\'})\">\r\n				<a class=\"text-transform\" ng-class=\"{\'active\': vm.selectedLanguage == \'en\'}\">English - EN</a>\r\n			</li>\r\n			<li>\r\n				<a class=\"text-transform\">Bahasa Indonesia - ID <span>(coming soon)</span></a>\r\n			</li>\r\n		</ul>\r\n	</li> --><li class=\"user-panel__tools user-panel__curation-panel\" ng-if=\"vm.loginedUser && (vm.loginedUser.role === \'admin_internal\' || vm.loginedUser.role === \'curator_internal\')\"><div uib-dropdown navbar-stop-collapse-on-click class=user-panel__curation-panel__item-more><div class=user-panel__curation-panel__item-more__btn uib-dropdown-toggle navbar-stop-collapse-on-click><span class=user-panel__curation-panel__item-more__btn__icon data-ng-style=\"vm.isViewMoreActived() ?{\'background-image\': \'url(assets/images/curation-icon-active.svg)\'} : {\'background-image\': \'url(assets/images/curation-icon.svg)\'}\"></span> <span class=\"icon-icons_chevron-down arrow-direct-with-menu dropdown-icon-menu\"></span></div><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li ng-if=vm.loginedUser.canSeeDirectory ui-sref-active=active ui-sref=buy-stock-page.photographers.featuredPhotographer>Directory</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.pending-photos>Pending Photos</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.pending-portfolio>Pending Portfolio</li><li ng-if=\"vm.loginedUser.role === \'admin_internal\' || [21,71702].includes(vm.loginedUser.id)\" ui-sref-active=active ui-sref=buy-stock-page.pending-commercial-license>Pending Commercial License</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.general-photos>General</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.rejected-photos>Rejected</li><li ng-if=\"vm.loginedUser.role === \'admin_internal\'\" ui-sref-active=active ui-sref=buy-stock-page.temporary-photos>Temporary</li></ul></div></li><li class=\"user-panel__tools user-panel__tools__first-child\" ng-click=vm.showUploadModal() ng-switch-when=true ng-if=\"vm.user.data.canUploadPhotos && !vm.guestUser\"><a class=user-panel__tools__upload href=\"\"><span class=\"icon-icons-upload text--color-pixerf-theme\"></span> <span ng-hide=\"vm.loginedUser && (vm.loginedUser.role === \'admin_internal\' || vm.loginedUser.role === \'curator_internal\')\" class=\"upload-text text--bold text--color-pixerf-theme\" translate>{{\'upload\'}}</span></a></li><li class=\"user-panel__tools user-panel__tools-cart\" role=button ng-class=\"{\'guest-user\': !vm.isAuthenticated()}\"><popover-cart></popover-cart></li><li class=\"user-panel__tools user-panel__tools-notification\" ng-switch-when=true><notification-btn></notification-btn></li><li class=user-panel__avatar><div href=\"\" class=user-panel__avatar__wrapper><span uib-dropdown class=user-panel__avatar__username-wrapper on-toggle=vm.onProfileMenuToggle(open)><span uib-dropdown-toggle ng-switch-when=true><a ng-if=!vm.updatingdAvatar class=user-panel__avatar__user-profile-pic><pixerf-user-avatar class=pull-left user-data=vm.user.data lazy=true></pixerf-user-avatar></a></span><ul class=\"dropdown-menu user-panel__dropdown-menu\" uib-dropdown-menu role=menu aria-labelledby=single-button><div ng-switch-when=true class=proflie-menu__remove-btn ng-if=vm.isProfileMenuOpen><span class=\"icon-bar one\"></span> <span class=\"icon-bar two\"></span></div><li ng-switch-when=true class=user-panel__upload-photos ng-click=vm.showUploadModal() ng-if=\"vm.user.data.canUploadPhotos && !vm.guestUser\"><a href=\"\"><span class=icon-icons-upload></span> <span class=upload-text translate>{{\'upload\'}}</span></a></li><li class=user-panel__tools-cart--mobile role=button><popover-cart></popover-cart></li><li ng-switch-when=true class=user-panel__tools-notification--mobile><notification-btn></notification-btn></li><li ng-switch-when=true role=menuitem class=\"dropdown-menu-title text--extrabold account-title\" translate>{{\'account\'}}</li><li ng-switch-when=true role=menuitem><a ng-click=vm.onCloseBtnClicked() ng-if=!vm.guestUser redirect-to-profile=vm.user.data class=user-panel__dropdown-menu__item>{{\'my-profile\' | translate}}</a> <a ng-if=vm.guestUser redirect-to-profile=vm.user.data>{{\'my-profile\' | translate}}</a></li><li ng-switch-when=true ng-click=vm.onSettingClicked() role=menuitem><a ng-click=vm.onCloseBtnClicked() href=\"\" translate translate-values=\"{name: (\'profile\' | translate)}\" class=user-panel__dropdown-menu__item>{{\'edit\'}}</a></li><li ng-if=vm.isAbleToChangePassword ng-switch-when=true role=menuitem><a ng-click=vm.onCloseBtnClicked() ui-sref=setting.change-password translate class=user-panel__dropdown-menu__item>{{\'change-password\'}}</a></li><li ng-switch-when=true role=menuitem><a ng-click=vm.onCloseBtnClicked() ui-sref=setting.purchase-history.order-list translate class=user-panel__dropdown-menu__item>{{\'purchase-history\'}}</a></li><li ng-switch-when=true role=menuitem><a ng-click=vm.onCloseBtnClicked() ui-sref=setting.earnings.my_earnings.images_sold ng-if=\"vm.user.data.canManageEarning && !vm.guestUser\" translate class=user-panel__dropdown-menu__item>{{\'earnings\'}}</a></li><li ng-switch-when=true ng-if=\"vm.user.data.isTrialUser || vm.user.data.canBuyCreditPlan\" role=menuitem><a ng-click=vm.onCloseBtnClicked() ng-if=!vm.guestUser ui-sref=setting.my_credit class=user-panel__dropdown-menu__item>{{\'my-credits\' | translate}}</a></li><li ng-switch-when=true role=menuitem class=\"dropdown-menu-title auth-menu-manage text--extrabold\" translate>{{\'manage\'}}</li><li ng-switch-when=true role=menuitem ng-if=vm.user.data.isFinanceInternal><a ng-click=vm.onCloseBtnClicked() ui-sref=payout-requests-page class=user-panel__dropdown-menu__item>Payout Requests</a></li><li ng-switch-when=true role=menuitem><a ng-click=vm.onCloseBtnClicked() ui-sref=setting.manage-photos.pending-review ng-if=\"vm.user.data.canUploadPhotos && !vm.guestUser\" class=user-panel__dropdown-menu__item>Photos</a></li><li ng-switch-when=true role=menuitem ng-if=vm.user.data.isContributor><a ui-sref=setting.manage-photos-mission.pending check-verified-email=true ng-if=\"vm.user.data.isContributor && !vm.guestUser\" class=user-panel__dropdown-menu__item>{{\'community-challenges\' | translate}}</a></li><li ng-switch-when=true role=menuitem><a authentication-click=vm.onManageCommissionClicked() ng-if=!vm.guestUser check-verified-email=true class=user-panel__dropdown-menu__item>{{\'custom-content-assignments\' | translate}}</a></li><li ng-switch-when=true role=menuitem ng-if=vm.user.data.isBiz><a ng-if=\"vm.user.data.canManageMission && !vm.guestUser\" authentication-click=vm.onManageMissionClicked() check-verified-email=true class=user-panel__dropdown-menu__item>{{\'community-challenges\' | translate}}</a></li><li ng-switch-when=true role=menuitem ng-if=vm.user.data.canVerifyBusinessUser><a ui-sref=setting.user-verification.sign-up class=user-panel__dropdown-menu__item>{{\'user-verification\' | translate}}</a></li><li ng-switch-when=true role=menuitem ng-if=vm.user.data.canCreateMediaPixerf><a ng-click=vm.onManageMediaPostClicked() class=user-panel__dropdown-menu__item>{{\'media\' | translate}}</a></li><li ng-switch-when=true role=menuitem><a ng-click=vm.onManageCommunityClicked() ng-if=!vm.guestUser check-verified-email=true class=user-panel__dropdown-menu__item>{{\'community-hub\' | translate}}</a></li><li ui-sref=logout role=menuitem class=logout-btn><a translate class=user-panel__dropdown-menu__item>{{\'logout\'}}</a></li></ul><div class=profile-menu-overlay ng-if=vm.isProfileMenuOpen></div></span></div></li><li id=E1 class=user-panel__sign-up-btn ng-switch-when=false ng-click=vm.onSignUpBtnClicked()><a href=\"\" class=text--color-pixerf-theme>{{\'sign-up\' | translate}}</a></li><li class=user-panel__log-in-btn ng-switch-when=false ng-click=vm.onSignInBtnClicked()><a href=\"\">{{\'log-in\' | translate}}</a></li></ul>");
$templateCache.put("app/components/cart/cart.html","<div class=cart><div class=cart__items-wrapper infinite-scroll-disabled=vm.isLastPage.data infinite-scroll=vm.fetchMoreitems() infinite-scroll-immediate-check=false infinite-scroll-container=\"\'.cart-wrapper\'\"><div ng-repeat=\"item in vm.cart.data.cart_items\" ng-click=\"vm.onCartItemClicked({cartItem: item, event: $event})\"><div class=cart-item><img class=cart-item__image ng-src=\"{{item.media.thumbnails[\'x100\']}}\" alt=\"\"><div class=cart-item__details><div class=cart-item__details__info><div class=\"cart-item__details__title text--truncate\">{{item.media.title}}</div><div class=\"cart-item__details__size text--truncate\"><span ng-repeat=\"license in item.media.extendedLicenses\">{{license.title}}/</span></div><div ng-repeat=\"price in item.media.price.range\" ng-show=price.isSelected>{{price.description}}</div></div><div class=cart-item__details__right-wrapper><div class=cart-item__details__cost>{{item.sub_total}} SGD</div><div class=cart-item__details__remove ng-click=\"vm.onRemoveItemClicked($event, item)\"><div class=cart-item__details__remove__text>Remove</div><div class=icon-icons_close></div></div></div></div></div><div class=divider ng-if=!$last></div></div></div></div>");
$templateCache.put("app/components/com-footer/com-footer.html","<div class=\"com-footer clearfix\" ng-show=isVisible><div class=com-footer__bottom-nav><!-- <div class=\"com-footer__bottom-nav__logo\">\r\n			<img src=\"assets/images/white-pixerf.svg\" alt=\"PIXERF\">\r\n		</div> --><div class=com-footer__bottom-nav__reserved>© 2022 PIXERF Private Limited. All Rights Reserved.</div><div class=com-footer__bottom-nav__social-media><div class=\"com-footer__bottom-nav__social-media__item fb-icon-sprite\"><a href=https://www.facebook.com/Pixerf target=_blank></a></div><div class=\"com-footer__bottom-nav__social-media__item ig-icon-sprite\"><a href=http://instagram.com/Pixerf target=_blank></a></div><div class=\"com-footer__bottom-nav__social-media__item li-icon-sprite\"><a href=https://www.linkedin.com/company/pixerf target=_blank></a></div><div class=\"com-footer__bottom-nav__social-media__item tt-icon-sprite\"><a href=https://twitter.com/Pixerf target=_blank></a></div><div class=\"com-footer__bottom-nav__social-media__item pt-icon-sprite\"><a href=https://www.pinterest.com/Pixerf/ target=_blank></a></div></div></div></div>");
$templateCache.put("app/components/create-gallery/create-gallery.html","<pixerf-alert instance=vm.alertSvc></pixerf-alert><div class=create-gallery ng-class=\"{\'create-gallery--edit-mode\': vm.mode === \'EDIT\'}\"><div class=clearfix><button type=button class=close ng-click=vm.onCancelBtnClicked()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal-header text-left\"><h3 class=\"modal--title text--bold text--color-black text-left\">{{vm.popupTitle}}</h3><p ng-if=\"!vm.type && vm.mode === \'CREATE\'\" translate>{{\'start-collecting-your-photos\'}}</p><p ng-if=\"vm.type === \'curated\' && vm.mode === \'CREATE\'\" translate>{{\'curated-gallery-description\'}}</p></div><div class=\"modal-body text-center\"><form name=createGalleryForm class=text-left><div ng-if=\"vm.mode === \'EDIT\'\" class=create-gallery__image-cover ng-class=\"{\'hover-show\': vm.cropped.source || vm.coverMedia}\"><div class=create-gallery__image-cover__button ng-click=vm.onEditCoverImage()>Change cover</div><img ng-if=vm.coverMedia class=create-gallery__image-cover__default ng-src={{vm.coverMedia}}></div><div class=form-group><label class=text--bold translate>{{\'title\'}}</label><input maxlength=50 name=title required ng-model=vm.gallery.data.title placeholder=\"{{\'give-this-gallery-name\' | translate}}\" type=text class=form-control></div><div class=\"form-group create-gallery__description\"><label class=text--bold translate>{{\'description\'}}</label><textarea validation-no-hyperlink maxlength=255 rows=3 name=description type=text ng-model=vm.gallery.data.description placeholder=\"{{\'tell-us-more\' | translate}}\" class=form-control></textarea><div class=text-right><span class=textarea__length_descriptioon>{{vm.gallery.data.description ? vm.gallery.data.description.length: 0}}/255</span></div></div><div class=\"form-group pixerf-checkbox pixerf-checkbox--medium create-gallery__restriction-checkbox ng-hide\"><pixerf-checkbox model=vm.gallery.data model-property=is_private></pixerf-checkbox><label class=create-gallery__restriction-checkbox__main-label>Make Private</label><label class=create-gallery__restriction-checkbox__sub-label>Not ready for your big reveal? Private galleries will be hidden from your public profile.</label></div></form></div><div class=modal-footer><button ng-if=\"vm.mode === \'CREATE\'\" ng-click=vm.onCancelBtnClicked() type=button class=\"btn btn-cancel\">{{\'cancel\' | translate}}</button> <a class=btn-delete-gallery ng-if=\"vm.mode === \'EDIT\'\" href=\"\" ng-click=vm.onDeleteGalleryBtnClicked(vm.gallery.data)>{{\'delete\' | translate: {something: (\'this-gallery\' | translate)}}}</a> <button ng-disabled=\"vm.isWorking || createGalleryForm.title.$error.required\" ng-click=vm.onSaveBtnClicked(vm.gallery.data,createGalleryForm) type=button class=\"btn btn-submit btn-save-gallery\">{{vm.mode === \"EDIT\" ? (\'save\' | translate) : (\'done\' | translate)}}</button></div></div></div>");
$templateCache.put("app/components/edit-cart-btn/edit-cart-btn.html","<div class=\"text-center edit-cart-btn\"><div><button class=\"container-full btn btn-submit btn-block\" authentication-click=vm.onEditCartBtnClicked(cartItem)>Save to Cart</button></div></div>");
$templateCache.put("app/components/galleries-list/galleries-list.html","<div scroll=vm.onWindowScroll() class=\"galleries-list-wrapper pixerf-scrollable-but-not-parent\" tabindex=0 ng-mouseover=vm.onGalleriesListHover() ng-mouseleave=vm.onGalleriesListLeave()><div class=galleries-list__gallery-list-wrapper infinite-scroll-disabled=vm.isLastPage.data infinite-scroll=vm.fetchMoreGallaries() infinite-scroll-immediate-check=false infinite-scroll-container=\"\'.galleries-list-wrapper\'\"><div class=\"gallery-item clearfix\" ng-click=\"vm.onGalleryItemClicked($event, gallery)\" ng-repeat=\"gallery in vm.galleries.data | filter : vm.filterFn\"><div class=\"gallery-item__thumbnail pull-left\"><div class=gallery-item__thumbnail__cover-photo ng-style=\"{\'background-image\': \'url(\' + gallery.thumbnailPath + \')\'}\"></div><span ng-show=!gallery.thumbnail class=\"gallery-item__thumbnail__short-name absolute absolute--full text-center text--color-white\">{{gallery.title.substr(0, 1)}}</span></div><div class=\"gallery-item__title text--bold text--color-black pull-left text--truncate\">{{gallery.title}}</div><span ng-show=gallery.isSelected class=icon-icons_check></span></div><div class=\"galleries-list__empty-state text-center\" ng-if=\"vm.galleries.data.length === 0\">You haven\'t created any galleries yet!</div><scroll-paging spinner=vm.spinner show-message=false is-last-page=vm.isLastPage.data message=\"No more gallery to load.\"></scroll-paging></div></div>");
$templateCache.put("app/components/gallery/gallery.html","<section class=\"gallery-page bg--night relative main__content--md\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div class=\"marketplace__sub-navigate clearfix\" scroll-to-fixed=vm.scrollToFixedHeaderSettings><div class=marketplace__sub-navigate__back-btn ng-click=vm.onBackbtnClicked()><span class=\"marketplace__sub-navigate__back-btn__icon text--color-black text--bold\">&lt;</span><span translate=back-to translate-values=\"{name: (\'galleries\' | translate)}\"></span></div></div><div class=\"gallery-page__header clearfix\"><div class=gallery-page__header__title>{{vm.gallery.data.title | toTitleCase}}</div><div class=\"gallery-page__header__description col-xs-6 no-padding\">{{vm.gallery.data.description}}</div><div class=\"gallery-page__header__sub clearfix\"><div class=\"gallery-page__header__sub__info clearfix\"><div class=gallery-page__header__sub__avatar><a ui-sref=\"user-home-page.personal.home({id: vm.user.id, userName: (vm.user.displayName | toSnakeCase)})\"><pixerf-user-avatar class=profile-image user-data=vm.user lazy=true></pixerf-user-avatar></a></div><div class=gallery-page__header__sub__author><div class=gallery-page__header__sub__author__by ng-bind=\"vm.gallery.data.is_curated ? (\'curated-by\' | translate) : (\'gallery-by\' | translate)\"></div><div class=gallery-page__header__sub__author__name><a ui-sref=\"user-home-page.personal.home({id: vm.user.id, userName: (vm.user.displayName | toSnakeCase)})\" class=\"pixerf-link--color-theme text--bold\">{{vm.user.displayName}}</a></div></div></div><div class=gallery-page__header__sub__action><button ng-if=vm.isMine ng-click=vm.showEditGalleryPopup() class=\"edit-gallery-btn btn btn-pixerf-theme btn-pixerf-theme--no-background text--bold\" translate translate-values=\"{name: (\'gallery\' | translate)}\">{{\'edit\'}}</button><follow-gallery-btn ng-if=\"!vm.isMine && (!vm.loginnedUser || vm.loginnedUser.canManageGalleries)\" gallery=vm.gallery.data></follow-gallery-btn><div class=\"gallery-page__header__sub__navigation-bar collapse navbar-collapse\" navbar-collapse-on-click=true id=gallery-share-navbar-collapse><share settings=\"{\'flatMode\': true}\" content-will-be-shared=vm.socialShareContent title=\"Share this gallery\"></share></div></div></div></div><div class=gallery-page__main-content><div ng-show=\"vm.photoGrid.photos.length === 0\" class=\"text-center gallery-empty-info ng-hide\"><div class=icon-icons-gallery></div><h4 class=\"gallery-page__main-content__title text--semibold text--color-black\" ng-bind-html=vm.emptyText[vm.type]></h4><p>Click on this icon <span class=icon-icons-add-to-gallery></span> on any photo to save it to your gallery.</p><a ng-if=vm.gallery.data.is_curated class=\"text--color-pixerf-theme gallery-page__discover-market\" ui-sref=buy-stock-page.trending>{{\'discover-marketplace\' | translate}}</a></div><div ng-hide=\"vm.photoGrid.photos.length === 0\" class=\"photos-grid-wrapper clearfix relative\"><photo-grid on-file-removed=vm.onFileRemoved(file) gallery=vm.gallery.data instance=vm.photoGrid></photo-grid></div><div class=\"gallery-page__related-galleries clearfix\"><div class=gallery-page__related-galleries__title translate>{{\'related-galleries-you-like\'}}</div><gallery-grid instance=vm.galleryGrid></gallery-grid></div></div></section>");
$templateCache.put("app/components/main-nav/main-nav.html","<div class=\"main-nav clearfix {{vm.stateName}}\"><div class=main-nav__logo ui-sref=home><img src={{vm.logoUrl}} alt=Pixerf></div><div class=login-item><!-- <div ng-click=\"vm.onLoginBtnClicked()\" ng-if=\"!vm.user\" class=\"main-nav__main-menu__item__login icon-baseline-lock\"></div> --><!-- <pixerf-user-avatar popover-trigger=\"\'outsideClick\'\" popover-append-to-body=true uib-popover-template=\"\'popover-user-menu.html\'\" popover-placement=\"bottom\" popover-title=\"{{vm.dynamicPopover.title}}\" ng-if=\"vm.user\" class=\"pull-left\" user-data=\"vm.user\"></pixerf-user-avatar> --></div><div class=\"main-nav__main-menu desktop-menu\"><div class=main-nav__main-menu__item ui-sref-active=active-item><a ui-sref=about>About</a></div><div class=main-nav__main-menu__item ui-sref-active=active-item><a ui-sref=work({id:233})>Work</a></div><div class=main-nav__main-menu__item><span class=\"cart-icon icon-icon-cart\"></span><popover-cart></popover-cart></div></div><div class=mobile-menu><div class=\"collapse-menu-btn clearfix\" ng-click=vm.toggleMenu() ng-class=\"{\'active\': vm.isNavShowed}\"><span class=\"icon-bar one\"></span> <span class=\"icon-bar two\"></span> <span class=\"icon-bar three\"></span></div><div id=hamburger-menu class=list-navigation><div class=menu-items><div class=menu-items__wrapper><div class=item-wrapper><div class=item ui-sref-active=active-item ui-sref=about ng-click=vm.navigateTo()>About</div></div><div class=item-wrapper><div class=item ui-sref-active=active-item ui-sref=work({id:233}) ng-click=vm.navigateTo()>Work</div></div></div></div><div class=\"menu-footer clearfix\"></div></div></div><!-- <script type=\"text/ng-template\" id=\"popover-user-menu.html\">\r\n		<a ng-if=\"vm.user.isAdmin\" ui-sref=\"dashboard\">Dashboard</a>\r\n		<div class=\"pixerf-link pixerf-link--color-theme\" ng-click=\"vm.onBtnLogoutClicked()\">Logout</div>\r\n    </script> --></div>");
$templateCache.put("app/components/photo/more-action-popover.html","<div class=photo-more-action-popover><div class=photo-more-action-popover__item-wrapper><div class=photo-more-action-popover__item ng-click=vm.setPhotoAsCover()>Set as Gallery Cover</div><div class=photo-more-action-popover__item ng-click=\"vm.removePhotoFromGallery(file, gallery)\">Remove from Gallery</div></div></div>");
$templateCache.put("app/components/photo/photo.html","<div ng-click=vm.onPhotoClicked(file) ng-style=\"{\'background-image\': \'url(\' + vm.imageUrl + \')\'}\" class=photo ng-attr-data-photo-id=file.id><div class=\"text-center add-to-cart-btn hidden-on-hover added-to-cart\" ng-if=vm.isAddedToCart><div><button class=\"container-full btn btn-submit btn-block\"><img src=assets/images/icon-checked-cart.svg class=icon-checked-cart> Added to cart</button></div></div><div class=overlay ng-click=vm.onAddToCartBtnClicked(file)><!-- <div ng-if=\"vm.isAddedToCart\" class=\"overlay__added-to-cart\"><span class=\"icon-check-circle\"></span> Added to cart</div> --><div class=\"text-center add-to-cart-btn overlay__added-to-cart\" ng-if=vm.isAddedToCart><div><button class=\"container-full btn btn-submit btn-block\"><img src=assets/images/icon-checked-cart.svg class=icon-checked-cart>Added to cart</button></div></div><div class=photo__add-to-cart-icon ng-class=\"vm.isAddedToCart ? \'icon-check-circle hover-on-added-item\' : \'icon-icon-cart\'\"></div></div></div>");
$templateCache.put("app/components/photo-detail/photo-detail.html","<div class=photo-detail><div class=\"clearfix relative\"><div class=\"photo-detail__main-content bg--night\"><div class=\"content-wrapper relative\"><div class=absolute--full><photo-viewer instance=photoViewer on-photo-saved=vm.onPhotoRotated() on-navigate=vm.setPhoto(photo) photo=photo class=photo-detail__main-content__photo-thumbnail photo-loaded=vm.onItemImageLoadHandler></photo-viewer></div></div><ng-include ng-if=\"isMobile && !isEditMode.data\" src=\"\'app/components/photo-detail/segments/photo-detail-user-photo-brief.html\'\"></ng-include><div class=clearfix><photo-exif-info media=photo class=\"photo-exif-info col-md-12\"></photo-exif-info><div class=\"ng-hide photo-detail__main-content__report-photo col-md-2 text-right\"><h5><a class=text--color-pixerf-theme href=\"\">Report this Photo</a></h5></div></div><div ng-if=!isEditMode.data><ng-include ng-if=!isMobile src=\"\'app/components/photo-detail/segments/photo-detail-keyword-similar.html\'\"></ng-include></div></div><div ng-class=\"{\'overflow--scroll\': !isEditMode.data}\" class=\"photo-detail__photo-info bg--night\"><ng-include ng-if=\"!isMobile && !isEditMode.data\" src=\"\'app/components/photo-detail/segments/photo-detail-user-photo-brief.html\'\"></ng-include><div class=\"photo-detail__photo-info--padding photo-detail__photo-info__private-label\" ng-if=\"photo.isMine && !photo.price\" ng-show=false><span class=\"label label-warning\">Private</span> <span class=icon-icons-info tooltip-placement=right tooltip-class=text-left tooltip-append-to-body=true uib-tooltip-html=vm.privateToolTip tooltip-placement=auto></span></div><div ng-if=!isEditMode.data class=\"photo-detail__photo-info__devider devider\"></div><div class=\"photo-detail__photo-info--padding photo-detail__photo-info__pricing\" ng-if=!isEditMode.data><h5 ng-if=!isMobile class=\"text--extrabold text--color-black photo-detail__photo-info__pricing__header--dimension\">Licensing Details</h5><div ng-if=isMobile class=photo-detail__item__header data-toggle=collapse data-target=#photo-details-licensing aria-expanded=true><h5 class=\"text--extrabold text--color-black photo-detail__photo-info__pricing__header--dimension\">Licensing Details</h5><span class=\"photo-detail__item__collapse-icon icon-icons_plus\"></span> <span class=\"photo-detail__item__collapse-icon icon-icons_minus\"></span></div><div class=\"clearfix photo-detail__photo-info__pricing__price-item collapse in\" id=photo-details-licensing><div class=clearfix><div class=\"pull-left col-md-5 no-padding\"><div class=\"photo-detail__photo-info__pricing__header--license-type text--bold text--color-black\">License Type</div></div><photo-license-info photo=photo></photo-license-info></div><div class=clearfix><div class=\"pull-left col-md-8 no-padding ng-hide\"><div class=\"photo-detail__photo-info__pricing__price-item__dimension-title text--bold text--color-black-2\">Price</div></div><div class=\"pull-left col-md-4 no-padding ng-hide\"><div class=\"text--color-black-2 text-right photo-detail__photo-info__pricing__price-item__editorial\">{{photo.price ? (\'SGD \' + photo.price) : \'Not set\'}}</div></div></div></div><h5 class=\"text--semibold photo-detail__photo-info__pricing__header--dimension ng-hide\">Dimension</h5><hr ng-if=isMobile class=photo-detail__mobile-devider><div ng-if=isMobile class=photo-detail__item__header data-toggle=collapse data-target=#photo-details-photo-price-size-selection aria-expanded=true><h5 class=\"text--extrabold text--color-black photo-detail__photo-info__pricing__header--dimension\">Pricing Details</h5><span class=\"photo-detail__item__collapse-icon icon-icons_plus\"></span> <span class=\"photo-detail__item__collapse-icon icon-icons_minus\"></span></div><div id=photo-details-photo-price-size-selection class=\"photo-detail__photo-price-size-selection collapse in\"><photo-price-size-selection user=photo.user class=clearfix is-readonly=photo.isMine ng-if=!photo.in_mission photo=vm.cartItem.media on-item-selected-changed=\"vm.onVariantSelected(evt, price)\" ng-if=!photo.in_mission></photo-price-size-selection><div ng-if=photo.in_mission class=photo-original-size-wrapper><div class=\"photo-detail__photo-info__pricing__header--license-type text--bold text--color-black-2\">Photo size</div><photo-original-size photo=photo></photo-original-size></div><photo-price-extended-license-selection class=clearfix ng-if=\"!photo.isMine && !photo.in_mission\" photo=vm.cartItem.media on-item-selected-changed=\"vm.onVariantSelected(evt, price)\"></photo-price-extended-license-selection></div><div ng-if=\"!photo.isMine && !photo.in_mission\" class=\"clearfix photo-detail__photo-info__pricing__price-item photo-detail__photo-info__pricing__price-item--sub-total\"><label class=\"text--extrabold text--color-black photo-detail__photo-info__pricing__price-item--sub-total__label\">Sub-total</label><div class=\"pull-right text--color-black col-md-3 no-padding text-right photo-detail__photo-info__pricing__price-item--sub-total__value\">SGD <span class=text--extrabold>{{vm.cartItem.sub_total}}</span></div></div><winner-photo-selection ng-if=\"photo.in_mission && vm.loginnedUser && vm.loginnedUser.canManageMission && !photo.mission.is_awarded  && photo.mission.is_closed && photo.state != \'r\' && photo.state != \'h\'\" mission=photo.mission media=photo></winner-photo-selection><div class=photo-detail__badge ng-if=\"photo.badges.length > 0\"><pixerf-badges badges=photo.badges></pixerf-badges></div></div><div class=\"photo-detail__photo-info--padding ng-hide\"><call-to-action-messages messages=vm.callToActionMesages></call-to-action-messages></div><hr ng-if=isMobile class=photo-detail__mobile-devider--no-margin><div class=\"photo-detail__photo-info--padding photo-detail__photo-info--btns-wrapper\" ng-if=!isEditMode.data><div class=photo-detail__photo-info__notice-in-mission ng-if=photo.in_mission compile=\"\'\'this-photo-is-part-of-mission\' | translate\'\"></div><div class=\"text-center photo-detail__photo-info__btn-edit-wrapper text--bold\" ng-if=\"photo.isMine || (vm.loginnedUser && vm.loginnedUser.canCurate)\"><button ng-click=vm.onEditBtnClicked() class=\"photo-detail__photo-info__btn-edit container-full btn btn-cancel--no-background btn-block\">{{\'edit-photo\' | translate}}</button></div><div ng-if=\"vm.loginnedUser && vm.loginnedUser.canDownloadComp\" class=\"photo-detail__photo-info__download-comp btn btn-cancel--no-background\" ng-click=vm.onDownloadComp(photo)>Download Comp</div><add-to-cart-btn ng-attr-title=\"{{photo.in_mission ? \'This photo is under review in a Mission\' : \'\'}}\" is-disabled=photo.in_mission on-added=vm.onAddedToCart(addedCartItem) media=vm.cartItem.media ng-if=\"!photo.isMine && !vm.cartItem.id && photo.state !=\'r\'\" ng-class=\"{\'btn-no-background\': vm.loginnedUser && vm.loginnedUser.canCurate && photo.status && photo.status !== \'none\' && photo.releases.length > 0}\"></add-to-cart-btn><div class=\"text-center add-to-cart-btn added-to-cart\" ng-if=\"!photo.isMine && vm.cartItem.id && photo.state !=\'r\'\"><div><button class=\"container-full btn btn-submit btn-block\"><span class=\"icon icon-icons_check\"></span> Added to cart</button></div><nomination-badge nomination-count=photo.nomination_count></nomination-badge><div ng-if=\"photo.status && photo.status !== \'none\' && photo.releases.length > 0\"><approve-reject-release-form alert=alert file=photo></approve-reject-release-form></div></div><hr ng-if=isMobile class=photo-detail__mobile-devider--no-margin><div ng-if=isEditMode.data class=\"height--full photo-detail__photo-info__edit-detail overflow--scroll\"><upload-photo-detail is-loading-clarifai=vm.isLoadingClarifai alert=alert form-error=vm.formError is-form-dirty=vm.isFormDirty files=[photo] categories=vm.categories></upload-photo-detail><div class=\"photo-detail__photo-info--padding text-center photo-detail__photo-info__btn-save-cancel-delete-wrapper\"><button class=\"photo-detail__photo-info__btn-save container-full btn btn-submit btn-block\" ng-disabled=vm.isSaving ng-click=vm.onSaveChangesBtnClicked()>{{vm.isSaving ? \'Saving ...\' : (\'save-changes\' | translate)}}</button><div class=photo-detail__photo-info__btn-cancel-delete-wrapper><a class=photo-detail__photo-info__btn-cancel ng-click=vm.onCancelPhotoBtnClicked()>{{\'cancel\' | translate}}</a> <a class=photo-detail__photo-info__btn-delete><pixerf-delete-media-btn pixerf-delete-media-btn-media=photo pixerf-delete-media-btn-btn-label=delete pixerf-delete-media-btn-on-media-deleted=\"onPhotoDeleted({photo: media})\" context=vm.context></pixerf-delete-media-btn></a></div></div></div><div ng-if=\"!isEditMode.data && isMobile\" class=photo-detail__main-content><ng-include src=\"\'app/components/photo-detail/segments/photo-detail-keyword-similar.html\'\"></ng-include></div></div></div></div></div>");
$templateCache.put("app/components/photo-detail-popup/photo-detail-popup.html","<pixerf-alert instance=vm.pixerfAlert></pixerf-alert><div class=photo-detail-popup scroll-to-top-modal-target=.photo-detail-modal scroll-to-top-modal=vm.shouldScrollTop.data><button type=button class=\"close photo-detail-popup__close-btn\" ng-click=vm.closePopup()><span class=\"icon-icons_close text--color-white\" aria-hidden=true></span></button><div class=\"clearfix relative\"><photo-detail photo-viewer=vm.photoViewer is-edit-mode=vm.isEditing alert=vm.pixerfAlert on-saved=vm.onSaved(savedPhoto) photo=vm.data.photo on-photo-deleted=vm.onDeletePhotoBtnClicked(photo) context=vm.context></photo-detail></div></div>");
$templateCache.put("app/components/photo-exif-info/photo-exif-info.html","<div class=photo-exif-info><div class=photo-exif-info__header data-toggle=collapse data-target=#photo-details-collapse aria-expanded=true><h5 class=photo-exif-info__title>Photo Details</h5><span class=\"photo-exif-info__collapse-icon icon-icons_plus\"></span> <span class=\"photo-exif-info__collapse-icon icon-icons_minus\"></span></div><h5 class=photo-exif-info__title>Photo Details</h5><div class=\"collapse in\" id=photo-details-collapse><div class=photo-exif-info__exif-items><div class=\"photo-exif-info__item photo-exif-info__item__camera-info\"><div ng-if=!vm.showInfoCamera class=photo-exif-info__item__camera-info__not-available>Camera info not available</div><div ng-if=media.camera.model class=photo-exif-info__item__camera-info__model>{{media.camera.cameraFormated}}</div><div ng-if=\"media.camera.model && media.isMine\" class=photo-exif-info__item__camera-info__hide><hide-camera media=media class=photo-exif-info__item__camera-info__hide-icon></hide-camera></div><div class=photo-exif-info__item__camera-info__first-prop>{{media.camera.lens_model}}</div><div class=photo-exif-info__item__camera-info__second-prop>{{media.camera.takenInfo}}</div></div><div class=\"photo-exif-info__item photo-exif-info__item__date-time\"><div class=photo-exif-info__item__row><label class=photo-exif-info__item__title>Location</label><div class=photo-exif-info__item__description>{{media.location.formatted_address ? media.location.formatted_address : media.location}}</div></div><div class=photo-exif-info__item__row><label class=photo-exif-info__item__title>Date Taken</label><div class=photo-exif-info__item__description>{{media.camera.imageCapturedDateFormated}}</div></div><div class=photo-exif-info__item__row><label class=photo-exif-info__item__title>Date Uploaded</label><div class=photo-exif-info__item__description>{{media.createdAtFormated}}</div></div></div><div class=\"photo-exif-info__item photo-exif-info__item__others\"><div class=photo-exif-info__item__row><label class=photo-exif-info__item__title>Photo ID</label><div class=photo-exif-info__item__description>{{media.id}}</div></div><div class=photo-exif-info__item__row><label class=photo-exif-info__item__title>Release Info</label><div class=photo-exif-info__item__description>{{vm.buildPhotoReleaseInfo(media)}}</div></div></div></div></div></div>");
$templateCache.put("app/components/photo-grid/photo-grid.html","<div class=photo-grid on-window-resize-event=vm.onWindowResize() on-orientation-change-event=vm.onOrientationChange() ng-class=\"{\'photo-grid--fresh\': vm.isFresh && vm.spinner.isVisible}\"><div infinite-scroll-distance=0.5 class=\"clearfix photo-grid__photos-container\" infinite-scroll-disabled=vm.isNoMorePhotoToLoad infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false infinite-scroll-container=vm.containerClass></div><ng-transclude class=ng-hide ng-hide=\"vm.photos.length > 0 || vm.spinner.isVisible\"></ng-transclude><scroll-paging spinner=vm.spinner show-message=\"!hideNoMoreMessage && vm.photos.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isNoMorePhotoToLoad message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div>");
$templateCache.put("app/components/photo-grid-pager/photo-grid-pager.html","<form ng-submit=\"onCurrentPageChanged({pageNumber: page})\" class=photo-grid-pager><!-- <span class=\"photo-grid-pager__page-total-photos\"><span class=\"text--bold text--color-black\">{{isShownNumPhotos ? totalPhotos : totalPhotoText}}</span> <span class=\"photo-grid-pager__item-unit\"> {{unit ? unit : (totalPhotos === 1 ? \'Photo\' : \'Photos\')}}</span></span> --> <span class=photo-grid-pager__page-text>Page</span> <input ng-disabled=spinner.isVisible parse-integer number-range=\"{{\'[1,\' + totalPage  + \']\'}}\" class=photo-grid-pager__page-number-input ng-model=page> <span class=photo-grid-pager__page-total-page_pretext>of</span> <span class=\"photo-grid-pager__page-total-page__number text--bold\">{{totalPage}}</span> <span ng-if=isShowPageText class=photo-grid-pager__page-total-page-posttext>{{totalPage === 1 ? \'Page\' : \'Pages\'}}</span></form>");
$templateCache.put("app/components/photo-price-size-selection/photo-price-size-selection.html","<div class=photo-price-size-selection ng-class=\"{\'layout-horizontal clearfix\': vm.layoutHorizontal}\"><div class=\"clearfix photo-price-size-selection__item\" ng-if=\"!vm.layoutHorizontal && vm.isCustomPriceForDefiner(user.id, price.title)\" ng-repeat=\"price in photo.price.range\"><div class=\"pull-left col-md-1 col-xs-1 no-padding\" ng-if=!isReadonly ng-click=\"vm.onPriceItemClicked($event, price)\" ng-class=\"{\'icon-bullet-checked\' : price.isSelected, \'icon-bullet-uncheck\': !price.isSelected}\"></div><div class=\"pull-left col-md-8 col-xs-8 no-padding\"><div class=\"photo-price-size-selection__item__dimension-title text--bold text--color-white\"><span ng-if=!vm.commonConst.CHEATED_USERS.DEFINERS.includes(user.id) class=photo-price-size-selection__item__dimension-title-text>{{\'size-\' + price.title.toLowerCase() | translate}}</span> <span ng-if=vm.commonConst.CHEATED_USERS.DEFINERS.includes(user.id) class=photo-price-size-selection__item__dimension-title-text>{{price.title == \"Small\" ? \"Insert Page\" : \"Front cover\"}}</span> <span uib-tooltip-html=price.toolTips tooltip-append-to-body=true class=icon-icons-info tooltip-class=photo-price-size-selection__item__tooltips tooltip-placement=auto></span> <span ng-if=\"price.title.toLowerCase() === \'x-small\'\" class=photo-price-size-selection__item__new-label>New!</span></div><div class=photo-price-size-selection__item__dimension-description>{{price.description}}</div></div><div class=\"pull-right text--color-white col-xs-3 col-md-3 no-padding text-right\">SGD <span class=text--bold>{{price.price}}</span></div></div><div ng-if=vm.layoutHorizontal><div class=\"clearfix photo-price-size-selection__item-wrapper\"><div class=\"text--color-black text-right pull-right photo-price-size-selection__item__price\">SGD <span class=text--bold>{{vm.selectedPrice.price}}</span></div><div ng-if=!vm.commonConst.CHEATED_USERS.DEFINERS.includes(user.id) class=\"clearfix photo-price-size-selection__item text--semibold\" ng-class=\"{\'photo-price-size-selection__item--selected\' : priceItem.isSelected}\" ng-repeat=\"priceItem in photo.price.range\" ng-click=\"vm.onPriceItemClicked($event, priceItem)\">{{priceItem.size}}</div><div ng-if=\"vm.commonConst.CHEATED_USERS.DEFINERS.includes(user.id) && vm.isCustomPriceForDefiner(user.id,priceItem.size)\" class=\"clearfix photo-price-size-selection__item text--semibold\" ng-class=\"{\'photo-price-size-selection__item--selected\' : priceItem.isSelected}\" ng-repeat=\"priceItem in photo.price.range\" ng-click=\"vm.onPriceItemClicked($event, priceItem)\">{{priceItem.size == \"S\" ? \"I\" : \"F\"}}</div></div><div class=photo-price-size-selection__item__dimension-description>{{vm.selectedPrice.description}}</div></div></div>");
$templateCache.put("app/components/photo-license-info/photo-license-info.html","<div class=photo-license-info><table class=table><tr><th class=relative><span class=\"photo-license-info__text photo-license-info__license-label\">Editorial</span><span class=icon-icons-info tooltip-class=\"photo-license-tooltip photo-license-tooltip-editorial\" tooltip-trigger=\"\'outsideClick\'\" tooltip-append-to-body=true uib-tooltip-template=\"\'photo-license-tooltip-template-editorial\'\"></span></th><td class=\"photo-license-info__text text-right text--bold\">Yes</td></tr><tr ng-if=\"(photo.license === \'commercial\' && (photo.has_model_property === true || photo.has_model_property === false)) ||  photo.license === \'editorial\'\"><th class=relative><span class=\"photo-license-info__text photo-license-info__license-label\">Commercial</span><span class=icon-icons-info tooltip-class=\"photo-license-tooltip photo-license-tooltip-commercial\" tooltip-trigger=\"\'outsideClick\'\" tooltip-append-to-body=true uib-tooltip-template=\"\'photo-license-tooltip-template-commercial\'\"></span></th><td ng-show=\'photo.license === \"editorial\"\' class=\"photo-license-info__text text-right text--bold\">No</td><td class=\"photo-license-info__text text-right text--bold\" ng-show=\'photo.license === \"commercial\" && ((photo.has_model_property && photo.status === \"approved\") || photo.has_model_property === false)\'>{{ vm.getCommercialStatus() }}<request-license-btn ng-show=vm.showDownloadRelease() media=photo class=\"pixerf-link pixerf-link--color-theme\">Download Release</request-license-btn></td><td class=\"photo-license-info__text text-right text--bold\" ng-show=\'photo.license === \"commercial\" && photo.has_model_property && photo.status !== \"approved\"\'><div tooltip-class=photo-license-tooltip tooltip-trigger=\"\'outsideClick\'\" tooltip-append-to-body=true uib-tooltip-template=\"\'photo-license-pending-review-tooltip-template\'\" class=pixerf-link--color-blue>{{ vm.getCommercialStatus() }}</div><request-license-btn ng-show=vm.showDownloadRelease() media=photo class=\"pixerf-link pixerf-link--color-theme\">Download Release</request-license-btn></td></tr><tr ng-if=\"vm.loginnedUser && vm.loginnedUser.canCurate\" class=photo-license-info__text ng-show=\'photo.license === \"commercial\" && (photo.has_model_property ) && !(photo.releases && photo.releases.length)\'><th></th><td class=\"pixerf-link pixerf-link--color-theme request-release-form text--semibold text-right\" ng-click=vm.onRequestReleaseFormBrnclicked(photo)>Request release form</td></tr></table><div class=photo-license-info__request-license-btn-wrapper ng-if=\"photo.license === \'editorial\' && photo.isMine\"><request-license-btn ng-show=vm.loginnedUser media=photo class=\"pixerf-link pixerf-link--color-theme\">Request for commercial licensing</request-license-btn></div><script type=text/ng-template id=photo-license-pending-review-tooltip-template><div class=\"tag-template\">\r\n            Our curators are currently reviewing the release forms for this photo. <a ui-sref=\"introduction-support.faq.personal({section: \'licensing\'})\"\r\n                target=\"_blank\" class=\'text--color-pixerf-theme text--bold\'>Learn more.</a>\r\n        </div></script><script type=text/ng-template id=photo-license-tooltip-template><div class=\"tag-template\">\r\n            <span ng-bind=\"photo.status !== \'pending\' && photo.status !== \'rejected\' &&  photo.license === \'editorial\' ? \'Can be used for news articles, blog posts and social media.\' : photo.status !== \'pending\' && photo.status !== \'rejected\' &&  photo.license === \'commercial\' ? \'Can be used for both commercial and editorial purposes, including advertisements.\' : \'\'\"></span>\r\n            <a  ui-sref=\"introduction-support.faq.personal({section: \'licensing\'})\" target=\"_blank\" class=\'text--color-pixerf-theme text--bold\' pixerf-close-on-click=\"true\"> Learn more.</a>\r\n        </div></script><script type=text/ng-template id=photo-license-tooltip-template-commercial><div class=\"tag-template\">\r\n            <span>Can be used for both commercial and editorial purposes, including advertisements.</span>\r\n            <a ui-sref=\"introduction-support.faq.personal({section: \'licensing\'})\" target=\"_blank\" class=\'text--color-pixerf-theme text--bold\' pixerf-close-on-click=\"true\"> Learn more.</a>\r\n        </div></script><script type=text/ng-template id=photo-license-tooltip-template-editorial><div class=\"tag-template\">\r\n            <span>Can be used for news articles, blog posts and social media.</span>\r\n            <a\r\n            ui-sref=\"introduction-support.faq.personal({section: \'licensing\'})\" target=\"_blank\" class=\'text--color-pixerf-theme text--bold\' pixerf-close-on-click=\"true\"> Learn more.</a>\r\n        </div></script></div>");
$templateCache.put("app/components/photo-viewer/photo-viewer.html","<div class=\"photo-viewer text-center relative\" upload-photo-preview-scale><div class=upload-photo-preview__overlay event-right-click><div class=photo__tools-wrapper><div class=photo__tools-wrapper__left ng-if=\"vm.loginUser && vm.loginUser.canCurate\"><pixerf-photo-state-btn need-review-license=true ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=g pixerf-photo-state-btn-media=photo title=\"Move to General\"></pixerf-photo-state-btn><pixerf-photo-state-btn ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=h pixerf-photo-state-btn-media=photo title=\"Move to Pending\"></pixerf-photo-state-btn><pixerf-photo-state-btn need-review-license=true ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=d pixerf-photo-state-btn-media=photo title=\"Move to Discover\"></pixerf-photo-state-btn><pixerf-photo-state-btn need-review-license=true ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=t pixerf-photo-state-btn-media=photo title=\"Move to Trending\"></pixerf-photo-state-btn><star-btn is-show-tooltip=true class=\"photo__tools photo__tools--left photo__tools__star-btn\" target=photo ng-click=$event.stopPropagation() hover-show-number=true></star-btn><pixerf-photo-state-btn is-need-confirm=\"photo.state !==\'h\' && photo.state !==\'r\'\" need-review-license=\"!!photo.user.ambassadorship && (photo.state ===\'h\' || photo.state ===\'r\')\" ng-if=\"vm.loginUser && (vm.loginUser.isAdminInternal) && (!!photo.user.ambassadorship || (!photo.user.ambassadorship && photo.state !==\'h\' && photo.state !==\'r\'))\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=e pixerf-photo-state-btn-media=photo title=\"Set as Editor\'s Pick\"></pixerf-photo-state-btn></div><div class=photo__tools-wrapper__right ng-if=\"vm.loginUser && (vm.loginUser.canCurate)\"><pixerf-photo-state-btn ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=r pixerf-photo-state-btn-media=photo ng-attr-title=\"{{photo.state===\'r\' && photo.reject_reason ? \'Reject Reason: \' + photo.reject_reason : \'Reject this photo\'}}\"></pixerf-photo-state-btn></div><div class=photo-viewer__toolbar ng-if=\"photo.isMine && false\"><div class=photo-viewer__toolbar__reset-btn ng-show=\"vm.originRotateStep !== vm.rotateStep\"><span ng-click=vm.resetRotation()>Reset</span></div><div class=photo-viewer__toolbar__rotate-btn ng-click=vm.rotatePhoto()><div><div class=icon-icons-rotate></div><div class=\"photo-viewer__toolbar__rotate-btn__label text--bold\">Rotate</div></div></div><div class=photo-viewer__toolbar__save-btn><button ng-disabled=vm.isWorking ng-click=vm.saveRotation() class=\"btn btn-submit\" ng-show=\"vm.originRotateStep !== vm.rotateStep\">Save</button></div></div></div></div><a ng-disabled=!vm.isLastPrev ng-if=vm.showNavigateBtn ng-click=\"vm.isLastPrev && vm.navigate(\'prev\')\" class=\"photo-viewer__photo-navigator photo-viewer__photo-navigator__prev-photo\" ng-class=\"{\'disabled\': !vm.isLastPrev}\"><span class=icon-icons_chevron-left></span> </a><img ng-attr-alt={{photo.title}} scale-image ng-src={{photo.url}} refit-image-after-rotating=true img-orientation-original-style img-orientation=vm.rotateStep image-onloaded=photoLoaded> <a ng-disabled=!vm.isLastNext ng-if=vm.showNavigateBtn event-key on-key-pressed=vm.logKey ng-click=\"vm.isLastNext && vm.navigate(\'next\')\" class=\"photo-viewer__photo-navigator photo-viewer__photo-navigator__next-photo\" ng-class=\"{\'disabled\': !vm.isLastNext}\"><span class=icon-icons_chevron-right></span></a></div>");
$templateCache.put("app/components/pixerf-animation-carousel/pixerf-animation-carousel.html","<div class=pixerf-animation-carousel id=carousel-{{instance}}><div class=\"pixerf-slick-nav prev-slide-nav clearfix\"><div class=\"pixerf-slick-prev icon-icons_chevron-left\"></div></div><div class=\"pixerf-slick-nav next-slide-nav clearfix\"><div class=\"pixerf-slick-next icon-icons_chevron-right\"></div></div><slick class=pixerf-animation-carousel__slick id={{instance}} infinite={{vm.config.infinite}} slides-to-show={{vm.config.slidesToShow}} slides-to-scroll={{vm.config.slidesToScroll}} on-init=vm.config.event.init({slick}) responsive=vm.config.responsive dots={{vm.config.dots}} autoplay autoplay-speed={{vm.config.autoplaySpeed}} init-onload=true data=vm.datas next-arrow=\"#carousel-{{instance}} .pixerf-slick-nav.next-slide-nav\" prev-arrow=\"#carousel-{{instance}} .pixerf-slick-nav.prev-slide-nav\"><div ng-repeat=\"data in vm.datas | limitTo: limit\" class=pixerf-animation-carousel__slick__item ng-click=vm.onItemClicked()><div ng-transclude=itemTemplate class=pixerf-animation-carousel__slick__item-template></div></div></slick></div>");
$templateCache.put("app/components/pixerf-confirm-popup/pixerf-confirm-popup.html","<div class=pixerf-confirm-popup><div class=clearfix><div class=\"modal-header text-left\"><h3 ng-hide=vm.hideTitle class=\"modal--title text--bold text--color-black text-left\">PIXERF.com says:</h3></div><div class=\"modal-body text-left\"><div compile=\"vm.message | translate\"></div><p class=pixerf-confirm-popup__confirm-text ng-hide=vm.hideConfirmText>{{vm.confirmText ? vm.confirmText : (\'are-you-sure-you-want-to-continue\' | translate)}}</p></div><div class=modal-footer><button ng-hide=vm.hideCancelBtn ng-click=vm.cancel() type=button class=\"btn btn-cancel\">{{vm.cancelBtnText}}</button> <button ng-disabled=vm.isWorking ng-click=vm.ok() type=button class=\"btn btn-submit\">{{vm.okBtnText}}</button></div></div></div>");
$templateCache.put("app/components/pixerf-user-avatar/pixerf-user-avatar.html","<img class=pixerf-user-avatar ng-attr-alt={{userData.displayName}} ng-src=\"{{lazy ? \'assets/images/default/default-profile.png\' : userData.avatar.profileImage}}\" ng-attr-lazy-img-error=\'{{lazy ? \"assets/images/default/default-profile.png\" : null}}\' ng-attr-lazy-img=\"{{lazy ? userData.avatar.profileImage : null}}\" ng-class=\"!userData.account_type || userData.account_type === \'personal\' ? \'img-circle\' : \'\'\">");
$templateCache.put("app/components/popover-cart/popover-cart.html","<div class=popover-cart is-open=vm.isOpen uib-dropdown ng-attr-title=\"You have {{vm.cart.data.cart_items.length}} item(s) in your cart\" ng-hide=\"!vm.isAuthenticated() && (vm.cart.data.cart_items.length ==0)\"><a class=\"mobile-show popover-cart-popover-redirect\" ui-sref=checkout.shopping-cart ng-click=vm.onCloseBtnClicked()></a> <button uib-dropdown-toggle class=\"icon-icons_cart relative\" ng-disabled=vm.isDisablePopup()><span class=notification-item-cart-quantity ng-bind=vm.cart.data.cart_items.length></span></button><div class=\"dropdown-menu user-panel__dropdown-menu list-cart__dropdown-menu\" uib-dropdown-menu role=menu><cart on-cart-item-clicked=vm.onCartItemClicked(cartItem) on-cart-item-removed=vm.onCartItemRemoved()></cart><div class=list-cart__footer><div><span class=list-cart__footer__quantity ng-bind=vm.cart.data.cart_items.length></span> <span class=list-cart__footer__description><span class=text-lowercase>{{ (vm.cart.data.cart_items.length == 1) ? \'photo\' : \'photos\' }} </span>selected for purchase</span></div><div class=control-cart><div role=button class=\"control-cart__continue btn--transparent btn\" ng-click=vm.onContinueXerfingBtnClicked()>Continue Xerfing</div><!-- <div role=\"button\" class=\"control-cart__view btn btn-submit\" ng-click=\"vm.viewCartList()\">View Cart</div> --><div role=button class=\"control-cart__view btn btn-submit\" ng-click=vm.checkOut()>Check Out</div></div></div></div><span class=\"popover-cart__text-description mobile-show\">Cart</span></div>");
$templateCache.put("app/components/portfolio-photo/portfolio-photo.html","<div class=portfolio-photo ng-style=\"{\'background-image\': \'url(\\\'\' + vm.displaySize + \'\\\')\'}\"><a class=portfolio-photo__fancy-box ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{vm.displaySize}} rel=portfolioGallery></a><div class=\"photo__tools-wrapper clearfix\"><div class=photo__tools-wrapper__left><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=g pixerf-photo-state-btn-media=file title=\"Move to General\"></pixerf-photo-state-btn><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=h pixerf-photo-state-btn-media=file title=\"Move to Pending\"></pixerf-photo-state-btn><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=d pixerf-photo-state-btn-media=file title=\"Move to Discover\"></pixerf-photo-state-btn><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=t pixerf-photo-state-btn-media=file title=\"Move to Trending\"></pixerf-photo-state-btn></div><div class=photo__tools-wrapper__right><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--right\" pixerf-photo-state-btn-state=r pixerf-photo-state-btn-media=file ng-attr-title=\"{{file.state===\'r\' && file.reject_reason ? \'Reject Reason: \' + file.reject_reason : \'Reject this photo\'}}\"></pixerf-photo-state-btn></div></div></div>");
$templateCache.put("app/components/portfolio-tile/portfolio-tile.html","<div class=portfolio-tile><div class=portfolio-tile__item__photo ng-class=\"{\'no-footer\': options.hideAuthor}\"><div class=portfolio-tile__carousel active=0><div class=portfolio-tile__carousel__item ng-click=vm.onPhotoClicked(portfolio)><div class=portfolio-tile__carousel__photo-cover ng-if=portfolio.url ng-style=\"{\'background-image\': \'url(\\\'\' +  portfolio.url + \'\\\')\'}\"></div></div></div></div></div>");
$templateCache.put("app/components/scroll-paging/scroll-paging.html","<div class=scroll-paging ng-class=\"{\'scroll-paging--loading\': spinner.isVisible}\"><spinner-win ng-if=spinner.isVisible spinner=spinner></spinner-win><div ng-if=\"isLastPage && showMessage && !spinner.isVisible\" class=\"scroll-paging__last-page-message text-center\"><span>{{message}}</span> <a ng-show=!hideBackToTop class=\"text--color-pixerf-theme text--bold\" ng-click=vm.scrollToTop()>Back to top</a></div></div>");
$templateCache.put("app/components/scroll-to-top/scroll-to-top.html","<div class=scroll-to-top-btn title=\"Scroll to Top\"><span class=icon-arrow-up-2></span></div>");
$templateCache.put("app/components/spinner-win/spinner-win.html","<div class=spinner-win ng-show=spinner.isVisible ng-class=\"{\'spinner-win--isOverlay-mode absolute absolute--full\': isOverlayMode}\"><div class=bg_preloader><div class=\"preloader one\"></div><div class=\"preloader two\"></div><div class=\"preloader three\"></div></div></div>");
$templateCache.put("app/components/tile-photo/tile-photo.html","<div ng-click=vm.onPhotoClicked(file) class=tile-photo ng-class=\"{\'hide-caption\' : hideCaption}\" ng-attr-title=\"{{showLicense ? ( file.license != \'commercial\' && !(file.type === \'portfolio\' || file.type === 5) ? \'License Type: Editorial\' : !(file.type === \'portfolio\' || file.type === 5) ? \'License Type: Commercial\' : \'\') : \'\'}}\"><!-- <a class=\"overlay\" ng-attr-href=\"{{file.path}}\" ng-click=\"$event.preventDefault();\"></a>\r\n  <a class=\"overlay\" ng-if=\"vm.isPortfolioPhoto\" ng-click=\"$event.preventDefault();\"\r\n    ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, keys:{next: null, prev: null}, \'showNavArrows\': false, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\"\r\n    href=\'{{file.urlSmall}}\' rel=\"portfolioGallery\"></a> --> <img ng-src={{vm.imageUrl}}><!-- <div class=\"tile-photo__status\">\r\n    <div class=\"tile-photo__status__set-state__left\" ng-if=\"!vm.isPortfolioPhoto\">\r\n      <div class=\"tile-photo__view-count\">\r\n        <span class=\"icon-view-count\"></span>\r\n        <span class=\"tile-photo__view-count__text\">{{file.view_count}}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"tile-photo__info\">\r\n    <div class=\"tile-photo__info__author\" ng-show=\"!file.isMine || context === \'MARKET_PLACE\'\">\r\n      <a ng-click=\"$event.stopPropagation()\"\r\n        ui-sref=\"user-home-page.personal.home({id: file.user.id, userName: (file.user.displayName)})\"\r\n        target=\"_blank\">\r\n        <div class=\"tile-photo__info__author__avatar\">\r\n          <pixerf-user-avatar user-data=\"file.user\" lazy=\"true\"></pixerf-user-avatar>\r\n        </div>\r\n        <div class=\"tile-photo__info__author__name text--truncate\">{{file.user.displayName}}\r\n        </div>\r\n      </a>\r\n    </div>\r\n    <div class=\"tile-photo__info__title text--truncate\"\r\n      ng-show=\"file.isMine && context !== \'MARKET_PLACE\' && !vm.isPortfolioPhoto\">\r\n      {{file.title}}\r\n    </div>\r\n  </div> --></div>");
$templateCache.put("app/components/upload-photo-detail/upload-photo-detail.html","<div class=\"upload-photo-detail text-left\"><div class=upload-photo-detail__header><h4 class=\"text--bold text--color-black\">{{\'edit-photo\' | translate}}</h4><div ng-show=vm.masterFile.data.id><call-to-action-messages messages=vm.callToActionMesages></call-to-action-messages></div><div class=upload-photo-detail__header__help><div class=\"text--bold text--color-pixerf-theme upload-photo-detail__header__help__title\">{{\'upload-maximise-licensed\' | translate}}</div><div class=upload-photo-detail__header__help__description>{{\'upload-maximise-licensed-body\' | translate}}</div></div></div><ng-form class=upload-photo-detail__body name=uploadform ng-class=\"{\'pixerf-form-dirty\': isFormDirty}\"><div class=\"form-group upload-photo-detail__category-selection\"><label class=text--bold for=\"\">{{\'category\' | translate}}<span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=true tooltip-class=upload-photo-detail__tooltips tooltip-placement=auto uib-tooltip=\"{{\'tool-tip-categories\' | translate}}\"></span></label><div is-disabled=!vm.masterFile.data class=multiple-dropdown-selection ng-dropdown-multiselect=\"\" events=\"{onItemSelect: vm.categoryDropdownSettings.events.onSelectionChanged, onItemDeselect: vm.categoryDropdownSettings.events.onSelectionChanged, onMaxSelectionReached: vm.categoryDropdownSettings.events.onMaxSelectionReached}\" translation-texts=\"{buttonDefaultText: (\'choose-up-to-categories\' | translate: {number: 3})}\" options=categories.data selected-model=vm.masterFile.data.categories extra-settings=vm.categoryDropdownSettings ng-class=\"{\'upload-photo-detail__placeholder-text-categories ng-invalid\': !files[0].categories || files[0].categories.length < 1}\"></div></div><div class=form-group><label class=text--bold for=\"\">{{\'keywords\' | translate}} <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=true tooltip-class=upload-photo-detail__tooltips tooltip-placement=auto uib-tooltip=\"{{\'tool-tip-keywords\' | translate}}\"></span></label><div class=relative><tags-input tag-class=vm.getTagClass($tag) min-length=2 template=pixerf-keyword-template display-property=text replace-spaces-with-dashes=false on-invalid-tag=\"vm.onInvalidTag($tag, scope)\" on-tag-added=vm.onTagAdded($tag) ng-disabled=\"files.length === 0\" ng-model=vm.masterFile.data.tags placeholder=\"{{\'add-keywords\' | translate}}\" class=upload-photo-detail__keywords on-tag-removed=vm.onTagRemoved($tag)><auto-complete select-first-match=false source=vm.loadTags($query)></auto-complete><pixerf-placeholder text=\"{{isLoadingClarifai ? \'We are generating keywords for you....\' : \'Adding at least 10 keywords will make it easier for others to search for your photo.\'}}\" is-visible=\"vm.masterFile.data.tags.length === 0\"></pixerf-placeholder><div ng-show=isLoadingClarifai ng-click=$event.stopPropagation() class=\"upload-photo-detail__keywords__loading-indicator absolute absolute--full\"><div class=\"absolute absolute--bottom-half\"><pixerf-loading-indicator></pixerf-loading-indicator></div></div></tags-input></div></div><div class=form-group ng-show=\"vm.masterFile.data.suggestedKeywords.length > 0\"><label class=text--bold for=\"\">{{\'suggested-keywords\' | translate}}</label><div><span class=tag-item ng-repeat=\"suggestedKeyword in vm.masterFile.data.suggestedKeywords\" ng-click=\"vm.addTag(vm.masterFile.data.tags, suggestedKeyword)\"><span class=tag-template><span><span class=text--semibold>{{suggestedKeyword}}</span></span></span></span></div></div><div class=\"form-group upload-photo-detail__title\"><label class=text--bold for=\"\">{{\'title\' | translate}} <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=true tooltip-class=upload-photo-detail__tooltips tooltip-placement=auto uib-tooltip=\"{{\'tool-tip-title\' | translate}}\"></span></label><input required maxlength=50 ng-disabled=\"files.length === 0\" type=text class=form-control validation-no-file-extension placeholder=\"{{\'give-photo-name\' | translate}}\" ng-model=vm.masterFile.data.title ng-change=\"vm.synchonizedFilesInfo(files, \'title\', vm.masterFile.data.title)\"></div><div class=\"form-group upload-photo-detail__description\"><label class=text--bold for=\"\">{{\'description\' | translate}} <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=true tooltip-class=upload-photo-detail__tooltips tooltip-placement=auto uib-tooltip=\"{{\'tool-tip-description\' | translate}}\"></span></label><textarea name=description maxlength=255 validation-no-hyperlink ng-disabled=\"files.length === 0\" rows=3 type=text class=form-control placeholder=\"{{\'say-something-about-your-photo\' | translate}}\" ng-model=vm.masterFile.data.description ng-change=\"vm.synchonizedFilesInfo(files, \'description\', vm.masterFile.data.description)\"></textarea><div class=text-right><span class=textarea__length_descriptioon>{{vm.masterFile.data.description ? vm.masterFile.data.description.length : 0}}/255</span></div></div><div class=\"form-group upload-photo-detail__licensing\"><label class=text--bold for=\"\">{{\'usage\' | translate}}</label><photo-license-info photo=vm.masterFile.data></photo-license-info><div class=\"upload-photo-detail__release-form-confirm clearfix\" ng-if=\"vm.masterFile.data.state === \'h\' || !vm.masterFile.data.state || vm.loginUser.canCurate\"><photo-license-deternimation-questions class=upload-photo-detail__release-form-confirm__questions is-required=true media=vm.masterFile.data on-question-answered=vm.onQuestionAnswered(question)></photo-license-deternimation-questions><get-release-form-btn ng-if=\"vm.masterFile.data.has_model_property && vm.masterFile.data.license === \'commercial\'\" class=\"btn btn--blue\"></get-release-form-btn></div></div><photo-release-form-selection alert=alert on-selection-changed=\"vm.synchonizedFilesInfo(files, \'releases\', vm.masterFile.data.releases)\" file=vm.masterFile.data ng-if=\"vm.masterFile.data.has_model_property && vm.masterFile.data.license === \'commercial\'\" class=form-group></photo-release-form-selection><div class=\"form-group upload-photo-detail__photo-price-wrapper clearfix\" ng-if=\"((vm.masterFile.data.user && vm.masterFile.data.user.isVIP) || (!vm.masterFile.data.user && vm.loginUser.isVIP)) && vm.masterFile.data.price_ranges\"><label ng-class=\"{\'pixerf-invalid\': !vm.masterFile.data.price.id}\" class=text--bold for=\"\">Select Photo Price <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=true tooltip-class=upload-photo-detail__tooltips tooltip-placement=auto uib-tooltip=\"Price your photo based on the Large size – our system will auto-generate other sizes and scale the prices accordingly. 20% for Small, 60% for Medium, 150% for X-Large and 200% for XX-Large.\"></span></label><photo-price-selection class=\"upload-photo-detail__photo-price clearfix\" is-disabled=\"files.length === 0\" settings=\"{options: vm.masterFile.data.price_ranges, isShownSubscribeText: vm.masterFile.data.user && !vm.masterFile.data.user.isNoNeedSubscribe}\" selected-model=vm.masterFile.data.price on-selection-changed=\"vm.synchonizePrice(files, vm.masterFile.data.price)\"></photo-price-selection></div><div ng-if=vm.masterFile.data.price><photo-price-size-selection photo=vm.masterFile.data is-readonly=true user=\"(vm.masterFile.data.user || vm.loginUser)\"></photo-price-size-selection></div><div class=\"form-group upload-photo-detail__btns-wrapper\"><div class=form-group><div class=upload-photo-detail__add-location><span class=icon-icons-location></span> <input maxlength=255 ng-disabled=\"files.length === 0\" ng-change=\"vm.synchonizedFilesInfo(files, \'location\', vm.masterFile.data.location)\" g-places-autocomplete force-selection=true ng-model=vm.masterFile.data.location placeholder=\"Enter location\" class=\"upload-photo-detail__add-location__input text--color-black form-control\"></div></div><div class=\"form-group upload-photo-detail__btn-add-to-gallery-wrapper\"><add-to-gallery is-last-page=vm.isLastPage load-more-galleries=vm.loadMoreGalleries() spinner=vm.spinner class=add-to-gallery file=vm.masterFile.data on-gallery-item-clicked=\"vm.onGallerySelected(gallery); vm.synchonizedFilesInfo(files, \'galleries\', vm.masterFile.data.galleries)\" is-disabled=!vm.masterFile.data add-when-gallery-created=true><button popover-append-to-body=true popover-class=add-to-gallery popover-is-open=vm.isOpen.data popover-trigger=\"\'outsideClick\'\" uib-popover-template=\"\'app/components/add-to-gallery/add-to-gallery-popover-tmpl.html\'\" popover-placement=\"auto left\" ng-disabled=!file type=button class=\"upload-photo-detail__btn upload-photo-detail__btn-add-to-gallery btn btn--white add-to-gallery-btn\"><span class=icon-icons-add-to-gallery></span> <span class=text--truncate ng-class=\"{\'text--color-black\': file.galleriesName !== \'Choose Gallery\'}\">{{file.galleriesName}}</span></button></add-to-gallery></div></div></ng-form><script type=text/ng-template id=pixerf-keyword-template><div class=\"tag-template\">\r\n        <div>\r\n          <span class=\"text--semibold\">{{$getDisplayText()}}</span>\r\n          <a class=\"remove-button icon-icons_close\" ng-click=\"$removeTag()\"></a>\r\n        </div>\r\n      </div></script><script type=text/ng-template id=pixerf-set-price-tooltip-template><div class=\"tag-template\">\r\n            Level up and unlock different price points. <a href=\"\" target=\"_blank\" class=\'pixerf-link--color-theme\' pixerf-close-on-click=\"true\">Learn more about Levelling.</a>\r\n      </div></script><script type=text/ng-template id=pixerf-upload-photo-release-template><div class=\"tag-template\">\r\n            Models and private property owners need to give you permission to use them in commercial photos.<a ui-sref=\"introduction-support.faq.personal({section: \'licensing\'})\" target=\"_blank\" class=\'text--color-pixerf-theme text--bold\' pixerf-close-on-click=\"true\"> Learn more.</a>\r\n      </div></script></div>");
$templateCache.put("app/components/photo-detail/segments/photo-detail-keyword-similar.html","<div><div class=photo-detail__main-content__keywords ng-if=\"!isEditMode.data && !photo.isMissionWinnerSelectionMode\"><div class=photo-detail__main-content__keywords__header data-toggle=collapse data-target=#photo-details-keywords aria-expanded=true><h5 class=photo-detail__main-content__keywords__title>Keywords</h5><span class=\"photo-detail__main-content__keywords__collapse-icon icon-icons_plus\"></span> <span class=\"photo-detail__main-content__keywords__collapse-icon icon-icons_minus\"></span></div><h5 class=photo-detail__main-content__keywords__title>Keywords</h5><div class=\"collapse in\" id=photo-details-keywords><div ng-repeat=\"tag in photo.tags\" class=\"tag-item tag-item--readonly\" ng-click=vm.onTagClicked(tag)>{{tag.text}}</div></div></div><hr ng-if=isMobile class=photo-detail__mobile-devider><div class=photo-detail__main-content__similar-photos ng-if=\"!isEditMode.data && !photo.isMissionWinnerSelectionMode\"><h5 class=photo-detail__main-content__similar-photos__title>Similar photos</h5><div class=\"photos-grid-wrapper clearfix relative\" ng-class=\"{\'curator-interface\': vm.loginnedUser.canCurate}\"><photo-grid hide-no-more-message=true ideal-height=\"isMobile ? 150 : 200\" context=context on-init=vm.onPhotoGridInit(photoGrid) container=\".photo-detail__main-content__similar-photos .photos-grid-wrapper\"><div class=text-center><span class=icon-icons-gallery></span><h5 class=\"text-semibold no-message-notice\">Sorry, we cannot find any similar photos</h5></div></photo-grid></div></div></div>");
$templateCache.put("app/components/photo-detail/segments/photo-detail-tools-wrapper.html","<div class=photo-detail__tools-wrapper><like-btn media=photo class=photo-detail__tools-wrapper__like-btn></like-btn><div class=photo-detail__view-count><span class=icon-view-count></span> <span class=photo-detail__view-count__value>{{photo.view_count === 1 ? (photo.view_count + \' view\') : (photo.view_count + \' views\')}}</span></div><div ng-if=\"vm.loginnedUser && vm.loginnedUser.canDownloadComp\" title=\"{{\'download-comp\' | translate}}\" class=\"photo-detail__tools-wrapper__icon-download icon-icons_download\" ng-click=vm.onDownloadComp(photo)></div></div>");
$templateCache.put("app/components/photo-detail/segments/photo-detail-user-photo-brief.html","<div class=photo-detail__photo-info__top-info><div ng-if=isMobile><ng-include src=\"\'app/components/photo-detail/segments/photo-detail-tools-wrapper.html\'\"></ng-include></div><div class=clearfix><a class=\"photo-detail__photo-info__author pull-left\" popup-link-clicked=\"{{\'/user-home-page/\' + photo.user.id +\'/\'+ (photo.user.displayName| toSnakeCase)}}\"><pixerf-user-avatar class=\"profile-image pull-left\" user-data=photo.user lazy=true></pixerf-user-avatar><h2 class=\"photo-detail__photo-info__author__username text--truncate pull-left text--bold text--color-white\">{{photo.user.displayName}}</h2></a><follow-btn ng-attr-title=\"{{photo.user.is_followed ? (\'unfollow-this-person\' | translate) : (\'follow-this-person\' | translate)}}\" user=photo.user ng-if=!photo.user.isMine is-icon-mode=true></follow-btn></div><div itemscope itemtype=http://schema.org/Product><h1 itemprop=name ng-attr-title={{photo.title}} class=\"text--semibold text--color-white photo-detail__photo-info__title\">{{photo.title}}</h1><h2 class=photo-detail__photo-info__description itemprop=description>{{photo.description}}</h2></div><!-- <div ng-if=\"!isMobile\">\r\n		<ng-include src=\"\'app/components/photo-detail/segments/photo-detail-tools-wrapper.html\'\"></ng-include>\r\n	</div> --></div>");}]);